/* je-visual-brief-content-20260906
   Source-derived card data only. The renderer owns presentation and diagrams. */
(function(global){
  "use strict";
  function plain(value){
    return String(value == null ? "" : value)
      .replace(/<[^>]*>/g, "").replace(/&Prime;/gi, "″").replace(/&quot;/gi, '"')
      .replace(/&amp;/gi, "&").replace(/&#39;/g, "'").replace(/\|/g, " ")
      .replace(/\s+/g, " ").trim();
  }
  function words(value){ return plain(value).split(/\s+/).filter(Boolean); }
  function sentenceList(value){
    var source = plain(value), result = [], start = 0;
    for(var i=0;i<source.length;i++){
      if(/[.!?]/.test(source.charAt(i)) && (i === source.length-1 || /\s/.test(source.charAt(i+1)))){
        result.push(source.slice(start,i+1)); start = i+1;
      }
    }
    if(source.slice(start).trim()) result.push(source.slice(start));
    return result;
  }
  function cardTitle(c){
    var title = plain(c.headline || "");
    // Tour headings are authored per product. Keep only whole, concise headings;
    // an overlong one falls back to its source section name rather than truncating a claim.
    if(title && !unsafeFact(title, "") && words(title).length <= 9 && title.length <= 65) return title;
    return plain(c.kicker || "Product details");
  }
  function conciseTitle(value, fallback){
    var title = plain(value);
    return title && words(title).length <= 9 && title.length <= 65 ? title : fallback;
  }
  function caption(c, title){
    var titleWords = words(title.toLowerCase()).filter(function(w){ return w.length > 3; });
    var choices = sentenceList(c.lede).map(function(s){ return plain(s); }).filter(function(s){
      var count = words(s).length;
      if(!s || unsafeFact(s, "") || count < 5 || count > 19 || s.length > 140) return false;
      var low = s.toLowerCase();
      return !titleWords.length || titleWords.some(function(w){ return low.indexOf(w) < 0; });
    });
    return choices[0] || "";
  }
  function unsafeFact(value, label){
    // The tour source is not an energy-label dataset. Do not turn an uncorroborated
    // annual-use sentence into a prominent card claim.
    var text=plain(value)+" "+plain(label);
    return /(?:energy|electricity|kwh|kilowatt[- ]hours?)/i.test(text) && /\b(?:annual|year|annum)\b/i.test(text);
  }
  function facts(rows){
    var result = [], seen = {};
    (rows || []).some(function(row){
      if(!Array.isArray(row)) return false;
      var value = plain(row[0]), label = plain(row[1]);
      if(!value || unsafeFact(value, label)) return false;
      // Do not crop a term or a qualifier to make it fit; keep it in detail instead.
      if(value.length > 36 || label.length > 48) return false;
      var key = value.toLowerCase()+"|"+label.toLowerCase();
      if(seen[key]) return false;
      var valueKey=value.toLowerCase().replace(/\s/g,''),labelKey=label.toLowerCase().replace(/[^a-z0-9]+/g,' ').trim();
      if(result.some(function(r){var previous=r[1].toLowerCase().replace(/[^a-z0-9]+/g,' ').trim();return r[0].toLowerCase().replace(/\s/g,'')===valueKey && labelKey && previous && ((' '+previous+' ').includes(' '+labelKey+' ') || (' '+labelKey+' ').includes(' '+previous+' '));})) return false;
      seen[key] = true;
      result.push([value, label]);
      return result.length === 3;
    });
    return result;
  }
  function counterFact(c){
    var counter = c.counter || {};
    if(counter.target === undefined || counter.target === null || counter.target === "") return null;
    var number = typeof counter.target === "number" ? counter.target.toLocaleString("en-GB") : plain(counter.target);
    var value = number + plain(counter.suffix || "");
    var label = plain(counter.label || c.kicker || "feature");
    if(/^(?:rpm|hrs?)$/i.test(plain(counter.suffix)) || plain(counter.suffix)==='m²'){
      label=label.replace(/^(?:rpm|hours?|square metres?)\s+(?:of\s+)?/i,'');
    }
    var qualifier = counterQualifier(c);
    if(qualifier) value = qualifier + " " + value;
    return value && !unsafeFact(value, label) ? [value, label] : null;
  }
  function counterQualifier(c){
    var n=Number((c.counter || {}).target), suffix=plain((c.counter || {}).suffix).toLowerCase();
    if(!isFinite(n)) return '';
    function re(s){return String(s).replace(/[.*+?^${}()|[\]\\]/g,"\\$&");}
    var aliases=[re(n),re(n.toLocaleString('en-GB'))];
    var names=['zero','one','two','three','four','five','six','seven','eight','nine','ten','eleven','twelve','thirteen','fourteen','fifteen','sixteen','seventeen','eighteen','nineteen'];
    if(n>=0 && n<20 && n%1===0) aliases.push(names[n]);
    if(n>=20 && n<100 && n%1===0){var tens=['','','twenty','thirty','forty','fifty','sixty','seventy','eighty','ninety'];aliases.push(tens[Math.floor(n/10)]+(n%10?'[ -]'+names[n%10]:''));}
    var units={'%':'(?:%|per\\s*cent)','min':'min(?:ute)?s?','mins':'min(?:ute)?s?','hr':'h(?:ou)?rs?','hrs':'h(?:ou)?rs?','s':'s(?:ec(?:ond)?s?)?','m':'(?:m|metres?)','m²':'(?:m²|square metres?)','kg':'(?:kg|kilograms?)','l':'(?:l|litres?)','rpm':'rpm'};
    var unit=units[suffix] || re(suffix);
    var found=new RegExp('\\b(up\\s+to|more\\s+than|less\\s+than|at\\s+least|at\\s+most|over|under|around|about|approximately)\\s+(?:'+aliases.join('|')+')(?![\\d.])\\s*'+unit+'(?![\\w²³])','i').exec(plain(c.lede)+' '+plain(c.headline));
    if(!found) return '';
    var qualifier=found[1].toLowerCase().replace(/\s+/g,' ');
    return qualifier.charAt(0).toUpperCase()+qualifier.slice(1);
  }
  function detailFor(c){
    var values = [];
    if(c.lede && !unsafeFact(c.lede, "")) values.push(plain(c.lede));
    (c.stats || []).forEach(function(row){
      if(Array.isArray(row) && plain(row[0]) && !unsafeFact(row[0],row[1])) values.push(plain(row[0]) + (plain(row[1]) ? " — " + plain(row[1]) : ""));
    });
    if(c.counter){ var fact = counterFact(c); if(fact) values.push(fact[0]+" — "+fact[1]); }
    return values.filter(function(v,i,a){ return a.indexOf(v) === i; }).join(" ");
  }
  /* je-glance-diagrams-20260916: the card's graphic is chosen from what the section
     SAYS, most specific rule first, and an authored `visual` on the chapter wins
     outright. Nothing falls through to a symbol: an unmatched card shows the product.
     Every word test is anchored (\b) where a longer word could carry it - "Wiring" once
     matched /rings?/, "laundry" matched /dry\b/, "Lightweight" matched /light/. */
  var KINDS = ("fit design capacity programmes sensor battery cable filtration wash hob blend temperature controls " +
    "tools clean stains hygiene interior door dispenser backlight apps portable quiet brushroll airflow heat steam " +
    "power drying wetclean reach bin zones rgb screen processor sound energy shield timer connected drum brew cooling").split(" ");
  function kindFor(c, p){
    p = p || {};
    var d = p.dna || {}, device = ((d.device || {}).kind || "").toLowerCase();
    var pin = plain(c.visual).toLowerCase();
    if(pin && KINDS.indexOf(pin) >= 0) return pin;
    var kicker = plain(c.kicker).toLowerCase();
    var intent = [c.kicker,c.headline].map(plain).join(" ").toLowerCase();
    var evidence = [c.lede].concat(c.chips || []).map(plain).join(" ").toLowerCase();
    var title = plain(p.title || "").toLowerCase();
    var vac = /vacuum|stickvac|carpet/.test(device) || /vacuum|carpet (?:cleaner|washer)|floor cleaner|spot cleaner|wet (?:and|&) dry|steam mop|spot ?wash|spot ?clean/.test(title);
    var laundry = /^(?:washer|dryer)$/.test(device), cold = /fridge|freezer/.test(device), coffee = /coffee/.test(device);
    var cooking = /cooker|oven|hob|microwave|airfryer/.test(device), tv = device === "tv";
    var audio = /soundbar|speaker|radio|audio/.test(device) || /\bcd\b|vinyl|turntable|hi-?fi|speaker|radio|headphone|earbud|sound ?bar/.test(title);
    var airmover = /^(?:fan|heater)$/.test(device) || /\bfan\b|purifier|hair ?dryer|air ?dryer/.test(title);
    var handheld = /vacuum|stickvac|kettle|generic|speaker|radio|fan|airfryer|coffee|heater|microwave/.test(device);
    var blender = /blender|smoothie|nutri|food processor|mixer/.test(title);
    var wireless = /wi-?fi|bluetooth|wireless|\bapp\b/.test(intent + " " + evidence);
    // 1. The section name carries the authored intent. Test the specific before the general.
    if(audio && /voice|dialogue|bass|atmos|channels?|symphony|stereo|clarity|gaming|game mode|tv pairing|sound|speakers?|equaliser|radio bands|headphones|\bspeeds?\b|playback|sources|presets/.test(intent)) return "sound";
    if(/noise|quiet|decibel|\bdb\b/.test(kicker)) return "quiet";
    if(/power cut|power outage/.test(kicker)) return "timer";
    if(/oscillat|swing/.test(kicker)) return "design";
    if(/touch/.test(kicker)) return "controls";
    if(/app control|connected care|\bconnect/.test(kicker)) return wireless ? "connected" : "controls";
    if(/processor|upscal|\bai\b|nq4|vision ai|viewing tools|intelligen/.test(kicker)) return "processor";
    if(/cover fabric|\bmaterials?\b/.test(kicker)) return "design";
    if(coffee && /filter|basket|grind|bean|milk|froth|pods?|brew|nozzle|wand|cup/.test(kicker)) return "brew";
    if(blender && /\bspeeds?\b|\bmotor\b|\bpower\b|blade|cups?|what it makes|everyday|uses|tasks/.test(kicker)) return "blend";
    if(/suction|cyclone|air ?watts/.test(kicker)) return "airflow";
    if(airmover && /airflow|air ?flow|\bspeeds?\b|\bfan\b|settings|oscillat/.test(kicker)) return "airflow";
    if(/dishwasher/.test(device) && /spray|rinse|\bwash\b/.test(kicker) && !/quick|\bfast\b/.test(kicker)) return "wash";
    if(/\bcable\b|\bcord\b|\bhose\b|radius/.test(kicker)) return "cable";
    if(/\btools?\b|attachment|accessor|in the box|included|\bkit\b/.test(kicker)) return "tools";
    if(vac && /hair|brush|\bpets?\b|floor (?:types|cleaning|sensing)|surfaces|self-?clean|carpet|nozzle/.test(kicker)) return "brushroll";
    if(vac && /spot|deep clean|tanks?|\bwet\b|spray|pads|mixing|water|extract|solution|\bmop\b|\bdry(?:ing)?\b/.test(kicker)) return "wetclean";
    if(vac && /steer|trackdrive|bend|flexolog|low spaces|slide tube|under|effort|manoeuv|handling|reach/.test(kicker)) return "reach";
    if(vac && /empty|self-?seal|collar|\bbag\b|\bbin\b/.test(kicker)) return "bin";
    if(vac && /airflow|\bmotor\b|cleaning power|power levels|wattage|\bpower\b/.test(kicker)) return "airflow";
    if(/battery|runtime|run ?time|cordless|\bcharg(?:e|ing)\b/.test(kicker)) return "battery";
    if(/filtrat|\bfilters?\b|hepa|purif/.test(kicker) || (airmover && /humid/.test(kicker)) || (vac && /allerg/.test(kicker))) return "filtration";
    if(/allerg|hygien|anti-?bacteria|germ|sanitis/.test(kicker)) return "hygiene";
    if(/creases?|ironing|drying|wash & dry|wash and dry|two-in-one|2-in-1|condenser|venting|heat pump|\bdry\b/.test(kicker) && !cold) return "drying";
    if(/\bstains?\b|stain removal|\bmarks\b|colour care/.test(kicker) || (laundry && /fabric|\bcare\b|wool|delicate/.test(kicker))) return "stains";
    if(tv && /refresh|mini[ -]?led|oled|qled|panel|gaming|game|pixels?|\b4k\b|full hd|uhd|resolution|inch|large format|hva|advanced image|motion|picture/.test(kicker)) return "screen";
    if(tv && /colour|color|spectrum|quantum|triluminos|crystal|rgb/.test(kicker)) return "rgb";
    if(tv && /direct led|backlight|backlighting|advanced led|contrast|bright|daylight|glare|cinema|dimming/.test(kicker)) return "backlight";
    if(/google tv|webos|tizen|roku|tivo|\bstreams?\b|streaming|catch-?up|channels|\bapps?\b|\brecord(?:ing)?\b|freeview|freely/.test(kicker) && !cooking) return "apps";
    if(tv && /\bsmart\b/.test(kicker) && /webos|google tv|tizen|roku|\bapps?\b/.test(intent)) return "apps";
    if((tv || audio) && /sources|presets|playback/.test(kicker)) return "apps";
    if(cooking && /defrost|power levels/.test(kicker)) return "heat";
    if(device === "hob" && /zones?|burners?|\brings?\b/.test(kicker)) return "hob";
    if(cooking && /two ovens|two drawers|dual zone|two containers|double|zones|cavities|two baskets/.test(kicker)) return "zones";
    if(cooking && /self-?clean|cleaning|pyrolytic|catalytic|hydrolytic|ceramic|wipe|lid & cleaning/.test(kicker)) return "clean";
    if(/self-?clean|auto-?clean|drum clean|descal|cleaning/.test(kicker) && !vac) return "clean";
    if(/dispenser|water & ice|ice maker|water and ice/.test(kicker)) return "dispenser";
    if(/interior|inside|drawers?|shelves|shelf|\brack\b|basket|crisper|loading|layout|compartment/.test(kicker)) return "interior";
    if(/display/.test(kicker)) return "controls";
    if(/\bdoor\b|\blid\b|\blights?\b|headlights?|lighting|status/.test(kicker) && !tv) return "door";
    if(/portab|handheld|on the move|folding handle|carry|handling|lightweight|\bweight\b/.test(kicker) && handheld) return "portable";
    if(/capacity|storage|\bload\b|water gauge|litres?/.test(kicker) || (cold && /split/.test(kicker))) return "capacity";
    if(cold && /\bzones?\b|convert|garage|cold room|freshness|fresh|salad|humid/.test(kicker)) return "cooling";
    if(laundry && /pet hair|spin|drum|bubble|motor/.test(kicker)) return "drum";
    if(/energy|efficien|\bsaving\b|\beco\b/.test(kicker) || (/\bratings?\b/.test(kicker) && !cooking && !/\bpot\b|star/.test(kicker))) return "energy";
    if(/programmes?|cycles?|modes?|functions|presets/.test(kicker)) return "programmes";
    if(/sensor|sensing|moisture|intellitemp|automatic/.test(kicker)) return "sensor";
    if(/temperature|degrees?|keeps warm|hold temp|warming/.test(kicker)) return "temperature";
    if(/wiring|amps?\b|wattage|watts|\bmotor\b|\bpower\b|voltage/.test(kicker)) return blender ? "blend" : "power";
    if(/no frost|frost|cool|chill|freez|cold/.test(kicker)) return "cooling";
    if(/sound|speaker|audio|stereo|equaliser|bass|atmos|acoustic/.test(kicker)) return "sound";
    if(/quick|timer|\bfast\b|minutes/.test(kicker) || (/speed/.test(kicker) && (laundry || /dishwasher|kettle|microwave/.test(device)))) return "timer";
    if(/\bfit\b|fitting|dimension|footprint|placement|slim|compact|\bsize\b|width|height|depth|worktop|counter|\bupright\b|\bweight\b/.test(kicker)) return "fit";
    if(/hob|burners?|cooking zones?|wok|induction|\bgas\b/.test(kicker)) return "hob";
    if(/grill|even heat|\bheat\b|oven|cook|browning|less oil|crisp|air ?fry|toast|roast|bake/.test(kicker)) return "heat";
    if(/steam/.test(kicker)) return "steam";
    if(/dishwasher/.test(device) && /wash|water|spray|rinse/.test(kicker)) return "wash";
    if(/blend|chop|food process|\bbowl\b|\bjug\b|blade/.test(kicker)) return "blend";
    if(/milk|froth|grind|bean|pods?|brew|nozzle|barista|espresso|dual function|serving|frozen drinks|soft serve|swirl/.test(kicker)) return coffee || /coffee|espresso/.test(intent) ? "brew" : "blend";
    if(/connect|smart|wi-?fi|bluetooth|wireless|pairing|remote/.test(kicker)) return wireless ? "connected" : "controls";
    if(/\bcontrols?\b|dial|buttons|settings|setup/.test(kicker)) return "controls";
    if(/durab|weatherproof|safety|protect|\block\b|guarantee|warranty|child/.test(kicker)) return "shield";
    if(/integrated|design|finish|colour|color|body|shape|stack|slim depth|depth & ports|styling/.test(kicker)) return /steam|ironing/.test(intent) ? "steam" : "design";
    // 2. A poetic section name says nothing; read the headline for the claim.
    function classify(text){
      if(/\brgb\b/.test(text)) return "rgb";
      if(/processor|upscal|ai picture|cognitive xr|\bxr\b/.test(text)) return "processor";
      if(/sound|speaker|audio|subwoofer|dolby atmos/.test(text)) return "sound";
      if(/noise level|decibel|quiet/.test(text)) return "quiet";
      if(/backlight|dimming zones/.test(text)) return tv ? "backlight" : "";
      if(/picture|screen|resolution|refresh|gaming|oled|qled|hdr|pixels/.test(text)) return tv ? "screen" : "controls";
      if(/\bapps\b|streaming|netflix|catch-?up|channels/.test(text)) return "apps";
      if(/battery|runtime|cordless|\bcharg(?:e|ing)\b/.test(text)) return "battery";
      if(/quick|timer|time remaining|power cut|minutes flat/.test(text)) return "timer";
      if(/steam/.test(text)) return "steam";
      if(/frost|cool|fresh|chill|freez|cold/.test(text)) return "cooling";
      if(/hob|burners?|cooking zones?|induction/.test(text)) return "hob";
      if(/self-?clean|pyrolytic|catalytic|hydrolytic|wipes clean|cleans itself/.test(text)) return vac ? "brushroll" : "clean";
      if(/\bstains?\b|pre-?treat/.test(text)) return "stains";
      if(/allergen|hygien/.test(text)) return "hygiene";
      if(/shelves|shelf|drawers?|\bbins\b|\brack\b|basket/.test(text)) return "interior";
      if(/\bdoor\b|\blid\b|lights? up|light inside|interior light/.test(text)) return "door";
      if(/dispenser|water and ice|water & ice/.test(text)) return "dispenser";
      if(/\btools?\b|attachments?/.test(text)) return "tools";
      if(/hair|brush ?roll|brushroll|\bpet\b/.test(text)) return vac ? "brushroll" : "";
      if(/suction|cyclone|airflow|air watts/.test(text)) return "airflow";
      if(/wet and dry|spray|\bmop\b|two tanks|dirty water/.test(text)) return vac ? "wetclean" : "wash";
      if(/bends?|under the sofa|low furniture|steer|turns? where/.test(text)) return vac ? "reach" : "";
      if(/empt(?:y|ies)|self-?seal|dust cup|\bbag\b/.test(text)) return vac ? "bin" : "";
      if(/lift|carry|carried|portable|lightweight|kilos|\bkg\b/.test(text)) return laundry ? "capacity" : handheld ? "portable" : "fit";
      if(/\bdry\b|drying|dries|creases/.test(text)) return vac ? "wetclean" : "drying";
      if(/cook|oven|grill|heat|crisp|roast|bake|toast/.test(text)) return "heat";
      if(/capacity|storage|\bload\b|litres?|liters?/.test(text)) return "capacity";
      if(/programmes?|cycles?|modes?/.test(text)) return "programmes";
      if(/sensor|moisture|automatic water level|auto adjust|senses/.test(text)) return "sensor";
      if(/\b(?:cord|cable|reach)\b/.test(text)) return "cable";
      if(/\bfilters?\b|allergen|particles?/.test(text)) return "filtration";
      if(/temperature|degrees?|°c|preset temperatures?/.test(text)) return "temperature";
      if(/blend|chop|food process/.test(text)) return "blend";
      if(/watts?\b|amps?\b|wattage|\bmotor\b/.test(text)) return "power";
      if(/\bfit\b|dimension|footprint|placement|compact|slim|counter|worktop/.test(text)) return "fit";
      if(/energy|efficien/.test(text)) return "energy";
      if(/guarantee|warranty|protect|lock|safety/.test(text)) return "shield";
      if(/connect|smart|google tv|wi-?fi|bluetooth|wireless|\bapp\b/.test(text)) return wireless ? "connected" : "controls";
      return "";
    }
    var resolved = classify(intent);
    if(!resolved && /clean/.test(intent) && /steam/.test(evidence)) resolved = "steam";
    if(resolved) return resolved;
    // 3. Nothing matched: the product itself, never a symbol.
    if(coffee) return "brew";
    return "design";
  }
  function chapter(c, p, index){
    var title = cardTitle(c), rows = [];
    var counter = counterFact(c);
    if(counter){
      rows.push(counter);
      if(counterQualifier(c)) title=conciseTitle(counter.join(' '),plain(c.kicker || 'Feature'));
    }
    rows = rows.concat(c.stats || []);
    if(!facts(rows).length && c.chips){ rows = c.chips.map(function(chip){ return [chip, ""]; }); }
    return {
      label: plain(c.kicker || "Feature"), title: title, line: caption(c, title),
      facts: facts(rows), kind: kindFor(c,p), href: "#ch"+index,
      detail: detailFor(c), detailTitle: plain(c.headline || c.kicker || "Feature details"),
      chips: (c.chips || []).map(plain).filter(Boolean), device: (((p.dna || {}).device || {}).kind || ""),
      source: "Product section " + (index+1)
    };
  }
  function isFiniteDimension(value){ return typeof value === "number" && isFinite(value) && value > 0; }
  function energyCard(p, closer){
    var rating = plain(p.energy);
    if(!closer.energy || !/^(?:[A-G](?:\+{1,3})?)$/.test(rating)) return null;
    return {label:"Energy",title:"The energy rating.\nAt a glance.",line:"Check the official label for consumption.",
      facts:[[rating,"energy class"]],kind:"energy",rating:rating,href:"#closer",pane:"p-energy",
      detail:"Energy efficiency class "+rating+". See the official energy label for consumption and test conditions.",source:"Energy section"};
  }
  function warrantyCard(p){
    var w = p.warranty || {}, years = Number(w.years);
    if(!isFinite(years) || years <= 0) return null;
    var standard = years + (years === 1 ? " year" : " years");
    var rows = [[standard,"standard guarantee"]];
    return {label:"Guarantee",title:"Your cover.\nClearly explained.",line:plain(w.ext || "Manufacturer's guarantee included."),
      facts:rows,kind:"shield",note:plain(w.note),href:"#gtk",
      detail:[standard+" guarantee.",plain(w.ext),plain(w.note)].filter(Boolean).join(" "),source:"Guarantee section"};
  }
  function applySony(cards, p){
    if(p.handle !== "sony-k85xr75m2pb-uka-85-4k-rgb-led-google-tv" || cards.length !== 3) return;
    cards[0] = {label:cards[0].label,title:"Big screen.\nColour in full.",line:"Red, green and blue backlighting.",facts:[["85″","screen size"],["4K","3840 × 2160"],["RGB","LED backlight"]],kind:"rgb",href:"#ch0",detail:"An 85-inch 4K screen with RGB LED backlighting, controlled by RGB Backlight Master Drive Pro. Resolution is 3840 × 2160.",detailTitle:cards[0].detailTitle,chips:cards[0].chips,device:"tv",source:cards[0].source};
    cards[1] = {label:cards[1].label,title:"Every scene.\nRefined by XR.",line:"AI picture processing, scene by scene.",facts:[["XR","processor"],["Dolby Vision","HDR"],["Studio modes","calibrated picture"]],kind:"processor",href:"#ch1",detail:cards[1].detail,detailTitle:cards[1].detailTitle,chips:cards[1].chips,device:"tv",source:cards[1].source};
    cards[2] = {label:cards[2].label,title:"Hear the detail.\nFeel the bass.",line:"Acoustic Multi-Audio+.",facts:[["2","full-range speakers"],["2","subwoofers"],["40 W","total output"]],kind:"sound",href:"#ch2",detail:cards[2].detail,detailTitle:cards[2].detailTitle,chips:cards[2].chips,device:"tv",source:cards[2].source,audioPair:true};
  }
  function build(p){
    p = p || {}; var d = p.dna || {}, closer = d.closer || {};
    var cards = (d.chapters || []).map(function(c,index){ return chapter(c,p,index); });
    applySony(cards,p);
    if(closer.design){
      var design = closer.design;
      var designFacts=facts((design.bullets || []).map(function(b){ return [b,""]; }));
      var designLine=caption({lede:design.p}, plain(design.h || "Designed for your space"));
      // A list may contain whole sentences. Extract a complete source clause
      // only for an otherwise empty design card; never cut a word or number.
      if(!designFacts.length && !designLine){
        var clauses=plain(design.p).split(/,\s+(?=it\b|with\b)|\s+[—;]\s+/);
        designLine=clauses.find(function(s){return words(s).length>=3 && words(s).length<=19;}) || '';
      }
      cards.push({label:"Design",title:plain(design.h || "Designed for your space"),line:caption({lede:design.p}, plain(design.h || "Designed for your space")),
        facts:designFacts,kind:"design",href:"#closer",pane:"p-fit",
        detail:plain(design.p),detailTitle:plain(design.h || "Design details"),device:((d.device || {}).kind || ""),source:"Design section"});
      cards[cards.length-1].line=designLine;
    }
    var fit = closer.fit;
    if(fit && isFiniteDimension(fit.w) && isFiniteDimension(fit.h) && isFiniteDimension(fit.d)){
      var device = ((d.device || {}).kind || ""), tv = device === "tv";
      cards.push({label:"Will it fit?",title:"A place for\nevery dimension.",line:tv ? (p.handle === "sony-k85xr75m2pb-uka-85-4k-rgb-led-google-tv" ? "Dimensions shown without stand." : (plain(fit.note) || "Check the size with your chosen stand.")) : "Measure your space before ordering.",
        facts:[[fit.w+" cm","width"],[fit.h+" cm","height"],[fit.d+" cm","depth"]],kind:"fit",href:"#closer",pane:"p-fit",device:device,
        note:plain(fit.note),detail:plain(fit.note || "Dimensions are W × H × D. Check the installation guide for required clearance."),source:"Dimensions section"});
    }
    var energy = energyCard(p,closer);
    if(energy){
      var emptyEnergy=cards.findIndex(function(c){return /energy/i.test(c.label) && !c.line && (!c.facts.length || (c.facts.length===1 && c.facts[0][0]===energy.rating && /energy|class|rating/i.test(c.facts[0][1])));});
      if(emptyEnergy>=0) cards[emptyEnergy]=energy;
      else cards.push(energy);
    }
    var warranty = warrantyCard(p); if(warranty) cards.push(warranty);
    cards.push({label:"Local delivery",title:"From our shop.\nTo your home.",/* je-glance-free-delivery-min-20261010 */line:"Free delivery (min. order \u00a3100).",kind:"delivery",facts:[["Free","delivery (min. order \u00a3100)"],["Our team","delivers"],["In store","collection available"]],href:"#gtk",detail:"Delivery in our covered postcodes is free on orders of \u00a3100 or more and \u00a315 below that, or collect in store in Scunthorpe. Installation is a paid service. Use the postcode checker to confirm coverage.",source:"Local delivery section"});
    var device = ((d.device || {}).kind || "");
    cards.forEach(function(card){ if(!card.device) card.device = device; });
    return cards;
  }
  global.JE_BRIEF_CONTENT = {build:build};
})(window);

/* je-visual-brief-cards-20260905. Source-derived summaries.
   The existing highlights controller owns card movement. This module owns only
   the tile's content. je-glance-no-visuals-20260917 (Will: "Keep the tiles just
   remove the animated graphics"): the tiles carry no drawings and there is no
   pause control; the Programmes tile keeps the exact model's reviewed gallery
   photo, which is a still photograph.
   je-glance-art-20260918: a tile whose words match one of the 31
   approved pictures carries it as a layer behind the words (artFor / artLayer below). */
(function(global){
  "use strict";
  function plain(value){
    var node = document.createElement("textarea");
    node.innerHTML = String(value == null ? "" : value).replace(/<[^>]*>/g,"");
    return node.value.replace(/\|/g, " ").replace(/\s+/g," ").trim();
  }
  function esc(value){ return plain(value).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#39;"); }
  function firstSentence(text){
    return plain(text).match(/^.*?(?:[.!?](?=\s|$)|$)/)[0];
  }
  function shortLine(text, limit){
    var s = firstSentence(text);
    return s.split(/\s+/).length <= (limit || 19) ? s : "";
  }
  function cleanFacts(rows){
    var seen = {};
    return (rows || []).filter(function(r){
      if(!Array.isArray(r) || !plain(r[0])) return false;
      var key = plain(r[0]) + "|" + plain(r[1]);
      if(seen[key]) return false; seen[key] = true; return true;
    }).slice(0,3).map(function(r){ return [plain(r[0]),plain(r[1])]; });
  }
  function kindFor(c,p){
    var k = plain(c.kicker).toLowerCase(), text = k + " " + plain(c.headline).toLowerCase();
    if(/processor|upscal|ai picture/.test(text)) return "processor";
    if(/sound|speaker|audio|noise/.test(text)) return "sound";
    if(/rgb/.test(text)) return "rgb";
    if(/picture|screen|resolution|refresh|gaming|oled|qled/.test(text)) return "screen";
    if(/quick|speed|timer|time|battery|power cut/.test(text)) return "timer";
    if(/connect|smart|google tv|wifi|wi-fi|control/.test(text)){
      return /wi-fi|wifi|bluetooth|wireless/i.test(text+' '+plain(c.lede)+' '+(c.chips || []).join(' ')) ? "connected" : "controls";
    }
    if(/fit|dimension|footprint|placement|compact|reach/.test(text)) return "fit";
    if(/energy|saving|efficien/.test(text)) return "energy";
    if(/safety|protect|lock|guarantee/.test(text)) return "shield";
    if(/steam/.test(text)) return "steam";
    if(/ironing|crease/.test(text)) return "features";
    if(/frost|cool|fresh|chill|freez/.test(text)) return "cooling";
    if(/heat|cook|oven|grill|hob|burner|induction|zones/.test(text)) return "heat";
    if(/filtrat|suction|hair|dust|clean/.test(text)) return "airflow";
    var module = (p.dna || {}).module;
    return {pixels:"screen",drum:"drum",tumble:"drum",steam:"steam",frost:"cooling",ember:"heat",flame:"heat",micro:"heat",vortex:"airflow",breeze:"airflow",brew:"brew",wave:"sound"}[module] || "features";
  }
  function chapter(c,p,i){
    var facts = (c.stats || []).slice();
    if(c.counter && Number.isFinite(Number(c.counter.target))){
      var val = Number(c.counter.target).toLocaleString("en-GB") + (c.counter.suffix || "");
      if(/up to/i.test(c.lede || "")) val = "Up to " + val;
      facts.unshift([val,c.counter.label || c.kicker]);
    }
    if(!facts.length && c.chips) facts = c.chips.slice(0,3).map(function(x){return [x,""];});
    var title = plain(c.headline || c.kicker || "The key details");
    if(c.counter && /up to/i.test(c.lede || "") && c.counter.label) title = facts[0][0] + " " + plain(c.counter.label);
    return {label:plain(c.kicker || "Feature"), title:title,
      line:shortLine(c.lede), facts:cleanFacts(facts), kind:kindFor(c,p), href:"#ch"+i,
      detail:plain(c.lede), detailTitle:plain(c.headline), chips:(c.chips || []).map(plain), device:((p.dna || {}).device || {}).kind, source:"Product section " + (i+1)};
  }
  function build(p){
    if(global.JE_BRIEF_CONTENT) return global.JE_BRIEF_CONTENT.build(p);
    var d = p.dna || {}, cards = (d.chapters || []).map(function(c,i){return chapter(c,p,i);});
    var cl = d.closer || {}, fit = cl.fit, w = p.warranty;
    // One exact-product art direction. Values remain anchored to the retrieved
    // product data and Sony's K-85XR75M2 specification, recorded in sources.json.
    if(p.handle === "sony-k85xr75m2pb-uka-85-4k-rgb-led-google-tv" && cards.length === 3){
      cards[0].title = "Big screen.\nColour in full.";
      cards[0].line = "Red, green and blue backlighting.";
      cards[0].facts = [["85″","screen size"],["4K","3840 × 2160"],["RGB","LED backlight"]];
      cards[0].kind = "rgb";
      cards[0].detail = "An 85-inch 4K screen with RGB LED backlighting, controlled by RGB Backlight Master Drive Pro. Resolution is 3840 × 2160.";
      cards[1].title = "Every scene.\nRefined by XR.";
      cards[1].line = "AI picture processing, scene by scene.";
      cards[1].facts = [["XR","processor"],["Dolby Vision","HDR"],["Studio modes","calibrated picture"]];
      cards[1].kind = "processor";
      cards[2].title = "Hear the detail.\nFeel the bass.";
      cards[2].line = "Acoustic Multi-Audio+.";
      cards[2].facts = [["2","full-range speakers"],["2","subwoofers"],["40 W","total output"]];
      cards[2].kind = "sound";
      cards[2].audioPair = true;
    }
    if(cl.design){
      var desc = cl.design;
      cards.push({label:"Design",title:plain(desc.h || "Designed for your space"),line:shortLine(desc.p),kind:"design",
        facts:cleanFacts((desc.bullets || []).slice(0,3).map(function(b){return [b,""];})),href:"#closer",pane:"p-fit",detail:plain(desc.p),source:"Design section",device:(d.device || {}).kind});
    }
    if(fit && fit.w && fit.h && fit.d){
      var tv = (d.device || {}).kind === "tv";
      cards.push({label:"Will it fit?",title:"A place for\nevery dimension.",line:tv ? "Check the size with your chosen stand." : "Measure your space before ordering.",kind:"fit",device:(d.device || {}).kind,
        facts:cleanFacts([[fit.w+" cm","width"],[fit.h+" cm","height"],[fit.d+" cm","depth"]]),href:"#closer",pane:"p-fit",note:p.handle==="sony-k85xr75m2pb-uka-85-4k-rgb-led-google-tv"?"Dimensions shown without stand.":"",detail:plain(fit.note || "Dimensions are W × H × D. Allow the clearances specified in the installation guide."),source:"Dimensions section"});
    }
    if(cl.energy && p.energy){
      cards.push({label:"Energy",title:"The energy rating.\nAt a glance.",line:"Check the official label for consumption.",kind:"energy",rating:plain(p.energy),
        facts:[[plain(p.energy),"energy class"]],href:"#closer",pane:"p-energy",detail:"Energy efficiency class " + plain(p.energy) + ". See the official energy label for consumption and test conditions.",source:"Energy section"});
    }
    if(w && w.years){
      cards.push({label:"Guarantee",title:"Your cover.\nClearly explained.",line:plain(w.ext || "Manufacturer's guarantee included."),kind:"shield",
        facts:[[w.years+(Number(w.years)===1?" year":" years"),"standard cover"]],note:plain(w.note),href:"#gtk",detail:[w.years+" year guarantee.",w.ext,w.note].filter(Boolean).map(plain).join(" "),source:"Guarantee section"});
    }
    cards.push({label:"Local delivery",title:"From our shop.\nTo your home.",/* je-glance-free-delivery-min-20261010 */line:"Free delivery (min. order \u00a3100).",kind:"delivery",facts:[["Free","delivery (min. order \u00a3100)"],["Our team","delivers"],["In store","collection available"]],
      href:"#gtk",detail:"Delivery in our covered postcodes is free on orders of \u00a3100 or more and \u00a315 below that, or collect in store in Scunthorpe. Installation is a paid service. Use the postcode checker to confirm coverage.",source:"Local delivery section"});
    return cards;
  }
  function text(x,y,t,cls){return '<text x="'+x+'" y="'+y+'" class="'+(cls || "hb-vlabel")+'" text-anchor="middle">'+esc(t)+'</text>';}
  function productControls(p,c){
    var photos=(p.photos || []).filter(function(photo){return photo && /^https:\/\//i.test(photo.src || '');});
    var photo=photos.find(function(photo){return /^(hero|main|primary)$/.test(photo.role || '');}) || photos[0] || p.hero;
    if(!photo || !/^https:\/\//i.test(photo.src || '')) return ''; /* je-glance-no-visuals-20260917: no photo, no placeholder drawing */
    var w=Number(photo.w),h=Number(photo.h),fit=photo.fit;
    var known=w>0 && h>0 && Array.isArray(fit) && fit.length===4 && fit.every(function(v){return typeof v==='number' && v>=0 && v<=1;}) && fit[2]>fit[0] && fit[3]>fit[1];
    var x=known?fit[0]*w:0,y=known?fit[1]*h:0,pw=known?(fit[2]-fit[0])*w:(w||1),ph=known?(fit[3]-fit[1])*h:(h||1);
    // Laundry controls sit on the upper front. Keep the source pixels and
    // enough of the cabinet to show that these are this model's actual dials.
    var close=known && /^(washer|dryer)$/.test(c.device || '');
    var cropH=close?ph*.42:ph;
    var caption=close?'ACTUAL FRONT CONTROLS':'ACTUAL PRODUCT';
    var scale=Math.min(344/pw,184/cropH),imageX=8+(344-pw*scale)/2-x*scale,imageY=14+(184-cropH*scale)/2-y*scale;
    var clipId='hb-front-'+String(p.handle || 'product').replace(/[^a-z0-9-]/gi,'');
    return '<svg viewBox="0 0 360 224" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" data-hb-product-front="'+esc(p.handle)+'"><defs><clipPath id="'+clipId+'"><rect x="8" y="14" width="344" height="184" rx="7"/></clipPath></defs><image href="'+esc(photo.src)+'" x="'+imageX+'" y="'+imageY+'" width="'+((w||1)*scale)+'" height="'+((h||1)*scale)+'" preserveAspectRatio="xMidYMid meet" clip-path="url(#'+clipId+')"/>'+text(180,220,caption)+'</svg>';
  }
  /* je-glance-no-visuals-20260917: the only thing left in the visual slot is the
     Programmes tile's still product photo; every other tile is text. The deck is a
     stack of equal-height tiles, so ONE tile with a photo sets the height of all of
     them: beside the copy on a wide screen that costs ~24px, stacked under it on a
     phone it cost every other tile in the deck 100-130px of empty space (measured on
     88 laundry, dishwasher and oven decks). So a narrow screen gets no photo - decided
     here rather than hidden in CSS, so the phone never downloads it either. The test
     is the SAME query the stylesheet lays the photo out under (min-width:821px), so a
     zoomed window 820.5px wide cannot render a photo that no rule positions. */
  function visual(p,c){
    if(c.kind!=='programmes') return '';
    if(global.matchMedia && !global.matchMedia('(min-width:821px)').matches) return '';
    var photo=productControls(p,c);
    return photo ? '<div class="hb-visual hb-photo">'+photo+'</div>' : '';
  }
  /* je-glance-art-20260918 (Will, 2026-09-18, after approving all 31 pictures on real cards: "1" = build
     them in). A tile whose OWN words make a claim one of the pictures shows gets that picture as a
     layer BEHIND its words: position:absolute, so it costs the tile no height (the deck is a stack of
     equal-height tiles - the Programmes-photo lesson), low-key on pure black and screen-blended, so
     only the picture's light reads as picture and the glass, tint and glow stay visible (its black
     deepens the translucent glass a little where the mask is open - see the CSS). ARTR is rendered from ONE
     definition, scripts/feature_tour/visual_brief_cards/glance_pictures.py (rules_for_js), by
     build_glance_art_cards_20260918.py, and test_glance_art_20260918.py holds artFor() equal to its
     bind() over the whole fleet. Nothing here can break a tile: any failure means no picture. */
  var ARTR = {"chargeNear":"recharge|to full|charging|charge time","chargeWindow":34,"db":"db|db\\(a\\)|decibels?","dries":"\\bdry\\b|dried|drying|\\bdries\\b","family":{"airfryer":"cooking","coffee":"small","cooker":"cooking","dishwasher":"dishwasher","dryer":"laundry","fan":"air","freezer":"cooling","fridge":"cooling","fridgefreezer":"cooling","generic":"other","heater":"air","hob":"cooking","kettle":"small","microwave":"cooking","oven":"cooking","radio":"audio","soundbar":"audio","speaker":"audio","stickvac":"floorcare","tv":"tv","vacuum":"floorcare","washer":"laundry"},"groups":{"even-heat":"bake","fridge-capacity":"fresh","fridge-interior":"fresh","motion":"bird","oven-capacity":"bake","tv-detail":"bird","two-ovens":"bake","upscaling":"bird"},"longLife":"long battery life","loud":"\\bloud","min":"min|mins|minutes?","oldScaleGood":"\\ba\\+{1,3}","pictures":[{"also":{"families":["tv"],"labels":["will it fit?"]},"evidence":"\\d(?:\\.\\d+)?\\s?cm\\b|centimetre|width|\\bwide\\b|\\btall\\b|\\bdeep\\b|\\bgap\\b|slot|housing|worktop|under[- ]?counter|built[- ]?(?:in|under)|integrated|slides? in|narrow|slim|compact|footprint|tuck|\\bfits?\\b","exCard":"atmos|sound|shed|garage|outbuilding|porthole|carry|configur|inox|\\bplug\\b","families":["cooling","cooking","laundry","floorcare","other","audio","dishwasher","small","air"],"id":"fit","labels":["compact","fit","fitting","footprint","height","placement","room fit","size","slim","slim depth","slimline","width","will it fit?","worktop space"]},{"id":"guarantee","labels":["guarantee"]},{"evidence":"\\b[abc](?:\\+{1,3})?\\s+energy|\\ba\\+{1,3}\\b|a-class|a-rated|class a\\b|top energy class|less energy|\\b[abc] (?:the )?(?:main|second) oven|efficien","id":"energy","labels":["energy","energy & water","energy rating","energy saving","energy use"],"predicate":"energy_ok"},{"families":["tv","audio","other"],"id":"sound","labels":["acoustic centre","atmos","audio","bass","bass modes","equaliser","sound","sound field","sound system","speaker units","speakers","stereo","subwoofer","x-balanced"]},{"id":"quiet","labels":["noise & drying","noise & water","noise control","noise level"],"predicate":"quiet_ok"},{"families":["laundry"],"id":"laundry-capacity","labels":["capacity","capacity & spin","laundry load","load size"]},{"devices":["fridge","fridgefreezer"],"exHeading":"freez|frozen","id":"fridge-capacity","labels":["50/50 split","capacity","capacity split"]},{"families":["tv"],"id":"tv-detail","labels":["4k","4k hdr","advanced image","crystal uhd","full hd","hdr formats","hdr support","hva panel","hva pro","mini led","neo qled","oled","oled hdr","panel","picture","picture detail","picture engine","picture quality","pixels","qled"]},{"exCard":"solid plate|sealed plate","families":["cooking"],"id":"hob","kinds":["hob"],"labels":["burners","gas","gas hob","hob","induction","wok burner","zones"]},{"families":["cooking"],"id":"cooking-clean","labels":["ceramic","ceramic hob","cleaning","self-cleaning","steam cleaning"]},{"families":["laundry"],"id":"quick-wash","labels":["quick 30","quick wash","superspeed"]},{"devices":["freezer","fridgefreezer"],"id":"no-frost","labels":["auto defrost","no frost"]},{"devices":["oven","cooker"],"id":"oven-capacity","labels":["capacity","oven capacity"]},{"devices":["fridge","fridgefreezer"],"exCard":"freez|frozen","exHeading":"ice ?box","id":"fridge-interior","labels":["inside","interior","salad crisper","storage layout"]},{"families":["tv"],"id":"streaming","kinds":["apps"],"labels":["apps","google tv","record","roku","smart","smart features","smart platform","streaming","tivo","webos"]},{"families":["dishwasher"],"id":"dishwasher-capacity","labels":["capacity"]},{"families":["laundry"],"id":"drying","kinds":["drying"],"labels":["anti-crease","condenser","drying method","heat pump","no venting","quick dry","sensor dry","two-in-one","wash & dry","wash & dry 45"],"predicate":"really_dries"},{"evidence":"\\bpet|\\bfur\\b|dander|shedding|animal","exCard":"\\bwash\\b|\\bwet\\b|\\bmop","families":["floorcare"],"id":"pet-hair","labels":["anti-tangle","bagless, pet","for pets","hair pickup","hair wrap","pet hair","pet turbobrush","pets"],"withTitle":true},{"exCard":"\\bwash\\b|\\bwet\\b|\\bmop","families":["floorcare"],"id":"run-time","labels":["battery life","run time"],"predicate":"long_runtime_ok"},{"families":["tv"],"id":"upscaling","labels":["nq4 ai","processor","upscaling","xr processor"]},{"families":["floorcare","air","other"],"id":"filtration","kinds":["filtration"],"labels":["allergen seal","filtration","hepa"]},{"families":["floorcare"],"id":"suction","labels":["cleaning power","cyclone","cyclones","suction","suction & bin","suction power"]},{"devices":["coffee"],"exCard":"two cups|two espressos","id":"espresso","labels":["3-in-1 brewing","barista assist","bean to cup","dual function","filter baskets","grinder","pods & grounds"]},{"devices":["coffee"],"id":"milk","labels":["froth presets","milk","milk cup","milk wand"]},{"devices":["oven","cooker"],"id":"two-ovens","labels":["double","dual zone","two ovens","two zones"]},{"devices":["microwave"],"id":"reheat","labels":["auto cook","auto-cook","defrost","inverter","power levels"]},{"evidence":"\\b(?:1[0-9]{2}|2[0-9]{2})\\s?hz\\b","families":["tv"],"id":"motion","labels":["gaming","refresh rate","screen motion"]},{"evidence":"oled|mini led|micro rgb|neo qled|dimming|contrast","families":["tv"],"id":"contrast","labels":["advanced led","backlight","backlighting","contrast"],"withTitle":true},{"families":["cooling"],"id":"power-cut","labels":["power cuts"]},{"evidence":"garage|shed|outbuilding|cold room|outhouse|-1[0-9]\\s?c|minus","exCard":"low frost|no ?frost|frost[- ]free|defrost|keeps? ice|ice (?:from|build)","families":["cooling"],"id":"cold-room","labels":["cold rooms","garage-ready","placement"]},{"families":["floorcare","other"],"id":"wet-clean","kinds":["wetclean"],"labels":["cleaning pads","deep clean","spot cleaning","spray & extract","steam pads","two tanks","vacuum & mop","water","wet and dry","wet roller head"]}],"quietDb":65.0,"quietWords":"quiet|hush|murmur|silent|silence|noise cancel","runtimeMin":40.0,"skip":["delivery","design","programmes"],"v":{"cold-room":{"1600":"346578b284","800":"bbb464448c"},"contrast":{"1600":"487fce205f","800":"9381e2a84d"},"cooking-clean":{"1600":"bb6f66bb50","800":"c941f4a194"},"dishwasher-capacity":{"1600":"5e97478713","800":"370a7f9f55"},"drying":{"1600":"3995fc3ca5","800":"7e5f63575f"},"energy":{"1600":"9115c3b43b","800":"841f0a19f3"},"espresso":{"1600":"d680c26a2b","800":"cdb84831ad"},"filtration":{"1600":"59d870bd58","800":"bd70e07ab1"},"fit":{"1600":"75d97038a5","800":"862f75e7f6"},"fridge-capacity":{"1600":"73caf0a12a","800":"a45ad0caca"},"fridge-interior":{"1600":"d825b7ab48","800":"0ea5d7da39"},"guarantee":{"1600":"ab58477f46","800":"54854376f1"},"hob":{"1600":"ff98870b43","800":"5dec416cbc"},"laundry-capacity":{"1600":"bfae120bf9","800":"c0fb7fe227"},"milk":{"1600":"fed5c3db6d","800":"dd18534b50"},"motion":{"1600":"fdcba7c6ef","800":"5c49d0ca47"},"no-frost":{"1600":"5912a12efa","800":"badc8ca25e"},"oven-capacity":{"1600":"434bacf9fb","800":"26b7a5219d"},"pet-hair":{"1600":"d0c8dce98e","800":"d5b52ea577"},"power-cut":{"1600":"9d7dcf690f","800":"08d5373c47"},"quick-wash":{"1600":"840f233583","800":"0aa57f4baa"},"quiet":{"1600":"84e07e4ea1","800":"455b279ddd"},"reheat":{"1600":"1266a9b2f8","800":"f1210594b3"},"run-time":{"1600":"a7c4699bbc","800":"a112856b98"},"sound":{"1600":"44a2ddeae5","800":"d7ff067b07"},"streaming":{"1600":"cdbeca5af2","800":"4d3afb183e"},"suction":{"1600":"b11a208b36","800":"092d55bfc2"},"tv-detail":{"1600":"727543ed1c","800":"f6afabe9c8"},"two-ovens":{"1600":"b5212337cc","800":"3e1d06ab38"},"upscaling":{"1600":"b9739a315a","800":"017ddac37d"},"wet-clean":{"1600":"dc94e2e918","800":"9d062e41ab"}},"words":{"fifteen":15,"fifty":50,"fifty-five":55,"fifty-nine":59,"fifty-two":52,"five":5,"forty":40,"forty-eight":48,"forty-five":45,"forty-four":44,"forty-nine":49,"forty-one":41,"forty-seven":47,"forty-six":46,"forty-three":43,"forty-two":42,"fourteen":14,"ninety":90,"ninety-one":91,"seventy":70,"sixty":60,"sixty-four":64,"sixty-two":62,"ten":10,"thirty":30,"thirty-eight":38,"thirty-five":35,"thirty-four":34,"thirty-nine":39,"thirty-seven":37,"thirty-six":36,"thirty-three":33,"thirty-two":32,"three":3,"twenty":20}};
  var ART_BASE = (function(){
    try {
      var s = (document.currentScript && document.currentScript.src) || ((document.querySelector('script[data-je-tour-engine]') || {}).src) || '';
      var b = String(s).split(/[?#]/)[0].replace(/[^\/]*$/, '');
      return /^https:\/\/[A-Za-z0-9._~:\/%-]+\/$/.test(b) ? b : '';
    } catch(e){ return ''; }
  })();
  /* own keys only: a script that adds to Object.prototype must not be able to choose a picture */
  function artOwn(o, k){ return Object.prototype.hasOwnProperty.call(o, k); }
  function artNorm(s){ return String(s == null ? '' : s).trim().toLowerCase().replace(/\s+/g, ' '); }
  function artTile(p, c){
    var d = p.dna || {}, ch = /^#ch(\d+)$/.exec(c.href || ''), chapters = d.chapters || [];
    var device = c.device || (d.device || {}).kind || '';
    return {kind:c.kind, label:c.label, device:device, family:artOwn(ARTR.family, device) ? ARTR.family[device] : 'other',
      heading:String(c.title || '').replace(/\n/g, ' '), line:c.line || '',
      facts:(c.facts || []).map(function(f){ return f.filter(Boolean).join(' '); }), title:p.title || '',
      lede:ch ? String((chapters[+ch[1]] || {}).lede || '').replace(/<[^>]+>/g, '') : ''};
  }
  function artText(t, withTitle){ return [t.heading, t.line, t.facts.join(' ')].concat(withTitle ? [t.title] : []).join(' ').toLowerCase(); }
  /* Every number written directly before a unit. The Python twin uses a look-behind; the engine
     checks the character before each number by hand instead, because a look-behind is a syntax
     error on Safari < 16.4 and would take the whole engine down there. */
  function artNumbers(text, num, unit, tail){
    var found = [], re = new RegExp(num + '\\s?(?:' + unit + ')' + tail, 'g'), m;
    while((m = re.exec(text))){
      if(m.index > 0 && /[\d.,]/.test(text.charAt(m.index - 1))){ re.lastIndex = m.index + 1; continue; }
      found.push({n:parseFloat(m[1]), at:m.index, end:m.index + m[0].length});
    }
    return found;
  }
  function artWords(text, unit){
    var found = [];
    Object.keys(ARTR.words).forEach(function(w){ if(new RegExp('\\b' + w + '\\s(?:' + unit + ')\\b').test(text)) found.push(ARTR.words[w]); });
    return found;
  }
  var ARTP = {
    quiet_ok:function(t){
      if(new RegExp(ARTR.loud).test((artText(t) + ' ' + t.lede).toLowerCase())) return false;
      var text = artText(t), levels = artNumbers(text, '(\\d{1,3}(?:\\.\\d+)?)', ARTR.db, '(?![a-z])').map(function(x){ return x.n; }).concat(artWords(text, ARTR.db));
      if(levels.length) return Math.max.apply(null, levels) <= ARTR.quietDb;
      return new RegExp(ARTR.quietWords).test(text);
    },
    long_runtime_ok:function(t){
      var text = artText(t), best = 0, near = new RegExp(ARTR.chargeNear), w = ARTR.chargeWindow;
      if(text.indexOf(ARTR.longLife) >= 0) return true;
      /* whole minutes only, exactly as the Python twin: "40.5 min" is no run time there either */
      artNumbers(text, '(\\d{1,3})', ARTR.min, '\\b').forEach(function(x){
        if(near.test(text.slice(Math.max(0, x.at - w), x.end + w))) return;
        best = Math.max(best, x.n);
      });
      artWords(text, ARTR.min).forEach(function(n){ best = Math.max(best, n); });
      return best >= ARTR.runtimeMin;
    },
    really_dries:function(t){ return t.device !== 'washer' || new RegExp(ARTR.dries).test(artText(t)); },
    /* a tumble dryer is still labelled A+++ to D, where B and C are the bottom half */
    energy_ok:function(t){ return t.device !== 'dryer' || new RegExp(ARTR.oldScaleGood).test(artText(t)); }
  };
  function artMatch(p, t){
    if(ARTR.skip.indexOf(t.kind) >= 0) return false;
    var rules = [p].concat(p.also ? [p.also] : []), lab = artNorm(t.label);
    for(var i = 0; i < rules.length; i++){
      var r = rules[i];
      if(r.labels.indexOf(lab) < 0) continue;
      if(r.devices && r.devices.indexOf(t.device) < 0) continue;
      if(r.families && !r.devices && r.families.indexOf(t.family) < 0) continue;
      if(r === p){
        if(p.kinds && p.kinds.indexOf(t.kind) < 0) continue;
        var text = artText(t, !!p.withTitle);
        if(p.evidence && !new RegExp(p.evidence).test(text)) continue;
        if(p.exHeading && new RegExp(p.exHeading).test(t.heading.toLowerCase())) continue;
        if(p.exCard && new RegExp(p.exCard).test(text)) continue;
        if(p.predicate && !ARTP[p.predicate](t)) continue;
      }
      return true;
    }
    return false;
  }
  /* Which picture each tile gets: the first picture whose rule the tile's own words satisfy, and
     never the same picture - or two of a kind (ARTR.groups) - twice on one page. */
  /* je-glance-art-expansion-20260919: generated from glance_extra_pictures.py.  Current31 artFor below is
     intentionally preserved byte-for-byte; EXTRA_RULES fills only its null entries afterwards. */
  var ART_EXTRA_RULES = {"pictures":[{"evidence":"\\b(?:dial|knob|rotary)\\b","exclude":"\\b(?:touch|button|display|sensor)\\b","families":["cooking","laundry","dishwasher","air","small","other"],"group":"controls","id":"control-dial","labels":["control panel","controls","pot & controls"],"render":"extra-control-dial"},{"evidence":"\\b(?:touch|button|display|sensor)\\b","exclude":"\\b(?:dial|knob|rotary)\\b","families":["cooking","laundry","dishwasher","air","small","other"],"group":"controls","id":"control-touch","labels":["control panel","controls","display","setup","touch sensor"],"render":"extra-control-touch"},{"evidence":"energy|consumption|efficien|water","families":["tv","cooling","laundry","dishwasher","cooking","small","air","other"],"group":"energy","id":"energy-neutral","labels":["energy","energy & water","energy rating","energy saving","energy use"],"render":"extra-energy-neutral"},{"evidence":"\\b(?:db|db\\(a\\)|decibels?|noise|sound)\\b","families":["laundry","dishwasher","cooling","floorcare","air","other"],"group":"sound","id":"sound-neutral","labels":["noise & drying","noise & reach","noise & water","noise level"],"render":"sound"},{"evidence":"wifi|wi-fi|app|connect|thinq|smartthings|connectlife","families":["laundry","cooling","dishwasher","cooking","air"],"group":"connection","id":"connected-wifi","labels":["app control","connected","lg thinq","smart connect","wi-fi"],"render":"extra-connected-wifi"},{"evidence":"\\b(?:hdmi|usb|optical|earc|arc)\\b","families":["tv","audio"],"group":"connection","id":"wired-ports","labels":["connections","sources"],"render":"extra-wired-ports"},{"devices":["freezer"],"evidence":"drawers?","exclude":"fridge|salad|ice ?box","group":"cold-storage","id":"freezer-drawers","labels":["capacity","drawers","inside"],"render":"extra-freezer-drawers"},{"devices":["fridge","fridgefreezer"],"evidence":"shelf|shelves|bins?|storage","exclude":"freez|frozen|ice ?box","group":"cold-storage","id":"fridge-shelves","labels":["inside","interior","shelves","storage layout"],"render":"extra-fridge-shelves"},{"devices":["freezer"],"evidence":"frozen|storage|litres?","exclude":"drawers?","group":"cold-storage","id":"freezer-interior","labels":["inside","interior"],"render":"extra-freezer-interior"},{"devices":["microwave"],"evidence":"\\b(?:l|litres?|capacity|turntable)\\b","group":"capacity","id":"microwave-space","labels":["capacity","inside","interior"],"render":"extra-microwave-space"},{"evidence":"dust|bin|capacity|storage","families":["floorcare"],"group":"floorcare-storage","id":"vacuum-bin","labels":["dust capacity","dust storage","suction & bin","tools & bin"],"render":"extra-vacuum-bin"},{"devices":["kettle"],"evidence":"\\b(?:l|litres?|water|cups?)\\b","group":"small-capacity","id":"kettle-water","labels":["capacity","water gauge","water tank"],"render":"extra-kettle-water"},{"evidence":"handheld|lift.?out|detach|convert","families":["floorcare"],"group":"portable","id":"handheld-convertible","labels":["handheld","handheld mode"],"render":"extra-handheld-convertible"},{"evidence":"\\b(?:lightweight|light to|carry|portable|folding)\\b","exclude":"cable|cord|hose|reach","families":["floorcare","audio","small","other"],"group":"portable","id":"carry-light","labels":["handling","on the move","portability","portable","portable design","weight"],"render":"extra-carry-light"},{"devices":["oven","cooker"],"evidence":"fan|convection|even|multi","exclude":"gas heat|grill|air fry|probe","group":"heat","id":"oven-heat","labels":["even heat","heat","heat method","heating","main oven"],"render":"extra-oven-heat"},{"devices":["oven","cooker","microwave"],"evidence":"grill","group":"heat","id":"grill-brown","labels":["grill","grill cavity","oven & grill"],"render":"extra-grill-brown"},{"devices":["airfryer","oven","cooker"],"evidence":"air ?fry|less oil|crisp","group":"heat","id":"airfry-crisp","labels":["air fry","less oil"],"render":"extra-airfry-crisp"},{"evidence":"steam.*(?:crease|iron|fabric|laundry)|(?:crease|iron|fabric|laundry).*steam","exclude":"saniti[sz]|bacteria|hygiene|allergen","families":["laundry"],"group":"steam","id":"steam-care","labels":["finish","steam","steam & extras","steam blaster","steam boost"],"render":"extra-steam-care"},{"evidence":"hygiene|saniti[sz]|bacteria|allergen","families":["laundry"],"group":"hygiene","id":"hygiene-care","labels":["allergy care","hygiene","hygiene mode","sanitising","steam & hygiene"],"render":"extra-hygiene-care"},{"evidence":"(?:pet tool|turbo.?brush|mini motorised|motorized pet)","families":["floorcare"],"group":"tools","id":"pet-tools","labels":["in the box","pet tool","pet tools","tools"],"render":"extra-pet-tools"},{"evidence":"crevice","exclude":"pet|fur|dander|animal","families":["floorcare"],"group":"tools","id":"crevice-tools","labels":["brush tools","cleaning tools","in the box","included tools","pro tools","styling tools","tools"],"render":"extra-crevice-tools"},{"evidence":"child lock|child safety|lock","families":["cooking","laundry","dishwasher"],"group":"safety","id":"child-lock","labels":["child lock","safety"],"render":"extra-child-lock"},{"evidence":"leak|water protect|aqua.?stop|overflow|flood","families":["laundry","dishwasher","cooling"],"group":"safety","id":"water-guard","labels":["safety","water protection"],"render":"extra-water-guard"},{"evidence":"channel|q-symphony|dolby|surround|two-in-one","families":["audio","tv"],"group":"audio","id":"audio-channels","labels":["channels","q-symphony","q-symphony tech","two-in-one","wireless dolby"],"render":"extra-audio-channels"},{"evidence":"cable|cord|hose|reach|radius","families":["floorcare"],"group":"reach","id":"cable-reach","labels":["cable reach","cleaning radius","cord & extras","hose length","hose reach","operating radius"],"render":"extra-cable-reach"},{"evidence":"charg|battery","families":["floorcare","air","other"],"group":"charging","id":"charging-neutral","labels":["battery life","charging","charging dock","cordless","quick charge"],"render":"extra-charging-neutral"},{"evidence":"brush|hair|tangle|floor|surface|pet","exclude":"wash|wet|mop","families":["floorcare"],"group":"brushroll","id":"brushroll-hair","labels":["anti-tangle","brush action","floor cleaning","floor sensing","floor types","hair pickup","hair wrap","pet mode","self-cleaning","surfaces"],"render":"extra-brushroll-hair"},{"devices":["tv"],"evidence":"(?:\\d{2}|large).{0,12}(?:inch|screen|format)|screen.{0,12}(?:\\d{2}|large)","group":"screen","id":"screen-size","labels":["42-inch screen","50-inch screen","55 inch","55\" screen","65 inch","65\" screen","75 inch","75-inch screen","98 inch","98-inch screen","large format","screen canvas"],"render":"extra-screen-size"}]};
  (function(){
    var v = {"extra-airfry-crisp":{"1600":"2dfa369e0e","800":"b3a2b31a10"},"extra-audio-channels":{"1600":"4835d68235","800":"dc398e7a12"},"extra-brushroll-hair":{"1600":"b1b350043d","800":"d740f43c78"},"extra-cable-reach":{"1600":"8742ba9b00","800":"100ef54c20"},"extra-carry-light":{"1600":"b321181cb2","800":"026d42067e"},"extra-charging-neutral":{"1600":"3ba7ed34ad","800":"38d8d93c81"},"extra-child-lock":{"1600":"d0dfda7428","800":"a8fbdcd6bd"},"extra-connected-wifi":{"1600":"1a1fac69b1","800":"405d8625c1"},"extra-control-dial":{"1600":"775fecf92e","800":"8addd9fdd2"},"extra-control-touch":{"1600":"2f6e0d33ba","800":"54ae8efe9d"},"extra-crevice-tools":{"1600":"8c09bff772","800":"1a7eb50ad2"},"extra-energy-neutral":{"1600":"a2347d49df","800":"ef8d89b36b"},"extra-freezer-drawers":{"1600":"a035a6e580","800":"b2f27e564b"},"extra-freezer-interior":{"1600":"c601e308e9","800":"aff0f75f83"},"extra-fridge-shelves":{"1600":"62a6be808c","800":"7b00e882e3"},"extra-grill-brown":{"1600":"f014ae1363","800":"a91ae74fc3"},"extra-handheld-convertible":{"1600":"fd4158851c","800":"37e47c275e"},"extra-hygiene-care":{"1600":"9aade321da","800":"c4f409a9e8"},"extra-kettle-water":{"1600":"7988704f32","800":"7620630564"},"extra-microwave-space":{"1600":"03ba186046","800":"c0fbdcd506"},"extra-oven-heat":{"1600":"40596f8d5c","800":"f2f8ddf893"},"extra-pet-tools":{"1600":"f2f7a38eb3","800":"11ce3fb101"},"extra-screen-size":{"1600":"5ebe79a020","800":"39fe90c70b"},"extra-steam-care":{"1600":"a49dcd3e52","800":"f6aa163e3c"},"extra-vacuum-bin":{"1600":"66a3271932","800":"0ff53e5cf1"},"extra-wired-ports":{"1600":"74b4dde044","800":"fb44198046"}};
    if(!ARTR || !ARTR.v || !v || typeof v !== 'object') return;
    Object.keys(v).forEach(function(id){
      if(!/^[a-z0-9-]+$/.test(id) || !v[id] || !/^[a-z0-9]+$/.test(v[id][1600]) || !/^[a-z0-9]+$/.test(v[id][800])) throw new Error('bad extra art version');
      if(artOwn(ARTR.v,id)) throw new Error('extra art id collides with current31: '+id);
      ARTR.v[id]=v[id];
    });
  })();
  function artFor(p, cards){
    var used = Object.create(null), out = [];
    try {
      (cards || []).forEach(function(c, i){
        var t = artTile(p, c), pid = null;
        for(var k = 0; k < ARTR.pictures.length; k++){ if(artMatch(ARTR.pictures[k], t)){ pid = ARTR.pictures[k].id; break; } }
        if(pid){ var g = artOwn(ARTR.groups, pid) ? ARTR.groups[pid] : pid; if(used[g]) pid = null; else used[g] = true; }
        out[i] = pid;
      });
    } catch(e){ return []; }
    return out;
  }
  /* je-glance-art-expansion-20260919: call current31 first, then fill only blank tiles.
     A malformed extra rule, ambiguity, or a current31 failure returns the original result unchanged. */
  var artForCurrent31 = artFor;
  function artExtraMatch(rule, t){
    try {
      if(ARTR.skip.indexOf(t.kind) >= 0 || rule.labels.indexOf(artNorm(t.label)) < 0) return false;
      if(rule.devices && rule.devices.indexOf(t.device) < 0) return false;
      if(rule.families && rule.families.indexOf(t.family) < 0) return false;
      var text=artText(t);
      return (!rule.evidence || new RegExp(rule.evidence).test(text)) && (!rule.exclude || !new RegExp(rule.exclude).test(text));
    } catch(e){ return false; }
  }
  artFor = function(p, cards){
    var original=artForCurrent31(p,cards), used=Object.create(null), out;
    try {
      if(!Array.isArray(original) || original.length !== (cards || []).length) return original;
      out=original.slice();
      out.forEach(function(pid){ if(pid){ var g=artOwn(ARTR.groups,pid) ? ARTR.groups[pid] : pid; used[g]=true; } });
      (cards || []).forEach(function(c,i){
        if(out[i]) return;
        var t=artTile(p,c), hits=[];
        ART_EXTRA_RULES.pictures.forEach(function(rule){ if(artExtraMatch(rule,t)) hits.push(rule); });
        if(hits.length !== 1) return; /* ambiguous or absent is text-only */
        var rule=hits[0], group=rule.group || rule.id;
        if(used[group]) return;
        if(rule.render !== 'sound' && (!artOwn(ARTR.v,rule.render) || !ARTR.v[rule.render])) return;
        if(rule.render === 'sound' && !artOwn(ARTR.v,'sound')) return;
        used[group]=true; out[i]=rule.render;
      });
      return out;
    } catch(e){ return original; }
  };
  /* je-glance-visibility-20261013: separate similar subjects and unillustrated cards.
     Keep the lead and delivery positions, every fact, link and picture binding. */
  /* je-glance-new-art-20261013: Will approved these three pictures and the existing Johns van.
     Fill only eligible gaps, using visible card evidence and at most one new food still-life per deck. */
  var artBeforeOctoberPhotos = artFor;
  artFor = function(p,cards){
    var out=artBeforeOctoberPhotos(p,cards), used=Object.create(null);
    if(!Array.isArray(out)||out.length!==cards.length) return out;
    out=out.slice();
    out.forEach(function(id){if(id)used[id]=true;});
    var food=/^(?:fridge-capacity|fridge-interior|freezer-capacity|oven-capacity|two-ovens|even-heat|extra-(?:fridge-shelves|freezer-drawers|freezer-interior|oven-heat|grill-brown|airfry-crisp))$/;
    var hasFood=out.some(function(id){return id&&food.test(id);});
    cards.forEach(function(c,i){
      if(out[i])return;
      var t=artTile(p,c), words=artText(t), label=artNorm(c.label), id=null;
      if(c.kind==='delivery'&&label==='local delivery')id='new-delivery-van';
      else if(!hasFood&&t.device==='fridgefreezer'&&/^(capacity|inside|interior|storage|storage layout)$/.test(label)
        &&/fridge|chilled/.test(words)&&/freez|frozen/.test(words))id='new-chilled-and-frozen';
      else if(label==='water protection'&&/\b(?:waterproof|water.resistant|ip67|ipx4)\b/i.test(words))id='new-water-beading';
      else if(!hasFood&&/^(oven|cooker)$/.test(t.device)&&/^(cooking modes|cook modes|programmes)$/.test(label)
        &&/fan|functions|programmes|conventional|bake|roast|cooking/.test(words))id='new-cooking-versatility';
      if(id&&!used[id]){out[i]=id;used[id]=true;if(/chilled-and-frozen|cooking-versatility/.test(id))hasFood=true;}
    });
    return out;
  };
  /* je-glance-library-20261013: approved concepts; visible facts gate every match. */
  var artBeforePhotoLibrary=artFor;
  artFor=function(p,cards){
    var out=artBeforePhotoLibrary(p,cards).slice(), used=Object.create(null);
    // Also defend against future upstream rules assigning the same picture twice.
    out.forEach(function(id,i){if(id){if(used[id])out[i]=null;else used[id]=true;}});
    cards.forEach(function(c,i){
      if(out[i]==='extra-charging-neutral'&&/usb.?c|type.?c/.test(artText(artTile(p,c)))&&!used['library-21-charge']){
        out[i]='library-21-charge';used['library-21-charge']=true;
      }
    });
    cards.map(function(c,i){return i;}).sort(function(a,b){return JSON.stringify(cards[a]).localeCompare(JSON.stringify(cards[b]));}).forEach(function(i){
      var c=cards[i];
      if(out[i])return;
      var t=artTile(p,c), w=artText(t), label=artNorm(c.label), k=c.kind, d=t.device, id=null;
      if(k==='design'&&/^(design|finish|body & finish|materials|colour)$/.test(label)&&/stainless|brushed|metal|graphite|silver|enamel/.test(w))id='01-materials';
      else if(k==='fit'&&/\b(?:cm|mm|width|height|depth|dimensions)\b/.test(w))id='02-measuring';
      else if(k==='stains'&&/stain|fabric|fibre|colour|care/.test(w))id='03-fabric-care';
      else if(/^(drum|capacity|programmes|drying)$/.test(k)&&/^(washer|washerdryer|dryer)$/.test(d)&&/cotton|wool|delicate|laundry|load|\bkg\b|dry|spin|drum/.test(w))id='04-laundry';
      else if((k==='wash'&&/water|litre|\d\s*l\b/.test(w))||(k==='dispenser'&&/water/.test(w)))id='05-water';
      else if(k==='energy'&&/eco|saving|efficien/.test(w))id='06-energy';
      else if(/^(connected|controls|apps|programmes)$/.test(k)&&/wi.?fi|bluetooth|phone|\bapp\b|miele@home/.test(w))id='07-connected';
      else if(/^(heat|programmes)$/.test(k)&&/^(oven|cooker|airfryer|microwave)$/.test(d)&&/bake|baking|bread|browning|roast|fan heat|even heat|convection/.test(w))id='08-even-cooking';
      else if(k==='sound'&&/sound|audio|bass|speaker|radio|music|dolby|atmos|headphone/.test(w))id='09-sound';
      else if(/^(rgb|backlight|processor)$/.test(k)&&/colour|color|picture|led|quantum|rgb|triluminos|upscal/.test(w))id='10-colour';
      else if(k==='portable'&&/light|weight|\bkg\b|portable|compact|handheld|carry/.test(w))id='11-portable';
      else if(k==='cooling'&&/^(fridge|freezer|fridgefreezer)$/.test(d)&&/freez|cool|cold|fresh|frost/.test(w))id='12-cooling';
      else if(k==='shield'&&/lock|safety|protect|cut.out|flame failure/.test(w))id='13-safety';
      else if(/^(sensor|capacity)$/.test(k)&&/weighs|weighing|load.sens|\bscales\b/.test(w))id='14-sensing';
      else if(k==='screen'&&/motion|refresh|\bhz\b|gaming|game|action|keep up/.test(w))id='15-motion';
      else if(/^(clean|wetclean)$/.test(k)&&/clean|wash|wipe|stain|spill/.test(w))id='16-cleaning';
      else if(/^(steam|hygiene|drying)$/.test(k)&&/steam/.test(w))id='17-steam';
      else if(k==='zones'&&/two|dual|2|separate|independent/.test(w))id='18-two-dishes';
      else if(d==='coffee'&&/^(brew|programmes|controls|temperature)$/.test(k)&&/coffee|espresso|barista|brew|grind|pods|grounds|filter basket/.test(w))id='19-coffee';
      else if(k==='blend'&&/smoothie|blend|fruit|drink/.test(w))id='20-blending';
      else if(/^(battery|power|cable)$/.test(k)&&/usb.?c|type.?c/.test(w))id='21-charge';
      else if(k==='timer'&&/timer|minutes?|\bmin\b|\d\s*hr|seconds?|preheat|quick/.test(w))id='22-time';
      else if(/^(airflow|filtration)$/.test(k)&&/air|purif|suction|fan|vortex/.test(w))id='23-air';
      else if(/^(brushroll|stains|tools)$/.test(k)&&/\bpet|hair pick.?up|hair wrap/.test(w))id='24-pets';
      if(id){id='library-'+id;if(!used[id]){out[i]=id;used[id]=true;}}
    });
    return out;
  };
  /* je-glance-coverage-20261014: Will approved topic-relevant photos for every card. */
  function coverageProductPhoto(p){
    var candidates=[(p.hero||{}).src,p.img];
    for(var i=0;i<candidates.length;i++){
      var src=String(candidates[i]||'');
      // Only existing Shopify-hosted product media; reject CSS/HTML delimiters.
      if(/^https:\/\/(?:cdn\.shopify\.com|johnselectrical\.co\.uk)\/[A-Za-z0-9_./%?=&+~:@,-]+$/.test(src))return 'product-photo:'+src;
    }
    return null;
  }
  var artBeforeFullCoverage=artFor;
  artFor=function(p,cards){
    var out=artBeforeFullCoverage(p,cards).slice(),used=Object.create(null),product=coverageProductPhoto(p);
    var productPhotos=[product].concat((p.photos||[]).map(function(photo){return coverageProductPhoto({img:photo.src});})).filter(Boolean);
    out.forEach(function(id){if(id)used[id]=true;});
    var topics={
      fit:['library-02-measuring'],energy:['extra-energy-neutral','library-06-energy'],
      sound:['library-09-sound'],quiet:['library-09-sound'],
      connected:['library-07-connected'],apps:['library-07-connected'],
      screen:['library-10-colour','library-15-motion'],backlight:['library-10-colour'],processor:['library-10-colour'],rgb:['library-10-colour'],
      portable:['library-11-portable'],cooling:['library-12-cooling'],
      clean:['library-16-cleaning'],wetclean:['library-16-cleaning'],hygiene:['library-16-cleaning'],
      stains:['library-03-fabric-care','library-16-cleaning'],steam:['library-17-steam'],
      timer:['library-22-time'],airflow:['library-23-air'],filtration:['library-23-air'],reach:['library-02-measuring'],
      cable:['library-02-measuring'],
      battery:['extra-charging-neutral'],power:['extra-energy-neutral'],
      shield:['library-13-safety'],blend:['library-20-blending'],brew:['library-19-coffee'],
      zones:['library-18-two-dishes'],drum:['library-04-laundry','library-03-fabric-care']
    };
    cards.map(function(c,i){return i;}).sort(function(a,b){return JSON.stringify(cards[a]).localeCompare(JSON.stringify(cards[b]));}).forEach(function(i){
      if(out[i])return;
      var c=cards[i],t=artTile(p,c),d=t.device,w=artText(t)+" "+artNorm(c.label),pool=(topics[c.kind]||[]).slice();
      var laundry=/^(washer|washerdryer|dryer)$/.test(d)||/laundry|washing machine|tumble|\bspin\b/.test(w);
      var cooking=/^(oven|cooker|hob|microwave|airfryer)$/.test(d)||/\b(?:toaster|grill|rice cooker|multi.cooker|pressure cooker)\b/.test(artNorm(p.title));
      if(c.kind==='drying')pool=laundry?['library-04-laundry','library-03-fabric-care']:['library-16-cleaning','library-05-water'];
      if(c.kind==='heat'||c.kind==='temperature'||c.kind==='hob')pool=cooking?['library-08-even-cooking','library-18-two-dishes']:[];
      if(/steam/.test(w)&&/^(power|capacity|sensor)$/.test(c.kind))pool.push('library-17-steam');
      if(/water|tank/.test(w)&&/^(capacity|interior)$/.test(c.kind))pool.push('library-05-water');
      if(/clean|surface|brush/.test(w)&&/^(design|tools|bin)$/.test(c.kind)&&!/hair dryer|styler/.test(artNorm(p.title)))pool.push('library-16-cleaning');
      if(/\bpet|four.legged|hair/.test(w)&&/^(brushroll|tools)$/.test(c.kind)&&!/hair dryer|styler/.test(artNorm(p.title)))pool.push('library-24-pets');
      if(c.kind==='apps'&&/record|hours|stored/.test(w))pool.unshift('library-22-time');
      if(c.kind==='connected'&&/hdmi|usb|port/.test(w))pool.push('extra-wired-ports');
      if(cooking&&c.kind==='controls')pool.push('library-08-even-cooking');
      if(cooking&&c.kind==='design'&&/four in one|replaces|cooking/.test(w))pool.push('library-18-two-dishes');
      if(/hair dryer|styler/.test(artNorm(p.title))){
        if(/concentrator/.test(w))pool.push('library-23-air');
        if(/curl/.test(w))pool.push('library-15-motion');
        if(/paddle/.test(w))pool.push('library-11-portable');
      }
      if(c.kind==='capacity'&&/\blitres?\b|\bml\b/.test(w))pool.push('library-05-water');
      if(c.kind==='tools'&&/kilos?|\bkg\b|weight/.test(w))pool.push('library-14-sensing');
      if(c.kind==='capacity'||c.kind==='interior'||c.kind==='programmes'){
        if(laundry)pool=pool.concat(['library-04-laundry','library-03-fabric-care']);
        else if(cooking)pool=pool.concat(['library-18-two-dishes','library-08-even-cooking']);
        else if(/^(fridge|freezer|fridgefreezer)$/.test(d))pool=pool.concat(['library-12-cooling']);
        else if(d==='dishwasher')pool=pool.concat(['library-16-cleaning','library-05-water']);
        else if(d==='coffee')pool=pool.concat(['library-19-coffee']);
        else if(d==='kettle')pool=pool.concat(['library-05-water']);
      }
      // Structural/controls/design details always have the item's own picture as a safe fallback.
      pool=pool.concat(productPhotos);
      if(c.kind==='design'&&/design|finish|shape|soleplate/.test(artNorm(c.label)))pool.push('library-01-materials');
      if(!pool.length)pool=['library-02-measuring'];
      var id=pool.filter(function(id){return !used[id];})[0]||pool[0];
      out[i]=id;used[id]=true;
    });
    return out;
  };
  var buildBeforeVisualSpacing = build;
  build = function(p){
    var cards=buildBeforeVisualSpacing(p), arts=artFor(p,cards);
    if(cards.length<3||arts.length!==cards.length)return cards;
    var photoKeys=cards.map(function(c,i){
      if(arts[i])return 'art:'+arts[i];
      var html=c.kind==='programmes'?productControls(p,c):'', m=/\b(?:href|src)=["']([^"']+)/.exec(html||'');
      return m?'product:'+m[1].split('?')[0]:null;
    });
    var families={
      'laundry-capacity':'fabric','drying':'fabric','extra-steam-care':'fabric','extra-hygiene-care':'fabric','library-03-fabric-care':'fabric','library-04-laundry':'fabric','library-16-cleaning':'fabric','library-24-pets':'fabric',
      'fridge-capacity':'food','fridge-interior':'food','extra-fridge-shelves':'food','oven-capacity':'food','two-ovens':'food','extra-oven-heat':'food','extra-grill-brown':'food','extra-airfry-crisp':'food','new-chilled-and-frozen':'food','new-cooking-versatility':'food','library-08-even-cooking':'food','library-18-two-dishes':'food','library-19-coffee':'food','library-20-blending':'food',
      'no-frost':'frozen','cold-room':'frozen','extra-freezer-drawers':'frozen','extra-freezer-interior':'frozen','library-12-cooling':'frozen',
      'energy':'energy','extra-energy-neutral':'energy','library-06-energy':'energy',
      'tv-detail':'bird','upscaling':'bird','motion':'bird',
      'extra-control-dial':'controls','extra-control-touch':'controls'
    };
    function family(i){return arts[i]?(families[arts[i]]||arts[i]):(photoKeys[i]?'product':'blank');}
    function cost(order){var s=0;for(var i=1;i<order.length;i++)for(var gap=1;gap<=2&&gap<=i;gap++){
      var a=order[i],b=order[i-gap];
      if(photoKeys[a]&&photoKeys[a]===photoKeys[b])s+=1000;
      if(family(a)===family(b))s+=(family(a)==='blank'?1:5)*(gap===1?2:1);
    }return s;}
    var natural=cards.map(function(_,i){return i;}), middle=natural.slice(1),tail=[];
    if(cards[cards.length-1].kind==='delivery')tail=[middle.pop()];
    var beam=[{order:[0],left:middle,score:0}];
    while(beam[0].left.length){var next=[];beam.forEach(function(v){v.left.forEach(function(idx,pos){var o=v.order.concat(idx),left=v.left.slice();left.splice(pos,1);next.push({order:o,left:left,score:cost(o)});});});
      next.sort(function(a,b){return a.score-b.score||a.order.join(',').localeCompare(b.order.join(','));});beam=next.slice(0,32);
    }
    var candidates=beam.map(function(v){return v.order.concat(tail);});candidates.push(natural);
    candidates.sort(function(a,b){return cost(a)-cost(b)||a.reduce(function(n,x,i){return n+(x!==i);},0)-b.reduce(function(n,x,i){return n+(x!==i);},0);});
    for(var n=0;n<candidates.length;n++){
      var order=candidates[n],result=order.map(function(i){return cards[i];}), check=artFor(p,result);
      if(check.length===arts.length&&check.every(function(id,i){return id===arts[order[i]];}))return result;
    }
    return cards;
  };
  function artLayer(id){
    var v = artOwn(ARTR.v, id) ? ARTR.v[id] : null;
    if(!ART_BASE || !v || !/^[a-z0-9-]+$/.test(id)) return '';
    function u(w){ return ART_BASE + 'je-glance-' + id + '-' + w + '.jpg?v=' + v[w]; }
    return '<span class="hb-art" hidden aria-hidden="true" style="--art:url(\'' + u(1600) + '\');--art-sm:url(\'' + u(800) + '\')"></span>';
  }
  /* je-glance-art-spacing-20260919 */
  var octoberPhotoFiles = {"new-water-beading":["je-glance-new-water-beading-1536.jpg?v=90c985ce2ed7","je-glance-new-water-beading-800.jpg?v=28d58c38761e"],"new-chilled-and-frozen":["je-glance-new-chilled-and-frozen-1536.jpg?v=d205699882de","je-glance-new-chilled-and-frozen-800.jpg?v=df1aa64d840b"],"new-cooking-versatility":["je-glance-new-cooking-versatility-1536.jpg?v=15370b098842","je-glance-new-cooking-versatility-800.jpg?v=3ab8fab386af"],"new-delivery-van":["je-glance-new-delivery-van-1000.webp?v=ed8e8a02b057","je-glance-new-delivery-van-500.webp?v=7d64afcd97d0"]};
  var artLayerBeforeOctoberPhotos=artLayer;
  artLayer=function(id){
    if(!artOwn(octoberPhotoFiles,id))return artLayerBeforeOctoberPhotos(id);
    if(!ART_BASE)return '';
    var f=octoberPhotoFiles[id];
    return '<span class="hb-art" hidden aria-hidden="true" style="--art:url(\''+ART_BASE+f[0]+'\');--art-sm:url(\''+ART_BASE+f[1]+'\')"></span>';
  };
  var libraryPhotoFiles = {"library-01-materials":["je-glance-library-01-materials-1536.jpg?v=022cf4b0f167","je-glance-library-01-materials-800.jpg?v=3d4452356eac"],"library-02-measuring":["je-glance-library-02-measuring-1536.jpg?v=1386f002d3ee","je-glance-library-02-measuring-800.jpg?v=f70f7fb10dc8"],"library-03-fabric-care":["je-glance-library-03-fabric-care-1536.jpg?v=21ee9d0d76de","je-glance-library-03-fabric-care-800.jpg?v=eb30c005dfd1"],"library-04-laundry":["je-glance-library-04-laundry-1536.jpg?v=9aaccddbf52f","je-glance-library-04-laundry-800.jpg?v=042b84e1ff14"],"library-05-water":["je-glance-library-05-water-1536.jpg?v=1e8339b35e1d","je-glance-library-05-water-800.jpg?v=ff16c4518c29"],"library-06-energy":["je-glance-library-06-energy-1536.jpg?v=6a029edf95de","je-glance-library-06-energy-800.jpg?v=b797f8de9db6"],"library-07-connected":["je-glance-library-07-connected-1536.jpg?v=5ec31f33d06b","je-glance-library-07-connected-800.jpg?v=9c06e61dba4c"],"library-08-even-cooking":["je-glance-library-08-even-cooking-1536.jpg?v=10eae09f5618","je-glance-library-08-even-cooking-800.jpg?v=ff5f80fc8cd4"],"library-09-sound":["je-glance-library-09-sound-1536.jpg?v=2e3254f7083a","je-glance-library-09-sound-800.jpg?v=280566203a17"],"library-10-colour":["je-glance-library-10-colour-1536.jpg?v=820dacfa394c","je-glance-library-10-colour-800.jpg?v=02ad66017e0d"],"library-11-portable":["je-glance-library-11-portable-1536.jpg?v=f63760968cb0","je-glance-library-11-portable-800.jpg?v=5d4894eea027"],"library-12-cooling":["je-glance-library-12-cooling-1536.jpg?v=2e9e935a688f","je-glance-library-12-cooling-800.jpg?v=baeecd07582a"],"library-13-safety":["je-glance-library-13-safety-1536.jpg?v=e80bbf2f693a","je-glance-library-13-safety-800.jpg?v=4cf45634039f"],"library-14-sensing":["je-glance-library-14-sensing-1536.jpg?v=3be3b5356d79","je-glance-library-14-sensing-800.jpg?v=e57261d65149"],"library-15-motion":["je-glance-library-15-motion-1536.jpg?v=74da4f4d84cd","je-glance-library-15-motion-800.jpg?v=d97d9bb508d5"],"library-16-cleaning":["je-glance-library-16-cleaning-1536.jpg?v=36437a436e02","je-glance-library-16-cleaning-800.jpg?v=796ccd55ca2c"],"library-17-steam":["je-glance-library-17-steam-1536.jpg?v=9544e6419d32","je-glance-library-17-steam-800.jpg?v=42390cd28619"],"library-18-two-dishes":["je-glance-library-18-two-dishes-1536.jpg?v=43be82268d44","je-glance-library-18-two-dishes-800.jpg?v=09ddf0a67a38"],"library-19-coffee":["je-glance-library-19-coffee-1536.jpg?v=628d48b39a74","je-glance-library-19-coffee-800.jpg?v=4576f730b725"],"library-20-blending":["je-glance-library-20-blending-1536.jpg?v=fb28a54db443","je-glance-library-20-blending-800.jpg?v=ac4efec9f879"],"library-21-charge":["je-glance-library-21-charge-1536.jpg?v=ae2012c23168","je-glance-library-21-charge-800.jpg?v=02e2d47ea8d3"],"library-22-time":["je-glance-library-22-time-1536.jpg?v=4e63aeaf0dc4","je-glance-library-22-time-800.jpg?v=294868bbde02"],"library-23-air":["je-glance-library-23-air-1536.jpg?v=c96ee4297fdf","je-glance-library-23-air-800.jpg?v=4b90fafaaa9b"],"library-24-pets":["je-glance-library-24-pets-1536.jpg?v=28e005875a21","je-glance-library-24-pets-800.jpg?v=ae7f1621c205"]};
  var artLayerBeforePhotoLibrary=artLayer;
  artLayer=function(id){
    if(!artOwn(libraryPhotoFiles,id))return artLayerBeforePhotoLibrary(id);
    if(!ART_BASE)return '';
    var f=libraryPhotoFiles[id];
    return '<span class="hb-art" hidden aria-hidden="true" style="--art:url(\''+ART_BASE+f[0]+'\');--art-sm:url(\''+ART_BASE+f[1]+'\')"></span>';
  };
  var artLayerBeforeFullCoverage=artLayer;
  artLayer=function(id){
    if(String(id).indexOf('product-photo:')!==0)return artLayerBeforeFullCoverage(id);
    var src=String(id).slice(14);
    if(coverageProductPhoto({img:src})!==id)return '';
    return '<span class="hb-art" hidden aria-hidden="true" style="--art:url(\''+esc(src)+'\');--art-sm:url(\''+esc(src)+'\')"></span>';
  };
  function render(p){
    var cards=build(p),arts=artFor(p,cards);
    return '<section id="highlights" class="block hb-section"><div class="highlights-head"><div><span class="hb-eyebrow">THE SHORT VERSION</span><h2 class="giant rv">At a glance.</h2></div></div><div class="hl-deck rv" tabindex="0" role="group" aria-roledescription="carousel" aria-label="Product highlights">'+
      cards.map(function(c,i){
        var art=arts[i]?'':visual(p,c),layer=arts[i]?artLayer(arts[i]):'';
        return '<div class="hcard hb-card'+(layer?' hb-has-art" data-glance-art="'+arts[i]:'')+'" role="group" aria-roledescription="slide" aria-label="'+(i+1)+' of '+cards.length+' · '+esc(c.label)+'" data-brief-kind="'+c.kind+'"><span class="glow" style="background:'+(['#325abb','#266b92','#694aa1'][i%3])+'"></span>'+'<div class="hb-shell"><div class="hb-top"><span class="hb-section-name"><span class="hb-index">'+String(i+1).padStart(2,'0')+'</span>'+esc(c.label)+'</span><span class="hb-position">'+String(i+1).padStart(2,'0')+' / '+String(cards.length).padStart(2,'0')+'</span></div><div class="hb-main'+(art?' hb-main-photo':'')+'"><div class="hb-copy"><h3>'+c.title.split('\n').map(esc).join('<br>')+'</h3>'+layer+(c.line?'<p class="hb-line">'+esc(c.line)+'</p>':'')+'</div>'+art+'</div>'+
          '<div class="hb-facts" data-size="'+c.facts.length+'">'+c.facts.map(function(f){return '<div class="hb-fact'+(f[0].length>13?' hb-fact-long':'')+'"><strong>'+esc(f[0])+'</strong>'+(f[1]?'<span>'+esc(f[1])+'</span>':'')+'</div>';}).join('')+'</div><div class="hb-bottom"><span class="hb-note">'+esc(c.note || 'Swipe to explore')+'</span><a href="'+esc(c.href)+'" class="hb-detail" data-brief-index="'+i+'"'+(c.pane?' data-brief-pane="'+c.pane+'"':'')+'>See details <span aria-hidden="true">↗</span></a></div></div></div>';
      }).join('')+'</div><div class="hl-nav rv"><div class="hl-dots" data-hl-dots></div><div class="highlight-controls" aria-label="Highlight carousel controls" hidden><button type="button" class="highlight-arrow" data-highlight-dir="-1" aria-label="Previous highlights" disabled><svg viewBox="0 0 24 24" aria-hidden="true"><path d="m15 18-6-6 6-6"></path></svg></button><button type="button" class="highlight-arrow" data-highlight-dir="1" aria-label="Next highlights"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="m9 6 6 6-6 6"></path></svg></button></div><p class="hl-count" data-hl-count aria-live="polite" aria-atomic="true"></p></div></section>';
  }
  function bind(deck){
    var section=deck.closest('.hb-section');if(!section)return function(){};
    var visible=false;
    var media=window.matchMedia('(prefers-reduced-motion: reduce)'),alive=true,lastWidth=0;
    // Reserve the tallest natural card once, then on resize/font changes only.
    // Hidden cards are measured in the same synchronous layout pass and restored
    // before paint. This never runs in the pointermove/animation path.
    function equalize(){
      if(!alive)return;
      // Record this measurement so the first ResizeObserver delivery does not
      // repeat the same synchronous all-card layout at an unchanged width.
      lastWidth=deck.offsetWidth;
      deck.style.removeProperty('--hb-card-height');
      var cards=Array.from(deck.querySelectorAll('.hb-card')),hidden=cards.map(function(c){return c.hidden;});
      cards.forEach(function(c){c.hidden=false;});
      var height=Math.max.apply(null,cards.map(function(c){return c.offsetHeight;}));
      cards.forEach(function(c,i){c.hidden=hidden[i];});
      deck.style.setProperty('--hb-card-height',height+'px');
    }
    equalize();
    // je-glance-ro-frame-20261103: avoid sizing mutations during ResizeObserver delivery.
    var equalizeFrame=0;
    function scheduleEqualize(){
      if(!alive || equalizeFrame)return;
      equalizeFrame=requestAnimationFrame(function(){equalizeFrame=0;if(alive)equalize();});
    }
    var sizes=new ResizeObserver(function(){var w=deck.offsetWidth;if(w!==lastWidth){lastWidth=w;scheduleEqualize();}});
    sizes.observe(deck);window.addEventListener('resize',scheduleEqualize);
    if(document.fonts)document.fonts.ready.then(scheduleEqualize);
    /* je-glance-no-visuals-20260917: no drawings, so no pause control; the class still
       gates the tile's own glow morph: on screen, tab visible, motion allowed. */
    function sync(){
      section.classList.toggle('hb-motion-on',visible && !document.hidden && !media.matches);
    }
    function detail(e){var link=e.target.closest('[data-brief-pane]');if(!link)return;var tab=document.querySelector('[data-pane="'+link.getAttribute('data-brief-pane')+'"]');if(tab)tab.click();}
    var io = new IntersectionObserver(function(entries){visible=entries[0].isIntersecting;sync();},{threshold:0});
    io.observe(section);section.addEventListener('click',detail);document.addEventListener('visibilitychange',sync);media.addEventListener('change',sync);sync();
    return function(){alive=false;if(equalizeFrame)cancelAnimationFrame(equalizeFrame);equalizeFrame=0;io.disconnect();sizes.disconnect();window.removeEventListener('resize',scheduleEqualize);section.removeEventListener('click',detail);document.removeEventListener('visibilitychange',sync);media.removeEventListener('change',sync);};
  }
  global.JE_BRIEF_CARDS={build:build,render:render,bind:bind,artFor:artFor};
})(window);

/* ============================================================
   Johns Electrical — Feature Tour Engine
   Renders the showcase hub (no ?p=) or one product's tour (?p=handle)
   from the je-feature-tours.json asset. Prices/availability hydrate
   LIVE from /products/<handle>.js at tour open, so the frozen asset
   can never sell a stale price.
   ============================================================ */
(function(){
"use strict";
var reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
var app = document.getElementById("app");
var MODE = window.JE_TOUR_MODE === "pdp" ? "pdp" : "showcase";
var MANUAL_OOS = MODE === "pdp" && window.JE_TOUR_MANUAL_OOS === true;
var DATA = null, byHandle = {};
var LANE = "stock";          // je-pdp-truth-20260901: the availability lane this page renders
var cleanup = [];           // per-view teardown fns
var rafAlive = false;       // single rAF loop guard
document.documentElement.classList.add("je-smooth");
if(MODE === "pdp") document.body.classList.add("je-tour-pdp");

/* ---------------- utils ---------------- */
/* je-pdp-truth-20260901: DNA, spec rows and closer bullets arrive with HTML
   entities already in them ("Terrestrial &amp; satellite tuners" printed
   literally on the live Sony page), and esc() was escaping the ampersand a
   second time. Decode the handful of entities copy carries FIRST, then
   escape exactly once. */
function decodeEntities(s){
  return s.replace(/&(amp|lt|gt|quot|#39|apos|nbsp|#160|Prime|sup2|deg|prime|mdash);/g, function(_m, e){
    return {amp:"&", lt:"<", gt:">", quot:'"', "#39":"'", apos:"'", nbsp:" ", "#160":" ", Prime:"″", sup2:"²", deg:"°", prime:"′", mdash:"—"}[e];
  });
}
function esc(s){
  s = decodeEntities(String(s == null ? "" : s).replace(/�/g, ""));
  s = s.replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;");
  // re-allow the one tag DNA copy may carry
  return s.replace(/&lt;b&gt;/g,"<b>").replace(/&lt;\/b&gt;/g,"</b>");
}
function attr(s){
  return decodeEntities(String(s == null ? "" : s).replace(/�/g, ""))
    .replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;")
    .replace(/"/g,"&quot;").replace(/'/g,"&#39;");
}
function money(n){
  if(window.JE_CATALOGUE_MAINTENANCE) return "";
  n = Number(n);
  var whole = Math.floor(n) === n;
  return "£" + n.toLocaleString("en-GB", {minimumFractionDigits: whole?0:2, maximumFractionDigits: whole?0:2});
}
function shortProductName(p){
  /* PDP Liquid supplies the source-guarded Brand + core product + colour title.
     Showcase data keeps its fuller card/search display string. */
  var liquidName = MODE === "pdp" ? String(window.JE_TOUR_SHORT_NAME || "").trim() : "";
  if(liquidName) return liquidName;
  return String(p.display || p.title || p.type || "Product").trim() || "Product";
}
/* je-product-brand-gold-20260905: same exact vendor-prefix match as the Liquid first paint. */
function productTitleHTML(p){
  var title = shortProductName(p);
  var brand = MODE === "pdp" ? String(window.JE_TOUR_VENDOR || p.vendor || "").trim() : "";
  var boundary = title.charAt(brand.length);
  if(brand && title.slice(0, brand.length).toLowerCase() === brand.toLowerCase() && (!boundary || boundary === " ")){
    return '<span class="je-product-brand">' + esc(title.slice(0, brand.length)) + '</span>' + esc(title.slice(brand.length));
  }
  return esc(title);
}
function productCode(p){
  /* In PDP mode Liquid supplies the source-guarded Shopify model code. The tour
     payload's model is only a fallback for the standalone showcase surface. */
  if(MODE === "pdp") return String(window.JE_TOUR_PRODUCT_CODE || "").trim();
  return String(p.model || "").trim();
}
function el(q, root){ return (root||document).querySelector(q); }
function els(q, root){ return Array.prototype.slice.call((root||document).querySelectorAll(q)); }
function on(target, ev, fn, opts){
  target.addEventListener(ev, fn, opts);
  cleanup.push(function(){ target.removeEventListener(ev, fn, opts); });
}
function nearViewport(elm, slack){
  var r = elm.getBoundingClientRect();
  return r.bottom > -slack && r.top < window.innerHeight + slack;
}
function thumb(url, w){
  if(!url) return "";
  if(/[?&]width=\d+/i.test(url)) return url.replace(/([?&]width=)\d+/i, "$1" + w);
  return url + (url.indexOf("?") > -1 ? "&" : "?") + "width=" + w;
}
function photoImg(photo, className, eager, sizes, widths){
  /* Serve the sharpest useful source without asking Shopify to invent pixels.
     The final candidate is capped by the reviewed photo's real width and by the
     largest slot this tour can render at 2x density. */
  var nativeWidth = Math.max(1, parseInt(photo.w, 10) || 1200);
  var maxWidth = Math.min(nativeWidth, 2200);
  widths = (widths || [480, 760, 1100, 1400, 1800, 2200]).filter(function(w){
    return w <= maxWidth;
  });
  if(!widths.length || widths[widths.length-1] !== maxWidth) widths.push(maxWidth);
  widths = widths.filter(function(w, i){ return !i || w !== widths[i-1]; });
  var srcset = widths.map(function(w){ return attr(thumb(photo.src, w)) + " " + w + "w"; }).join(", ");
  var fit = Array.isArray(photo.fit) && photo.fit.length === 4
    ? ' data-product-fit="' + attr(photo.fit.join(",")) + '"' : "";
  return '<img class="' + attr(className || "") + '" src="' + attr(thumb(photo.src, widths[widths.length-1])) +
    '" srcset="' + srcset + '" sizes="' + attr(sizes || "100vw") + '" width="' +
    Math.max(1, parseInt(photo.w, 10) || 1200) + '" height="' +
    Math.max(1, parseInt(photo.h, 10) || 1200) + '" alt="' + attr(photo.alt || "") + '"' +
    fit +
    (eager ? ' loading="eager" fetchpriority="high"' : ' loading="lazy"') +
    ' decoding="async">';
}

/* A reviewed TV overlay is not another product photo. It is the exact source
   photograph painted through a tightly reviewed inset on top of the matching
   transparent frame, so the bezel, body and feet always remain the base image. */
function validPhotoOverlay(photo){
  var overlay = photo && photo.overlay;
  if(!isRealProductPhoto(overlay) || !Array.isArray(overlay.clip) || overlay.clip.length !== 4){
    return null;
  }
  var clip = overlay.clip;
  if(clip.some(function(v){ return typeof v !== "number" || !isFinite(v) || v < 0 || v > 1; })){
    return null;
  }
  return {photo: overlay, clip: clip.slice()};
}
function photoOverlayImg(photo, className, eager, sizes, widths){
  var valid = validPhotoOverlay(photo);
  if(!valid) return "";
  var aligned = {};
  Object.keys(valid.photo).forEach(function(k){ aligned[k] = valid.photo[k]; });
  aligned.alt = "";
  aligned.w = photo.w;
  aligned.h = photo.h;
  if(Array.isArray(photo.fit) && photo.fit.length === 4) aligned.fit = photo.fit.slice();
  else delete aligned.fit;
  var html = photoImg(aligned, (className || "") + " product-photo-overlay", eager, sizes, widths);
  return html.replace("<img ", '<img aria-hidden="true" tabindex="-1" data-overlay-clip="' +
    attr(valid.clip.join(",")) + '" ');
}
function productPhotoHTML(photo, className, eager, sizes, widths){
  return photoImg(photo, className, eager, sizes, widths) +
    photoOverlayImg(photo, className, eager, sizes, widths);
}

/* Product View only accepts explicit image objects backed by a normal web URL.
   A missing image fails closed: it must never bring the old CSS product art (or
   a data-URI illustration) back onto a customer-facing page. */
function isRealProductPhoto(photo){
  if(!photo || typeof photo !== "object" || typeof photo.src !== "string") return false;
  var src = photo.src.trim();
  var classification = String(photo.kind || "") + " " + String(photo.role || "");
  if(!src || (!/^(?:https:)?\/\//i.test(src) && src.charAt(0) !== "/")) return false;
  if(/^(?:data|blob|javascript):/i.test(src)) return false;
  if(photo.generated === true || photo.placeholder === true || photo.synthetic === true) return false;
  if(/\b(?:generated|placeholder|synthetic|illustration)\b/i.test(classification)) return false;
  if(/(?:^|[\/_\-.])placeholder(?:[\/_\-.?]|$)/i.test(src)) return false;
  return true;
}
function photoKey(photo){
  try{
    var u = new URL(photo.src, window.location.origin);
    ["width","height","crop","quality","format","v"].forEach(function(k){
      u.searchParams.delete(k);
    });
    return u.origin + u.pathname + (u.searchParams.toString() ? "?" + u.searchParams.toString() : "");
  }catch(_e){ return String(photo.src).split("#")[0]; }
}
function uniqueProductPhotos(list){
  var seen = {}, out = [];
  (list || []).forEach(function(photo){
    if(!isRealProductPhoto(photo)) return;
    var key = photoKey(photo);
    if(seen[key]) return;
    seen[key] = true;
    out.push(photo);
  });
  return out;
}
function productPhotoSet(p){
  /* p.photos is the reviewed exact-product collection. Until a product has
     that collection, its known exact hero is the sole safe fallback; legacy
     p.media is deliberately not promoted into the new photo story. */
  var reviewed = Array.isArray(p.photos) ? uniqueProductPhotos(p.photos) : [];
  var all = reviewed.length ? reviewed : uniqueProductPhotos([p.hero]);
  var hero = null;
  all.some(function(photo){
    var role = String(photo.role || "").toLowerCase();
    if(role === "hero" || role === "main" || role === "primary"){
      hero = photo; return true;
    }
    return false;
  });
  hero = hero || all[0] || null;
  if(hero){
    var heroKey = photoKey(hero);
    all = [hero].concat(all.filter(function(photo){ return photoKey(photo) !== heroKey; }));
  }
  return {
    hero: hero,
    all: all,
    /* One main view plus at most five deliberate alternates keeps the page
       cinematic instead of turning every chapter into a catalogue strip. */
    story: hero ? all.slice(1, 6) : []
  };
}
function productGallerySet(p, editorialSet){
  /* The cinematic story above remains restricted to reviewed cut-outs.  The
     final Photos rail has a different job: show every explicit Shopify gallery
     image, in source order, without allowing those raw images into the hero. */
  var complete = Array.isArray(p.galleryPhotos) ? uniqueProductPhotos(p.galleryPhotos) : [];
  return complete.length ? complete : ((editorialSet && editorialSet.all) || []);
}
function photoLabel(photo, index){
  var label = String(photo.label || "").trim();
  if(label) return label;
  var role = String(photo.role || "").trim().replace(/[-_]+/g, " ");
  if(role && !/^(?:hero|main|primary)$/i.test(role)){
    return role.charAt(0).toUpperCase() + role.slice(1);
  }
  return index === 0 ? "Main product view" : "Product view " + (index + 1);
}
function accessiblePhoto(photo, p, index){
  if(photo.alt) return photo;
  var copy = {};
  Object.keys(photo).forEach(function(k){ copy[k] = photo[k]; });
  copy.alt = (p.title || p.display || p.model || "Product") + " — " + photoLabel(photo, index).toLowerCase();
  return copy;
}

function serviceIcon(kind){
  var path = "";
  if(kind === "delivery"){
    path = '<path d="M3.5 6.75h10.25v9.5H3.5z"/>' +
      '<path d="M13.75 10h3.1l3.65 3.75v2.5h-2"/>' +
      '<path d="M16.25 10v3.75h4.25"/>' +
      '<circle cx="7" cy="17.25" r="1.75"/><circle cx="17.25" cy="17.25" r="1.75"/>';
  }else if(kind === "installation"){
    path = '<path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94z"/>';
  }else{
    path = '<path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.79 19.79 0 0 1 2.12 4.18 2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.69 2.8a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.9.33 1.84.56 2.8.69A2 2 0 0 1 22 16.92z"/>';
  }
  return '<svg class="svc-icon" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">' + path + '</svg>';
}

/* Fit the visible alpha bounds, not the transparent source canvas.  This keeps
   awkward manufacturer angles centred and substantial on every viewport while
   preserving every approved product pixel and never cropping the appliance. */
/* je-pdp-hero-left-rail-20260903: how far inside its own box a LEFT-anchored
   appliance sits.  The box's left edge is already 20px from the page edge (#hero's
   padding), so this is the "little space" on top of that, not the whole gap. */
var FIT_LEFT_INSET = 12;
function fitProductPhoto(img){
  if(img.classList.contains("product-photo-overlay")){
    fitPhotoOverlay(img); return;
  }
  var raw = (img.getAttribute("data-product-fit") || "").split(",").map(Number);
  if(raw.length !== 4 || raw.some(function(v){ return !isFinite(v); })) return;
  var ew = img.clientWidth, eh = img.clientHeight;
  var nw = img.naturalWidth || parseInt(img.getAttribute("width"), 10);
  var nh = img.naturalHeight || parseInt(img.getAttribute("height"), 10);
  if(!ew || !eh || !nw || !nh) return;

  var sourceAspect = nw / nh, elementAspect = ew / eh;
  var ow, oh, ox, oy;
  if(sourceAspect > elementAspect){
    ow = ew; oh = ew / sourceAspect; ox = 0; oy = (eh - oh) / 2;
  } else {
    oh = eh; ow = eh * sourceAspect; oy = 0; ox = (ew - ow) / 2;
  }
  var left = ox + raw[0] * ow, top = oy + raw[1] * oh;
  var right = ox + raw[2] * ow, bottom = oy + raw[3] * oh;
  var bw = Math.max(1, right - left), bh = Math.max(1, bottom - top);
  var isSupport = img.classList.contains("support-product-photo") ||
    img.classList.contains("gallery-product-photo") ||
    img.classList.contains("closer-product-photo");
  var isThumb = img.classList.contains("hub-product-photo");
  var fill = isSupport ? 0.92 : (isThumb ? 0.86 : 0.88);
  var maxScale = isSupport ? 3.4 : (isThumb ? 3.0 : 2.6);
  var scale = Math.max(1, Math.min(maxScale, ew * fill / bw, eh * fill / bh));
  var cx = (left + right) / 2, cy = (top + bottom) / 2;
  var tx = -scale * (cx - ew / 2);
  var ty = -scale * (cy - eh / 2);
  img.style.setProperty("--product-fit-scale", scale.toFixed(4));
  img.style.setProperty("--product-fit-x", tx.toFixed(2) + "px");
  img.style.setProperty("--product-fit-y", ty.toFixed(2) + "px");
  /* je-pdp-hero-left-rail-20260903: the SAME framing, anchored to the box's LEFT
     edge instead of its centre, published as a second variable so the stylesheet
     decides which one a surface uses.  Derived, not guessed: with transform-origin
     50% 50% a point p maps to ew/2 + scale*(p - ew/2) + tx, so landing the alpha
     box's own left edge on FIT_LEFT_INSET needs the tx below.  Math.min clamps it
     to never move the appliance RIGHT of where centring put it - artwork that
     already fills its box must not be pushed out of the stage's overflow:hidden. */
  img.style.setProperty("--product-fit-lx",
    Math.min(tx, FIT_LEFT_INSET - ew / 2 - scale * (left - ew / 2)).toFixed(2) + "px");
  img.classList.add("product-fit-ready");
  var overlay = img.parentElement && img.parentElement.querySelector(".product-photo-overlay");
  if(overlay) fitPhotoOverlay(overlay);
}

function fitPhotoOverlay(img){
  var raw = (img.getAttribute("data-overlay-clip") || "").split(",").map(Number);
  if(raw.length !== 4 || raw.some(function(v){ return !isFinite(v) || v < 0 || v > 1; })) return;
  var ew = img.clientWidth, eh = img.clientHeight;
  var nw = parseInt(img.getAttribute("width"), 10) || img.naturalWidth;
  var nh = parseInt(img.getAttribute("height"), 10) || img.naturalHeight;
  if(!ew || !eh || !nw || !nh) return;

  /* clip values describe the source canvas. Translate them into the rendered
     object-fit:contain rectangle, including any presentation padding. */
  var cs = getComputedStyle(img);
  var pl = parseFloat(cs.paddingLeft) || 0, pr = parseFloat(cs.paddingRight) || 0;
  var pt = parseFloat(cs.paddingTop) || 0, pb = parseFloat(cs.paddingBottom) || 0;
  var cw = Math.max(1, ew - pl - pr), ch = Math.max(1, eh - pt - pb);
  var sourceAspect = nw / nh, contentAspect = cw / ch;
  var ow, oh, ox, oy;
  if(sourceAspect > contentAspect){
    ow = cw; oh = cw / sourceAspect; ox = pl; oy = pt + (ch - oh) / 2;
  }else{
    oh = ch; ow = ch * sourceAspect; oy = pt; ox = pl + (cw - ow) / 2;
  }
  var top = oy + raw[0] * oh;
  var right = ew - ox - ow + raw[1] * ow;
  var bottom = eh - oy - oh + raw[2] * oh;
  var left = ox + raw[3] * ow;
  img.style.setProperty("--overlay-clip-path", "inset(" +
    top.toFixed(2) + "px " + right.toFixed(2) + "px " +
    bottom.toFixed(2) + "px " + left.toFixed(2) + "px)");

  var base = img.parentElement && img.parentElement.querySelector("img:not(.product-photo-overlay)");
  if(base && base.classList.contains("product-fit-ready")){
    /* je-pdp-hero-left-rail-20260903: --product-fit-lx rides along, or a TV's
       exact-source screen photo stays centred while its frame moves left. */
    ["--product-fit-scale","--product-fit-x","--product-fit-y","--product-fit-lx"].forEach(function(k){
      img.style.setProperty(k, base.style.getPropertyValue(k));
    });
    img.classList.add("product-fit-ready");
  }
  if(img.hasAttribute("data-product-fit") && (!base || !base.classList.contains("product-fit-ready"))){
    return;
  }
  img.classList.add("overlay-ready");
}

/* je-pdp-hero-left-rail-20260903: the alpha fit reads the image's CURRENT box, so a
   layout that settles AFTER it runs leaves a translate derived from the old one.  It
   always could - fonts, a late poster - but nothing exposed it while the hero media
   row's width was a constant.  That row now reserves the MEASURED rail width, which
   syncRailGutter publishes a beat after this file first fits, so the photo track goes
   642 -> 560px at 1280 and a left-anchored appliance landed 41px too far left, clipped
   by .hero-photo-stage's overflow:hidden.  A window resize was the only thing that
   ever re-fitted.  Watch the boxes instead: the fit writes custom properties feeding a
   transform, and a transform cannot change the border box being observed, so this
   cannot feed itself. */
var FIT_RO = typeof ResizeObserver === "function" ? new ResizeObserver(function(entries){
  entries.forEach(function(entry){
    var img = entry.target;
    if(!img.complete || !img.naturalWidth) return;
    (img.classList.contains("product-photo-overlay") ? fitPhotoOverlay : fitProductPhoto)(img);
  });
}) : null;
function fitAllProductPhotos(root){
  els('img[data-product-fit],img.product-photo-overlay', root || document).forEach(function(img){
    var fit = img.classList.contains("product-photo-overlay") ? fitPhotoOverlay : fitProductPhoto;
    if(img.complete && img.naturalWidth) fit(img);
    else img.addEventListener("load", function(){ fit(img); }, {once:true});
    if(FIT_RO) FIT_RO.observe(img);
  });
}

var GROUPS = {
  "Televisions":"TV & Audio","TV Accessories":"TV & Audio","Set Top Boxes":"TV & Audio",
  "Blu-ray & DVD Players":"TV & Audio","Audio":"TV & Audio","Soundbars":"TV & Audio",
  "Washing Machines":"Laundry","Washer Dryers":"Laundry","Tumble Dryers":"Laundry",
  "Fridge Freezers":"Refrigeration","Fridges":"Refrigeration","Freezers":"Refrigeration",
  "American Fridge Freezers":"Refrigeration",
  "Cookers":"Cooking","Built-in Ovens":"Cooking","Hobs":"Cooking","Microwaves":"Cooking",
  "Dishwashers":"Dishwashers",
  "Vacuum Cleaners":"Floorcare","Carpet Cleaners":"Floorcare","Floorcare":"Floorcare",
  "Small Appliances":"Small Appliances","Fans & Heaters":"Small Appliances",
  "Accessories":"Small Appliances"
};
function groupOf(t){ return GROUPS[t] || "More"; }

/* ---------------- boot ---------------- */
/* je-pdp-enrich-20260902: a PDP fetches its OWN ~6KB data asset first
   (je-tour-p-<product id>.json, written per product by build_tours_asset and
   published by host_tour_data.py) and only falls back to the fleet file when
   that is missing. Every PDP open was downloading all 270 tours (1.6 MB) to
   render one, and the fleet file grows with every product and every field. */
/* je-tour-first-paint-20260901: and before either fetch, the page itself.  A PDP
   carries its OWN entry inline (<script id="je-tour-inline">, from custom.tour_dna —
   written daily by sync_tour_metafields.py from the same built asset both data
   files above come from), so the tour renders at DOMContentLoaded with no request
   at all.  The per-product asset is the second arm and the fleet file the third.
   Stale = the handle does not match: the section already refuses to inline such
   a value; this is belt and braces. */
function jeInlineTourData(){
  if(MODE !== "pdp") return null;
  var node = document.getElementById("je-tour-inline");
  if(!node) return null;
  try{
    var j = JSON.parse(node.textContent || "");
    if(!j || j.v !== 1 || !j.p || j.h !== window.JE_TOUR_HANDLE ||
       j.p.handle !== window.JE_TOUR_HANDLE) return null;
    return {built: j.built, photoReview: null, products: [j.p], inline: true};
  }catch(_e){ return null; }
}
/* The section hides its no-JS fallback while JS is on and a placeholder hero
   precedes it; when there is genuinely nothing to render — no entry for this
   handle, every fetch failed, or renderTour threw before the swap — the fallback
   has to come back and the placeholder has to stand down. */
function jeRevealFallback(){
  var root = document.querySelector(".je-tour-root");
  if(root) root.classList.add("je-tour-fallback-shown");
  /* je-tour-fallback-transaction-20261015: with a fallback to show, the placeholder hero goes
     altogether rather than waiting hidden. It carries #hero and .rig-real, and a media script
     that finds a #hero would otherwise mount a gallery into a header nobody can see. */
  var pre = el("#app > .je-tour-pre");
  if(pre && el("#app > .je-tour-fallback") && pre.parentNode) pre.parentNode.removeChild(pre);
}
/* je-tour-fallback-transaction-20261015: the server-rendered fallback stays until the tour has
   committed. renderTour() swaps #app's markup and then initTour() wires it; an exception in
   either used to leave a half-built tour with the fallback already destroyed (measured: the
   fallback class set, zero fallback nodes). jeRenderTourCommitted() keeps the ORIGINAL nodes
   (moved, never cloned, so a listener another script bound to them still works), and on any
   synchronous failure tears the partial tour down through the same cleanup list a view change
   uses, puts the originals back without the placeholder hero, undoes the page-level custom
   properties the render wrote, and reveals the fallback. The rollback runs inside the task
   that failed, so the media scripts' observers next see the restored page, never the partial
   one. PDP only: the showcase hub keeps its own error panel and its route() teardown. */
/* A rolled-back render bumps the generation; a deferred callback the failed render queued (a
   timer, a font-ready promise, an idle callback) checks it and does nothing, so nothing writes to
   the restored page after the rollback. Never bumped on the showcase hub, where these are no-ops. */
var JE_VIEW_GEN = 0;
function jeOwned(fn){
  var gen = JE_VIEW_GEN;
  return function(){ if(gen === JE_VIEW_GEN) return fn.apply(this, arguments); };
}
var JE_TX_ROOT_PROPS = ["--pa", "--pa-ink", "--pa-text", "--pb", "--pb-text", "--pc", "--pc-text",
  "--je-name-a", "--je-name-c", "--je-railw"];
function jeRenderTourCommitted(p){
  /* Once the seven-second safety fallback is the shopper's working page, a late
     data/script response must not replace its controls or move their selection. */
  var tourRoot = document.querySelector(".je-tour-root");
  if(tourRoot && tourRoot.classList.contains("je-tour-fallback-shown") && el("#app > .je-tour-fallback")){
    jeRevealFallback();
    return;
  }
  var rootStyle = document.documentElement.style;
  var tx = {
    nodes: Array.prototype.slice.call(app.childNodes),
    appStyle: app.getAttribute("style"),
    progress: el("#progress"),
    progressStyle: el("#progress") ? el("#progress").getAttribute("style") : null,
    cleanupFrom: cleanup.length,
    props: JE_TX_ROOT_PROPS.map(function(n){
      return [n, rootStyle.getPropertyValue(n), rootStyle.getPropertyPriority(n)];
    })
  };
  try{
    renderTour(p);
  }catch(e){
    jeRollbackTour(tx);
    throw e;
  }
}
function jeRollbackTour(tx){
  JE_VIEW_GEN++;
  var undo = cleanup.splice(tx.cleanupFrom);
  undo.forEach(function(f){ try{ f(); }catch(_e){} });
  rafAlive = false;
  JE_SPI_NODE = null; JE_SPI_ANCHOR = null;
  JE_EXPRESS_NODE = null; JE_EXPRESS_ANCHOR = null;
  try{
    var hasFallback = tx.nodes.some(function(n){
      return n.nodeType === 1 && n.classList.contains("je-tour-fallback");
    });
    while(app.firstChild) app.removeChild(app.firstChild);
    tx.nodes.forEach(function(n){
      if(hasFallback && n.nodeType === 1 && n.classList.contains("je-tour-pre")) return;
      app.appendChild(n);
    });
    if(tx.appStyle === null) app.removeAttribute("style"); else app.setAttribute("style", tx.appStyle);
    if(tx.progress){
      if(tx.progressStyle === null) tx.progress.removeAttribute("style"); else tx.progress.setAttribute("style", tx.progressStyle);
    }
    var rootStyle = document.documentElement.style;
    tx.props.forEach(function(s){
      if(s[1]) rootStyle.setProperty(s[0], s[1], s[2]); else rootStyle.removeProperty(s[0]);
    });
  }catch(_e){}
  jeRevealFallback();
}
/* The section server-renders the hero as a placeholder in this engine's own
   markup and classes, and arms its .rv entrance itself.  Read how far each
   element has risen BEFORE the innerHTML swap and hand that to the freshly
   rendered hero: an element the placeholder had already armed continues its 24px
   rise from wherever it was (inline transform for one reflow, then cleared, so
   the .rv transition carries on from the current value with no delay), and an
   element it had not armed yet is left to the reveal engine exactly as before.
   Nothing is written when there is no placeholder (the hub, or a PDP whose
   metafield is missing), so the old path is byte-for-byte the old behaviour. */
var JE_PRE_PARTS = [".eyebrow", "h1", ".je-vitrine", ".je-tour-actions", ".je-klarna-line", ".sub"]; /* je-tour-first-paint-v2-20260902 */
function jeReadPlaceholder(){
  if(MODE !== "pdp") return null;
  var pre = el("#app > .je-tour-pre");
  if(!pre) return null;
  return JE_PRE_PARTS.map(function(sel){
    var n = el(sel, pre);
    if(!n || !n.classList.contains("in")) return null;
    return {sel: sel, transform: getComputedStyle(n).transform};
  });
}
function jeAdoptPlaceholder(state, p){
  if(!state) return;
  var hero = el("#hero", app);
  if(!hero) return;
  /* je-tour-first-paint-v2-20260902: the placeholder showed the Klarna line from the first
     paint when the SERVER said a variant is purchasable (window.JE_TOUR_PURCHASABLE), so the
     rendered hero must not go through its hidden phase: apply it now from the bind-time
     price; hydrate() re-applies the live one moments later and hides it if nothing is buyable. */
  if(p && window.JE_TOUR_PURCHASABLE === true) applyKlarna(Math.round((Number(p.price) || 0) * 100));
  var carried = [];
  state.forEach(function(s){
    if(!s) return;
    var n = el(s.sel, hero);
    if(!n) return;
    n.classList.add("in");
    if(s.transform && s.transform !== "none"){
      n.style.transform = s.transform;
      n.style.transitionDelay = "0s";
      carried.push(n);
    }
  });
  if(!carried.length) return;
  void hero.offsetWidth; /* commit the carried transforms before releasing them */
  carried.forEach(function(n){ n.style.transform = ""; });
  setTimeout(jeOwned(function(){ carried.forEach(function(n){ n.style.transitionDelay = ""; }); }), 1800);
}
/* je-pdp-hero-settle-20261013: the review link under the product name. The words and the markup are the section's
   (snippets/je-product-review-link.liquid, printed in the placeholder hero and handed over as a string), so
   this hero lands on the placeholder's pixels and nothing is inserted after first paint. Nothing on the hub. */
function reviewLinkHTML(){
  return (MODE === "pdp" && typeof window.JE_TOUR_REVIEW_LINK_HTML === "string") ? window.JE_TOUR_REVIEW_LINK_HTML : "";
}
function fetchJSON(u){
  return fetch(u).then(function(r){
    if(!r.ok) throw new Error("data " + r.status);
    return r.json();
  });
}
function loadTourData(){
  var inline = jeInlineTourData(); /* je-tour-first-paint-20260901: the page carries its own entry */
  if(inline) return Promise.resolve(inline);
  var per = MODE === "pdp" ? window.JE_TOUR_PRODUCT_DATA_URL : null;
  if(!per) return fetchJSON(window.JE_TOUR_DATA_URL);
  return fetchJSON(per).then(function(d){
    if(d && d.product && d.product.handle === window.JE_TOUR_HANDLE){
      return {built: d.built, photoReview: d.photoReview, products: [d.product]};
    }
    throw new Error("per-product data mismatch");
  }).catch(function(){ return fetchJSON(window.JE_TOUR_DATA_URL); });
}
function jeDoorFirstFrame(){
  var template = document.getElementById('je-approved-door-template');
  if(!template || !template.content.querySelector('video') || document.visibilityState === 'hidden' ||
     matchMedia('(prefers-reduced-motion: reduce)').matches || (navigator.connection && navigator.connection.saveData)) return Promise.resolve();
  var initialMedia=el('#hero .je-sr-media',app), initialRect=initialMedia && initialMedia.getBoundingClientRect();
  if(initialRect && (initialRect.bottom<=0 || initialRect.top>=innerHeight)) return Promise.resolve();
  return new Promise(function(resolve){
    var timer, settled=false;
    function done(){
      if(settled) return; settled=true;
      clearTimeout(timer); app.removeEventListener('je-door-mounted',check); app.removeEventListener('je-door-first-frame',done);
      if(document.visibilityState === 'hidden'){ resolve(); return; }
      // Let the decoded primary frame actually paint before the long tour's
      // DOM work. A bounded timer also covers a tab hidden between frames.
      var paintTimer=setTimeout(resolve,80);
      requestAnimationFrame(function(){requestAnimationFrame(function(){clearTimeout(paintTimer);resolve();});});
    }
    function check(){
      var media=el('#hero .je-door-media',app), film=media && el('.je-door-film',media), play=media && el('.je-door-play',media);
      if(!film) return;
      var rect=film.getBoundingClientRect();
      if(film.classList.contains('je-door-playing') || (play && !play.hidden) || rect.bottom<=0 || rect.top>=innerHeight) done();
    }
    app.addEventListener('je-door-mounted',check); app.addEventListener('je-door-first-frame',done);
    timer=setTimeout(done,2000); check();
  });
}
loadTourData().then(function(d){
  DATA = d;
  d.products.forEach(function(p){ byHandle[p.handle] = p; });
  if(MODE === "pdp"){
    var p = byHandle[window.JE_TOUR_HANDLE];
    if(p) return jeDoorFirstFrame().then(function(){ jeRenderTourCommitted(p); }); /* primary film first; native SSR commerce stays usable */
    else jeRevealFallback(); // no entry -> the section's server-rendered fallback is shown (je-tour-first-paint-20260901)
  } else {
    route();
    window.addEventListener("popstate", route);
  }
}).catch(function(e){
  if(MODE !== "pdp"){
    app.innerHTML = '<div id="boot"><div>Could not load the showcase data (' + esc(e.message) +
      ') — <a href="/collections/in-stock">browse the In Stock collection instead</a>.</div></div>';
  } else {
    jeRevealFallback(); /* je-tour-first-paint-20260901 */
  }
  /* je-tour-boot-visible-20260827: this catch covers the data fetch AND the whole of
     renderTour/initTour, so on a PDP it used to swallow every render-time exception in
     total silence — the tour would half-build (markup written, counters/reveals/buy-sheet
     wiring dead) with a clean console and nothing to find. Re-throwing on a fresh task
     leaves the visible fallback exactly as it was while putting the error where a page
     error listener and this folder's QA harnesses can see it. */
  setTimeout(function(){ throw e; }, 0);
});

function route(){
  cleanup.forEach(function(f){ try{ f(); }catch(_e){} });
  cleanup = []; rafAlive = false;
  var p = new URLSearchParams(location.search).get("p");
  if(p && byHandle[p]) renderTour(byHandle[p]); else renderHub();
  window.scrollTo(0, 0);
}
function nav(handle){
  history.pushState({}, "", handle ? "?p=" + encodeURIComponent(handle) : location.pathname);
  route();
}

/* ================= HUB ================= */
function renderHub(){
  document.title = "The Johns Showcase";
  document.documentElement.style.removeProperty("--pa");
  document.documentElement.style.removeProperty("--pb");
  document.documentElement.style.removeProperty("--pc");
  document.documentElement.style.removeProperty("--je-name-a");
  document.documentElement.style.removeProperty("--je-name-c");
  var groups = [];
  DATA.products.forEach(function(p){
    var g = groupOf(p.type);
    if(groups.indexOf(g) === -1) groups.push(g);
  });
  groups.sort();
  var h = '<div id="hub"><div class="hubhero">' +
    '<h1>The Johns Showcase</h1>' +
    '<p>Every appliance in stock, given the feature tour it deserves.</p>' +
    '<div class="count">' + DATA.products.length + ' products · tap any card</div>' +
    '</div>' +
    '<div class="filters"><button class="fchip on" data-g="*">All</button>' +
    groups.map(function(g){ return '<button class="fchip" data-g="' + esc(g) + '">' + esc(g) + '</button>'; }).join("") +
    '</div>' +
    '<input id="hubsearch" type="search" placeholder="Search by name or model…" autocomplete="off">' +
    '<div class="grid" id="hubgrid"></div></div>';
  app.innerHTML = h;

  var state = {g:"*", q:""};
  function cards(){
    var q = state.q.toLowerCase();
    var list = DATA.products.filter(function(p){
      if(state.g !== "*" && groupOf(p.type) !== state.g) return false;
      if(q && (p.title + " " + (p.model||"") + " " + p.vendor).toLowerCase().indexOf(q) === -1) return false;
      return true;
    });
    el("#hubgrid").innerHTML = list.length ? list.map(function(p){
      var d = p.dna || {};
      var pal = (d.palette && d.palette.a) || "#2997ff";
      var hubPhoto = productPhotoSet(p).hero;
      return '<button class="pcard" data-h="' + esc(p.handle) + '" style="--ca:' + esc(pal) + '">' +
        '<span class="thumb">' + (hubPhoto ? photoImg(hubPhoto, "hub-product-photo", false,
          "(max-width: 620px) 46vw, 260px", [260, 420]) : "") + '</span>' +
        '<span class="meta">' +
        (p.energy ? '<span class="echip">' + esc(p.energy) + '</span>' : "") +
        '<span class="cat">' + esc(p.type || p.vendor) + '</span>' +
        '<h3>' + esc(p.display || p.title) + '</h3>' +
        '<span class="prices"><span class="pnow">' + money(p.price) + '</span>' +
        (p.was ? '<span class="pwas">' + money(p.was) + '</span>' : "") + '</span>' +
        '</span></button>';
    }).join("") : '<div class="hubempty">Nothing matches — try another word.</div>';
    els("#hubgrid .pcard").forEach(function(c){
      c.addEventListener("click", function(){ nav(c.getAttribute("data-h")); });
    });
    fitAllProductPhotos(el("#hubgrid"));
  }
  els(".fchip").forEach(function(f){
    f.addEventListener("click", function(){
      els(".fchip").forEach(function(x){ x.classList.remove("on"); });
      f.classList.add("on"); state.g = f.getAttribute("data-g"); cards();
    });
  });
  el("#hubsearch").addEventListener("input", function(e){ state.q = e.target.value; cards(); });
  cards();
}

/* ================= REAL PRODUCT HERO ================= */
function rigHTML(hero, p, besideVideo){
  if(!isRealProductPhoto(hero)) return "";
  hero = accessiblePhoto(hero, p, 0);
  /* Keep the hero product in its reserved layout slot from first paint.  The
     generic reveal class translates elements downward, which lets a tall
     appliance cross the in-flow Scroll cue before the reveal settles. */
  /* je-pdp-framed-hero-20260902: a hero with no verified cutout is FRAMED — a
     glass panel around a white photo card, none of the cutout-only effects. */
  var framed = !hero.cutout && hero.framed === true;
  return '<div class="rig rig-real' + (hero.cutout ? ' cutout' : (framed ? ' framed' : '')) + '">' +
    '<div class="hero-photo-stage' + (framed ? ' je-glass' : '') + '"><span class="hero-photo-halo" aria-hidden="true"></span>' +
    productPhotoHTML(hero, "hero-product-photo", true,
      besideVideo ? "(max-width: 900px) 94vw, 52vw" : "(max-width: 700px) 94vw, 980px",
      [480, 760, 1100, 1400, 1800, 2200]) +
    '<span class="hero-photo-plinth" aria-hidden="true"></span></div></div>';
}
function photoBeatHTML(media, index, p){
  if(!isRealProductPhoto(media)) return "";
  media = accessiblePhoto(media, p, index + 1);
  var side = index % 2 ? " right" : " left";
  return '<figure class="photo-beat photo-angle' + (media.cutout ? ' cutout' : (media.framed ? ' framed' : '')) + side +
    ' rv" aria-label="Product photography">' +
    '<span class="photo-beat-glow" aria-hidden="true"></span><div class="photo-frame">' +
    productPhotoHTML(media, "support-product-photo", false,
      "(max-width: 700px) 94vw, 780px", [480, 760, 1100, 1400, 1800, 2200]) + '</div>' +
    '</figure>';
}
function MEDIA_KIND(kind){
  return kind === "detail" || kind === "lifestyle" ? kind : "angle";
}
function eqBars(n){
  var s = "";
  for(var i=0;i<n;i++){
    s += '<i style="animation-delay:' + (-(i*137%100)/100).toFixed(2) + 's"></i>';
  }
  return s;
}

/* ================= TOUR ================= */
function paletteRGB(hex){
  var s = String(hex || "").trim().replace(/^#/, "");
  if(s.length === 3) s = s.replace(/./g, function(c){ return c + c; });
  if(!/^[0-9a-f]{6}$/i.test(s)) return null;
  return [parseInt(s.slice(0,2),16), parseInt(s.slice(2,4),16), parseInt(s.slice(4,6),16)];
}
function paletteLuminance(rgb){
  return rgb.reduce(function(sum, value, index){
    var c = value / 255;
    c = c <= .04045 ? c / 12.92 : Math.pow((c + .055) / 1.055, 2.4);
    return sum + c * [0.2126, 0.7152, 0.0722][index];
  }, 0);
}
function paletteButtonInk(hex){
  var rgb = paletteRGB(hex);
  if(!rgb) return "#000";
  var l = paletteLuminance(rgb);
  return 1.05 / (l + .05) >= (l + .05) / .05 ? "#fff" : "#000";
}
function paletteTextOnBlack(hex){
  var rgb = paletteRGB(hex);
  if(!rgb) return "#2997ff";
  for(var mix = 0; mix <= 1; mix += .02){
    var candidate = rgb.map(function(value){ return Math.round(value + (255 - value) * mix); });
    /* Keep a small cushion above 4.5:1: independently safe gradient stops can
       dip a few hundredths while the browser interpolates between them. */
    if((paletteLuminance(candidate) + .05) / .05 >= 4.7){
      return "rgb(" + candidate.join(",") + ")";
    }
  }
  return "#fff";
}
/* je-name-shimmer-depink-pass2-20260826: the name shimmer must never run pink — drop the
   purple/magenta/pink/rose band (hue 255-355, chroma >= 12) from the two
   name-gradient vars only; every other palette surface keeps the brand colour. */
function paletteIsPink(hex){
  var rgb = paletteRGB(hex);
  if(!rgb) return false;
  var mx = Math.max(rgb[0], rgb[1], rgb[2]), mn = Math.min(rgb[0], rgb[1], rgb[2]);
  var d = mx - mn;
  if(d < 12) return false;
  var h;
  if(mx === rgb[0]) h = ((rgb[1] - rgb[2]) / d) % 6;
  else if(mx === rgb[1]) h = (rgb[2] - rgb[0]) / d + 2;
  else h = (rgb[0] - rgb[1]) / d + 4;
  h = (h * 60 + 360) % 360;
  return h >= 255 && h <= 355;
}
/* je-glass-1i-vitrine-20260830: the reference's own five embers, verbatim -
   sliced out of design-reference/je-glass-boxes-reference.html. */
var JE_VITRINE_EMBERS = "<span class=\"je-ember\" style=\"left:16%;width:3px;height:3px;background:rgba(246,199,27,.85);animation-duration:5.4s\"></span><span class=\"je-ember\" style=\"left:38%;width:2.5px;height:2.5px;background:rgba(255,255,255,.7);animation-duration:6.6s;animation-delay:1.4s\"></span><span class=\"je-ember\" style=\"left:57%;width:3px;height:3px;background:rgba(246,199,27,.8);animation-duration:4.8s;animation-delay:2.4s\"></span><span class=\"je-ember\" style=\"left:76%;width:2.5px;height:2.5px;background:rgba(246,199,27,.75);animation-duration:6s;animation-delay:.7s\"></span><span class=\"je-ember\" style=\"left:89%;width:2px;height:2px;background:rgba(255,255,255,.6);animation-duration:5.1s;animation-delay:3.1s\"></span>";
/* ================= AVAILABILITY LANE (je-pdp-truth-20260901) =================
   The theme makes exactly ONE availability decision — je_avail_lane, the ladder
   in product-main.liquid and its parity-checked copy in je-tour-schema — and
   renders it into this page's Product JSON-LD. The engine READS that decision
   rather than re-deriving it (a second availability code path is the thing the
   je-availability-lane-20260808 rule forbids), then re-checks it after
   hydration against the live payload's tags, which are the same evidence the
   ladder reads. The live check can only move a page AWAY from an in-stock
   claim: no tag evidence keeps the server's answer.
   Copy per lane is product-main's own, verbatim, so the two templates agree. */
var LANE_COPY = {
  stock: {line: "\u25cf In stock in Scunthorpe",
          svc: "Delivered by our own team across North Lincolnshire and beyond, free on orders of \u00a3100 or more \u2014 typically within 1\u20133 business days. Or collect in store for free."},
  ato:   {pill: "Available to Order", line: "In store in 1-3 days",
          svc: "Ordered in for you, then delivered by our own team across North Lincolnshire and beyond, free on orders of \u00a3100 or more. Or collect in store for free."},
  oos:   {line: "Call to check availability",
          svc: "Delivered by our own team across North Lincolnshire and beyond once it is back in stock, free on orders of \u00a3100 or more. Or collect in store for free."}
};
function pageLane(){
  var lane = null;
  els('script[type="application/ld+json"]').some(function(s){
    try{
      var d = JSON.parse(s.textContent);
      var list = Array.isArray(d) ? d : [d];
      return list.some(function(x){
        if(!x || x["@type"] !== "Product") return false;
        var a = String((x.offers && x.offers.availability) || "");
        lane = /BackOrder/.test(a) ? "ato" : /InStock/.test(a) ? "stock" : /OutOfStock/.test(a) ? "oos" : null;
        return !!lane;
      });
    }catch(_e){ return false; }
  });
  return lane;
}
function liveLane(live, purchasable){
  var tags = Array.isArray(live && live.tags) ? live.tags : [];
  if(tags.indexOf("supply-hold-call-for-info") > -1) return "oos";
  if(!purchasable) return "oos";
  if(tags.indexOf("available-to-order") > -1 || tags.indexOf("euronics-on-demand") > -1) return "ato";
  return null;
}
/* je-store-stock-20260925 (Will, 2026-09-25): Google's in-store listings are served from
   OUR product pages ("product pages with in-store availability"), which Google approves
   only while each page shows the same in-store availability as its local inventory data;
   a mismatch suspends in-store listings.  So the engine never decides it: the section reads
   custom.store_stock (Google's own store-1 rows, copied onto the product by
   scripts/gmc_store_stock_mirror.py) for the landing variant and hands over
   window.JE_STORE = {line, on}, with the shop list in <template id="jeStoreDetail">.
   A stale copy, a variant Google holds out of stock, or any lane but "stock" prints no
   shop claim, and hydration can only take the claim away (applyLane). */
function storeState(){
  var s = MODE === "pdp" ? window.JE_STORE : null;
  return (s && typeof s.line === "string" && s.line) ? s : null;
}
function storeDetailHTML(lane){
  var s = storeState(), t = document.getElementById("jeStoreDetail");
  return (lane === "stock" && s && s.on === true && t) ? t.innerHTML : "";
}
function stockLineHTML(lane){
  var c = LANE_COPY[lane] || LANE_COPY.stock;
  var line = MODE === "pdp" && lane === "stock" && window.JE_TOUR_SHORTLIST_INSTOCK === true ? "\u25cf In Stock" : c.line;
  var st = storeState(); /* je-store-stock-20260925: the server's in-store answer */
  if(lane === "stock" && st) line = st.line;
  return '<p class="je-stock-line stockline" data-lane="' + attr(lane) + '">' +
    (c.pill ? '<span class="je-avail-pill">' + esc(c.pill) + '</span>' : "") +
    '<span class="je-stock-copy">' + esc(line) + '</span></p>';
}
function applyLane(lane){
  LANE = LANE_COPY[lane] ? lane : "stock";
  els(".stockline", app).forEach(function(n){ n.outerHTML = stockLineHTML(LANE); });
  if(LANE !== "stock") els(".je-store", app).forEach(function(n){ if(n.parentNode) n.parentNode.removeChild(n); }); /* je-store-stock-20260925 */
  var fin = el(".cta-lede", app);
  if(fin) fin.textContent = FINALE_COPY[LANE] || FINALE_COPY.stock;
  var svc = el("#svc-delivery-copy", app);
  if(svc) svc.textContent = LANE_COPY[LANE].svc;
}

/* ================= ENRICHMENT BLOCKS (je-pdp-enrich-20260902) =================
   Every block below renders only when the product carries the data for it.
   p.enrich is written by build_tours_asset.py from data/enrich/verified.json —
   the ONLY writer of that file is verify_enrichment.py, which reproduces each
   claim's evidence itself (official-channel check via YouTube oEmbed, numbers
   present on the manufacturer page, quotes present verbatim on the review page).
   So nothing here can print a claim a script did not re-check. */
var KLARNA_MIN_PENCE = 3500;                 // product-main klarna_min_gbp (35)
var KLARNA_TPL = "3 \u00d7 {amount} interest-free, subject to approval"; // product-main klarna_paylater_note
var KLARNA_NOTE = "available at checkout";   // product-main klarna_note

function safePitch(html){
  /* custom.john_pitch is our own prose, but it is rendered as HTML, so only the
     tags it legitimately carries survive. */
  return String(html || "").replace(/<(?!\/?(?:p|b|strong|em|i|br)\b)[^>]*>/gi, "")
    .replace(/\son\w+="[^"]*"/gi, "");
}
function videoHTML(p, heroPlacement){
  var v = p.enrich && p.enrich.video;
  if(!v || !/^[A-Za-z0-9_-]{11}$/.test(String(v.id || ""))) return "";
  var brand = p.vendor || "the maker";
  var poster = v.posterHi || v.poster;
  var posterSet = v.poster && v.posterHi && v.poster !== v.posterHi
    ? attr(v.poster) + ' 480w, ' + attr(v.posterHi) + ' 1280w' : "";
  var posterSizes = heroPlacement
    ? '(max-width: 900px) calc(100vw - 48px), 44vw'
    : '(max-width: 820px) calc(100vw - 48px), 1040px';
  /* je-tour-video-scope-20260902: the heading must not promise more than the film
     delivers. A model or range film keeps "The official film"; a film about the KIND of
     appliance says so, because the alternative was either dropping useful maker content
     or heading a category tutorial as if it were about this product. `scope` is set by a
     human on the raw record — the verifier proves WHO owns a channel, never what the film
     is about — so an absent scope keeps today's heading and nothing already live moves. */
  var isCat = v.scope === "category";
  var kicker = isCat ? "From the maker" : "See it in motion";
  var head = isCat
    ? 'How it works,<br><span class="dim">explained by ' + esc(brand) + '.</span>'
    : 'The official film,<br><span class="dim">from ' + esc(brand) + '.</span>';
  return '<section id="video"' + (heroPlacement ? ' class="je-video-hero"' : '') + '><div class="wrap">' +
    '<span class="kicker rv">' + kicker + '</span>' +
    '<h2 class="giant rv d1">' + head + '</h2>' +
    '<div class="je-video je-glass rv d2" data-video-id="' + attr(v.id) + '">' +
    '<div class="je-video-frame"><button type="button" class="je-video-play" aria-label="Play the official ' + attr(brand) + ' video">' +
    '<img class="je-video-poster" src="' + attr(poster) + '"' +
    (posterSet ? ' srcset="' + posterSet + '" sizes="' + attr(posterSizes) + '"' : '') +
    ' data-fallback="' + attr(v.poster || "") + '" alt="" loading="lazy" decoding="async" width="1280" height="720">' +
    '<span class="je-video-btn" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M8 5v14l11-7z"/></svg></span>' +
    '</button></div>' +
    '<p class="je-video-cap"><b>' + esc(v.title || "Official video") + '</b>' +
    (v.channel ? ' \u00b7 ' + esc(v.channel) + ' on YouTube' : "") +
    (isCat ? '<span class="je-video-note">General guidance from ' + esc(brand) +
             ', not specific to this model.</span>' : "") + '</p>' +
    '</div></div></section>';
}
function makerHTML(p){
  var en = p.enrich || {};
  var facts = Array.isArray(en.brandFacts) ? en.brandFacts.slice(0, 4) : [];
  if(!facts.length) return "";
  var brand = p.vendor || "the maker";
  return '<section id="maker"><div class="wrap">' +
    '<span class="kicker rv">Straight from ' + esc(brand) + '</span>' +
    '<h2 class="giant rv d1">What ' + esc(brand) + ' built in.</h2>' +
    '<div class="maker-grid rv d2">' + facts.map(function(f){
      return '<article class="maker-card je-glass"><h3>' + esc(f.h) + '</h3><p>' + esc(f.p) + '</p></article>';
    }).join("") + '</div>' +
    (en.manufacturer && en.manufacturer.url ?
      '<p class="maker-src rv d3">From ' + esc(brand) + '\u2019s own product page \u00b7 <a href="' + attr(en.manufacturer.url) +
      '" target="_blank" rel="noopener">' + esc(en.manufacturer.host || "read more") + ' \u2192</a></p>' : "") +
    '</div></section>';
}
function ourTakeHTML(p){
  var pitch = safePitch(p.pitch);
  if(!/<p[\s>]/i.test(pitch) || pitch.replace(/<[^>]+>/g, "").trim().length < 40) return "";
  return '<section id="ourtake"><div class="wrap">' +
    '<span class="kicker rv" style="color:var(--green)">From the shop floor</span>' +
    '<h2 class="giant rv d1">Our take.</h2>' +
    '<div class="ourtake-card je-glass rv d2"><div class="ourtake-copy">' + pitch + '</div>' +
    '<p class="ourtake-sig">\u2014 the team at Johns Electrical, Scunthorpe</p></div>' +
    '</div></section>';
}
function reviewsHTML(p){
  if(MODE === "pdp") return typeof window.JE_SHOWROOM_REVIEW_HTML === "function" ? window.JE_SHOWROOM_REVIEW_HTML(p) : "";
  var en = p.enrich || {};
  var press = Array.isArray(en.press) ? en.press.slice(0, 3) : [];
  var awards = Array.isArray(en.awards) ? en.awards.slice(0, 3) : [];
  if(!press.length && !awards.length) return "";
  return '<section id="reviews"><div class="wrap">' +
    '<span class="kicker rv">Independent reviews</span>' +
    '<h2 class="giant rv d1">' + (press.length ? 'What the reviewers say.' : 'Recognised.') + '</h2>' +
    (awards.length ? '<div class="award-row rv d2">' + awards.map(function(a){
      return '<a class="award-chip" href="' + attr(a.source) + '" target="_blank" rel="noopener nofollow">' +
        '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2l2.9 6.3 6.9.7-5.2 4.7 1.5 6.8L12 17l-6.1 3.5 1.5-6.8L2.2 9l6.9-.7z"/></svg>' +
        esc(a.name) + (a.year ? ' ' + esc(a.year) : "") + '</a>';
    }).join("") + '</div>' : "") +
    (press.length ? '<div class="press-grid rv d3">' + press.map(function(r){
      return '<a class="press-card je-glass" href="' + attr(r.url) + '" target="_blank" rel="noopener nofollow">' +
        '<div class="press-head"><span class="press-outlet">' + esc(r.outlet) + '</span>' +
        (r.verdict ? '<span class="press-verdict">' + esc(r.verdict) + '</span>' : "") + '</div>' +
        '<blockquote>\u201c' + esc(r.quote) + '\u201d</blockquote>' +
        '<span class="press-read">Read the full review \u2192</span></a>';
    }).join("") + '</div>' : "") +
    '<p class="fine rv d4">Short excerpts from independent reviews, each linked in full. They are the reviewers\u2019 opinions, not ours' +
    (press.some(function(r){ return r.match === "range"; }) ? ', and some cover the range this model belongs to' : "") + '.</p>' +
    '</div></section>';
}
function downloadsHTML(p){
  var links = [];
  if(p.energyLabel) links.push(["Energy label", p.energyLabel]);
  if(p.manual) links.push(["Instruction manual", p.manual]);
  if(p.infoSheet) links.push(["Product information sheet", p.infoSheet]);
  if(!links.length) return "";
  return '<div class="spec-downloads rv d3">' + links.map(function(l){
    return '<a class="spec-dl" href="' + attr(l[1]) + '" target="_blank" rel="noopener">' +
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3v12m0 0l-4-4m4 4l4-4M5 21h14"/></svg>' + esc(l[0]) + '</a>';
  }).join("") + '</div>';
}
/* je-spi-promo-20260904: the Shop Pay Installments panel is SERVER-RENDERED by the placeholder
   hero (Liquid's payment_terms filter has no JS equivalent), so the engine never builds
   it. It reserves a slot in its own hero markup, detaches the node before the innerHTML
   swap and drops it into the slot afterwards. The panel carries the placeholder's Klarna
   line INSIDE it (second option), so the engine's own standalone Klarna line is dropped
   when the panel lands - applyKlarna() finds the one inside. The closing #cta echo is
   built from THAT node's text (no credit copy is typed in this file). applySpi() hides
   both with the Klarna line when nothing is buyable, keeps the banner's hidden name="id"
   on the live anchor variant, and re-computes the headline figure from the live price the
   way Shopify computes its own: price / months, rounded half-up to the penny (measured on
   its banner and dialog), the plan rule and every string read from the panel's data-*. */
var JE_SPI_NODE = null;
function spiHTML(){
  if(MODE !== "pdp") return "";
  return '<div class="je-spi-slot" data-je-spi-slot></div>';
}
function jeCarrySpi(){
  var n = el("#app > .je-tour-pre [data-je-spi]");
  JE_SPI_NODE = n || null;
  if(n && n.parentNode) n.parentNode.removeChild(n);
}
function jeAdoptSpi(){
  var slot = el("[data-je-spi-slot]", app);
  if(!slot) return;
  if(!JE_SPI_NODE){
    if(slot.parentNode) slot.parentNode.removeChild(slot);
    var dead = el("[data-je-spi-cta-slot]", app);
    if(dead && dead.parentNode) dead.parentNode.removeChild(dead);
    return;
  }
  slot.parentNode.replaceChild(JE_SPI_NODE, slot);
  /* je-hero-settle-with-spi-20260904: the panel is force-settled (just below), so it defines the
     settled baseline for its column - and .rv holds a 24px DOWNWARD offset, not invisibility,
     until `in` lands. The design leaves 14px under the trust strip, so an un-armed sibling
     above a settled panel lands INSIDE it: measured live, ul.je-trust-strip crossed the
     panel top by exactly 10.0px on both 390x844 and 1440x900, because the reveal observer
     arms at top < 0.75vh and the strip sits 2.1px below that line on a phone. Settling the
     strip alone makes it worse - at 1440 .je-tour-actions is un-armed too and a 24px-low
     button pair then overlaps the settled strip by 8px - so the whole run above the panel
     settles in the same frame, and lands THERE rather than sliding up into place (Will
     2026-09-04: "Just have it there in its own space make sure it doesnt go under any other
     object"). Anything already `in` is skipped, so wherever the staged entrance actually
     played it is unchanged.
     .rvsnap is deliberately NOT used, and this was measured, not assumed: it sets
     transition-duration:0s but .rv.d3 still carries transition-delay:.6s, so a snapped
     element sits out the delay - and jeWriteReveals drops .rvsnap on the next animation
     frame, which is INSIDE that delay, restoring the 1.6s duration. Copying that shape here
     left the strip carrying `in` from 618ms with its rect unmoved until ~2.8s (.6 + 1.6),
     i.e. exactly the slow float this push exists to remove. An inline transition:none beats
     both declarations (neither is !important), one forced read commits the style while it
     is still off, and clearing the inline value afterwards changes no property so nothing
     transitions. One reflow, on a tree the innerHTML swap has just dirtied anyway. */
  var jeSettle = [JE_SPI_NODE], jeSnapped = [];
  for(var jeAbove = JE_SPI_NODE.previousElementSibling; jeAbove; jeAbove = jeAbove.previousElementSibling){
    if(jeAbove.classList.contains("rv")) jeSettle.push(jeAbove);
  }
  var jeNeedsSettle = jeSettle.filter(function(n){
    return !(n.classList.contains("in") && getComputedStyle(n).transform === "none");
  });
  jeNeedsSettle.forEach(function(n){
    /* `in` alone is not "settled" - an element can carry it and still be MID-TRANSITION,
       holding part of its 24px offset for up to 2.2s. Skipping those left the price
       vitrine 8px over the buttons on 360/1280/1440 for about a third of a second, a
       new overlap in place of the one being fixed. The identity transform is the test. */
    n.style.transition = "none"; n.classList.add("in"); jeSnapped.push(n);
  });
  if(jeSnapped.length){
    void app.offsetHeight;
    jeSnapped.forEach(function(n){ n.style.transition = ""; });
  }
  jeScheduleSpiTerms(); /* je-spi-defer-terms-20260904 */
  var inner = el(".je-klarna-line", JE_SPI_NODE);
  if(inner){
    inner.classList.add("in");
    els(".je-klarna-line", app).forEach(function(k){ if(!JE_SPI_NODE.contains(k) && k.parentNode) k.parentNode.removeChild(k); });
  }
  var ctaSlot = el("[data-je-spi-cta-slot]", app);
  if(ctaSlot){
    var mark = el(".je-spi__mark", JE_SPI_NODE), big = el("[data-je-spi-big]", JE_SPI_NODE), legal = el(".je-spi__legal", JE_SPI_NODE);
    var line = document.createElement("p");
    line.className = "je-spi-cta rv d3";
    line.setAttribute("data-je-spi-cta", ""),line.setAttribute("data-nosnippet","");
    line.hidden = true;
    if(mark) line.appendChild(mark.cloneNode(true));
    var t = document.createElement("span");
    t.setAttribute("data-je-spi-cta-fig", "");
    t.textContent = big ? big.textContent : "";
    line.appendChild(t);
    if(legal){ var sm = document.createElement("small"); sm.innerHTML = legal.innerHTML; line.appendChild(sm); }
    ctaSlot.parentNode.replaceChild(line, ctaSlot);
  }
}
/* je-tour-express-20261008: the express checkout button is SERVER-RENDERED (a Liquid product form
   + Shopify's payment_button filter has no JS equivalent), so it follows the Shop Pay
   Installments panel's carry pattern exactly: detach the node from the placeholder hero
   before the innerHTML swap, drop it into its reserved slot after. The platform component
   re-binds on the move — it walks up to its form and observes the form's value attribute,
   and the form travels with the node. applyExpress() hides it when nothing is buyable and
   keeps the form's hidden name="id" on the live anchor: the one-tap buy is always the
   standard delivery option, never a second copy of a sheet choice. */
var JE_EXPRESS_NODE = null;
var JE_EXPRESS_ANCHOR = null;
function expressHTML(){
  if(MODE !== "pdp" || MANUAL_OOS) return "";
  return '<div class="je-express-slot" data-je-express-slot></div>';
}
function jeCarryExpress(){
  var n = el("#app > .je-tour-pre [data-je-express]");
  JE_EXPRESS_NODE = n || null;
  if(n && n.parentNode) n.parentNode.removeChild(n);
}
function jeAdoptExpress(){
  var slot = el("[data-je-express-slot]", app);
  if(!slot) return;
  if(!JE_EXPRESS_NODE){
    if(slot.parentNode) slot.parentNode.removeChild(slot);
    return;
  }
  slot.parentNode.replaceChild(JE_EXPRESS_NODE, slot);
  /* The server already rendered the price and stock line from the same variant data; keep
     the button in the state that data implied until hydrate() arrives with the live one. */
  applyExpress(JE_EXPRESS_ANCHOR, window.JE_TOUR_PURCHASABLE === true);
}
function applyExpress(anchor, keepServerState){
  JE_EXPRESS_ANCHOR = anchor || null;
  var node = JE_EXPRESS_NODE || el("[data-je-express]", app);
  if(!node) return;
  var on = anchor ? !!(anchor.available && Number(anchor.price) > 0) : !!keepServerState;
  node.hidden = !on;
  if(!on) return;
  if(!anchor) return; /* server state kept: the hidden variant already carries the anchor */
  var inp = el("[data-je-express-variant]", node);
  if(inp && String(inp.value) !== String(anchor.id)){
    inp.value = anchor.id;
    inp.setAttribute("value", String(anchor.id));
  }
}
var JE_SPI_ANCHOR = null;
window.addEventListener("je:finance-ready", function(){ if(JE_SPI_ANCHOR) applySpi(JE_SPI_ANCHOR); });
function applySpi(anchor){
  JE_SPI_ANCHOR = anchor;
  if(window.JeFinancePanel) window.JeFinancePanel.apply(anchor, app);
  else { var panel=el('[data-je-spi]',app); if(panel) panel.hidden=true; }
}
/* je-spi-defer-terms-20260904: Shopify's <shopify-payment-terms> waits in a <template> until the
   page has loaded and the main thread is idle, then is imported into its form. Its loader (in
   content_for_header) registers the element early, so the import upgrades it at once; its 473 KB
   of fonts are requested only then (measured: with no element on the page they never load). */
function jeMountSpiTerms(){
  var t = el("template[data-je-spi-terms]", app);
  if(!t || !t.content) return;
  var frag = document.importNode(t.content, true);
  t.parentNode.insertBefore(frag, t);
  t.parentNode.removeChild(t);
}
var JE_SPI_TERMS_SCHEDULED = false;
function jeScheduleSpiTerms(){
  if(JE_SPI_TERMS_SCHEDULED) return;
  JE_SPI_TERMS_SCHEDULED = true;
  var mount = jeOwned(jeMountSpiTerms);
  var go = function(){
    if("requestIdleCallback" in window) requestIdleCallback(mount, {timeout: 2500});
    else setTimeout(mount, 600);
  };
  if(document.readyState === "complete") go();
  else window.addEventListener("load", go, {once: true});
}
function spiCtaSlotHTML(){
  return MODE === "pdp" ? '<div data-je-spi-cta-slot></div>' : "";
}
function klarnaHTML(){
  if(MODE !== "pdp") return "";
  return '<p class="je-klarna-line rv d3" data-klarna hidden><span class="je-klarna-mark" role="img" aria-label="Klarna"></span>' +
    '<span class="je-klarna-text"></span></p>';
}
/* je-pay-in-3-shopify-figure-20260906: the pay-in-3 amount Shopify itself prints for this variant ("£116.66"),
   read from the shopify-meta JSON on its <shopify-payment-terms> element - which waits in
   <template data-je-spi-terms> until the engine mounts it, so both homes are searched.
   The variant is matched by full price in pence; anything unreadable returns "" and the
   caller falls back to the old arithmetic. Never throws. */
function jeSpiPerTerm(pence){
  try{
    var host = document.querySelector("shopify-payment-terms[shopify-meta]");
    if(!host){
      var t = document.querySelector("template[data-je-spi-terms]");
      host = t && t.content ? t.content.querySelector("shopify-payment-terms[shopify-meta]") : null;
    }
    if(!host) return "";
    var meta = JSON.parse(host.getAttribute("shopify-meta") || "{}");
    var variants = meta && meta.variants ? meta.variants : [];
    var want = Math.round(Number(pence));
    for(var i = 0; i < variants.length; i++){
      var v = variants[i];
      var full = Math.round(parseFloat(String(v.full_price || "").replace(/[^0-9.]/g, "")) * 100);
      if(full === want && v.eligible !== false && Number(v.number_of_payment_terms || 3) === 3
         && /\d/.test(String(v.price_per_term || ""))){
        return String(v.price_per_term);
      }
    }
  }catch(e){}
  return "";
}
function applyKlarna(pence){
  var line = el(".je-klarna-line", app);
  if(!line) return;
  if(!pence || pence <= 0){ line.hidden = true; return; }
  var tpl = document.getElementById("jeKlarnaMark");
  var mark = el(".je-klarna-mark", line);
  if(tpl && /<svg/i.test(tpl.innerHTML) && !mark.firstChild){ mark.innerHTML = tpl.innerHTML; }
  else if(!mark.firstChild){ mark.textContent = "Klarna"; }
  var text = el(".je-klarna-text", line);
  if(pence >= KLARNA_MIN_PENCE){
    /* je-pay-in-3-shopify-figure-20260906: Shopify's own per-term figure first, our division only as the fallback. */
    var spiTerm = jeSpiPerTerm(pence);
    text.textContent = KLARNA_TPL.replace("{amount}", spiTerm || money(Math.ceil(pence / 3) / 100));
  } else {
    text.textContent = KLARNA_NOTE;
  }
  line.hidden = false;
}
/* je-pdp-location-settle-20261013: the delivery-area button under the buy pair. The markup is the section's
   (snippets/je-delivery-location-button.liquid, printed in the placeholder hero and handed over as a string), so
   this hero lands on the placeholder's pixels and je-delivery-location-20260919.js only wires the button.
   Only with the buy pair (that script mounts beside it), never on the hub. */
function locationHTML(actions){
  return (MODE === "pdp" && actions && typeof window.JE_TOUR_LOCATION_HTML === "string") ? window.JE_TOUR_LOCATION_HTML : "";
}
function postcodeHTML(){
  if(MODE !== "pdp" || !window.JE_TOUR_ZONES_URL) return "";
  return '<div class="pc-band je-glass je-glass--sm rv d3">' +
    '<div class="pc-copy"><h3>Do we deliver to you?</h3>' +
    '<p>Delivery by our own team across our local area, free on orders of \u00a3100 or more. Pop your postcode in and we\u2019ll tell you straight away.</p></div>' +
    '<form class="pc-form" id="jeTourPostcode" novalidate>' +
    '<label class="visually-hidden" for="jeTourPostcodeInput">Your postcode</label>' +
    '<input class="pc-input" id="jeTourPostcodeInput" type="text" inputmode="text" autocomplete="postal-code" maxlength="9" placeholder="e.g. DN15 6EN">' +
    '<button class="btn pc-btn" type="submit">Check</button>' +
    '<p class="pc-result" data-state="hidden" role="status" aria-live="polite"></p></form></div>';
}
/* The compact purchase summary deliberately reads only the fit object already
   used by the canonical closer-look/specification path.  Do not infer a unit,
   round a dimension, or attempt to parse product prose here. */
function purchaseFitHTML(p){
  if(MODE === "pdp" && window.JEBuyingFacts) return window.JEBuyingFacts.render(p);
  var fit = p && p.closer && p.closer.fit;
  if(MODE !== "pdp") return "";
  if(fit && fit.w != null && fit.h != null && fit.d != null){
    return '<p class="je-purchase-fit rv d3" aria-label="Product dimensions">' +
      '<span>Dimensions</span><b>' + esc(String(fit.w)) + ' × ' + esc(String(fit.h)) + ' × ' +
      esc(String(fit.d)) + ' cm</b><em>W × H × D</em></p>';
  }
  /* Some tour records carry the maker's dimensions only in the canonical spec
     table.  Preserve that row verbatim instead of guessing a dimension order
     or adding a unit. */
  var groups = p && p.spec || [];
  for(var g = 0; g < groups.length; g++){
    var rows = groups[g] && groups[g].r || [];
    for(var r = 0; r < rows.length; r++){
      if(/dimensions?/i.test(String(rows[r][0] || "")) && String(rows[r][1] || "").trim()){
        return '<p class="je-purchase-fit rv d3" aria-label="Product dimensions"><span>' +
          esc(String(rows[r][0])) + '</span><b>' + esc(String(rows[r][1])) + '</b></p>';
      }
    }
  }
  return "";
}
function initPostcode(){
  var form = el("#jeTourPostcode", app);
  if(!form) return;
  var input = el("#jeTourPostcodeInput", form), out = el(".pc-result", form), zones = null;
  function setResult(state, msg){ out.setAttribute("data-state", state); out.textContent = msg;
    /* je-postcode-log-20261011: report the district and this answer (never the postcode) */
    try{ if(window.jePcReport) window.jePcReport(input.value, state, "product"); }catch(e){}
  }
  function loadZones(){
    if(zones) return Promise.resolve(zones);
    return fetchJSON(window.JE_TOUR_ZONES_URL).then(function(d){ zones = d; return d; });
  }
  on(form, "submit", function(e){
    e.preventDefault();
    /* je-outcode-parse-20260806: anchor on the INWARD code so single-digit
       outcodes (DN1, LN7) are not eaten by the greedy match. */
    var raw = (input.value || "").toUpperCase().replace(/[^A-Z0-9]/g, "");
    var full = raw.match(/^([A-Z]{1,2}[0-9][A-Z0-9]?)([0-9][A-Z]{2})$/);
    var district = full ? full[1] : (/^[A-Z]{1,2}[0-9][A-Z0-9]?$/.test(raw) ? raw : null);
    if(!district){ setResult("no", "That doesn\u2019t look like a UK postcode \u2014 try again."); return; }
    var areaPrefix = district.match(/^([A-Z]+)/)[1];
    loadZones().then(function(d){
      /* je-collect-advert-20260806 + je-outofarea-fallback-20260815, verbatim
         from product-main: every refusal offers collection, and a well-formed
         postcode not in districts{} is OUTSIDE the area, never "unrecognised". */
      var collect = d.collect_note ? " " + d.collect_note : "";
      var entry = d.districts && d.districts[district];
      if(entry){
        if(entry.delivery){
          /* je-ato-pill-postcode-eta-20260904: the ETA belongs to the in-stock lane only - an
             Available-to-Order page already says "In store in 1-3 days" in its hero, and two
             timeframes on one page is the shape that cost the GMC account in June. */
          setResult("yes", (d.delivery_note || "Yes \u2014 local delivery") + " to " + entry.area + " (" + district + ")" + (LANE === "stock" && d.eta ? " \u00b7 " + d.eta : ""));
        } else {
          setResult("no", (d.no_delivery_note || "We don\u2019t deliver there") + " \u2014 " + entry.area + " (" + district + ")." + collect);
        }
        return;
      }
      if((d.blanket_no_prefixes || []).indexOf(areaPrefix) !== -1){
        setResult("no", "We don\u2019t currently deliver to " + areaPrefix + " postcodes." + collect);
        return;
      }
      setResult("no", "Outside our current delivery zone (" + district + ")." + collect);
    }).catch(function(){
      setResult("unsure", "Check service unavailable \u2014 please call 01724 844040 or 01724 843800.");
    });
  });
}
function mountPurchasePostcode(){
  var band = el('.pc-band', app), home = el('[data-je-postcode-home]', app), actions = el('#hero .je-tour-actions', app);
  if(!band || !home || !actions || !window.matchMedia) return;
  var media = window.matchMedia('(max-width:900px)');
  function place(){
    if(!band.isConnected || !home.isConnected) return;
    if(media.matches){
      var fit = el('#hero .je-purchase-fit', app);
      if(fit && (fit.parentNode !== actions.parentNode || fit.previousElementSibling !== actions)) actions.insertAdjacentElement('afterend', fit);
      var anchor = fit || actions;
      if(band.parentNode !== anchor.parentNode || band.previousElementSibling !== anchor) anchor.insertAdjacentElement('afterend', band);
    } else if(band.parentNode !== home) home.appendChild(band);
  }
  place();
  if(media.addEventListener) on(media, 'change', place);
  else { media.addListener(place); cleanup.push(function(){ media.removeListener(place); }); }
  // The showroom enhancement groups the hero after hydration. Follow the same
  // original button row when that grouping happens, without cloning controls.
  var hero = el('#hero', app);
  if(hero && window.MutationObserver){
    var observer = new MutationObserver(place);
    observer.observe(hero, {childList:true,subtree:true});
    cleanup.push(function(){ observer.disconnect(); });
  }
}
function initVideo(){
  var box = el(".je-video", app);
  if(!box) return;
  var poster = el(".je-video-poster", box);
  if(poster){
    /* YouTube serves a 120x90 grey tile with status 200 when no maxres frame
       exists, so a 404 handler would never fire — check the decoded size. */
    var fallback = poster.getAttribute("data-fallback");
    var useFallback = function(){
      if(!fallback || (!poster.hasAttribute("srcset") && poster.src === fallback)) return;
      poster.removeAttribute("srcset");
      poster.removeAttribute("sizes");
      poster.src = fallback;
    };
    var check = function(){
      if(poster.naturalWidth && poster.naturalWidth < 300) useFallback();
    };
    if(poster.complete) check(); else on(poster, "load", check);
    on(poster, "error", useFallback);
  }
  var play = el(".je-video-play", box);
  if(!play) return;
  var warm = function(){
    if(box.getAttribute("data-video-warmed") === "true") return;
    box.setAttribute("data-video-warmed", "true");
    ["https://www.youtube-nocookie.com", "https://i.ytimg.com"].forEach(function(href){
      if(document.querySelector('link[rel="preconnect"][href="' + href + '"]')) return;
      var link = document.createElement("link");
      link.rel = "preconnect";
      link.href = href;
      document.head.appendChild(link);
    });
  };
  on(play, "pointerenter", warm, {once:true, passive:true});
  on(play, "touchstart", warm, {once:true, passive:true});
  on(play, "focus", warm, {once:true, passive:true});
  on(play, "click", function(){
    if(box.classList.contains("playing")) return;
    var id = box.getAttribute("data-video-id");
    if(!/^[A-Za-z0-9_-]{11}$/.test(id)) return;
    warm();
    box.classList.add("playing", "is-loading");
    box.setAttribute("aria-busy", "true");
    var frame = document.createElement("iframe");
    frame.src = "https://www.youtube-nocookie.com/embed/" + id + "?autoplay=1&rel=0&modestbranding=1&playsinline=1";
    frame.setAttribute("title", play.getAttribute("aria-label") || "Product video");
    frame.setAttribute("allow", "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share");
    frame.setAttribute("allowfullscreen", "");
    frame.setAttribute("loading", "eager");
    frame.setAttribute("referrerpolicy", "strict-origin-when-cross-origin");
    var ready = function(){
      box.classList.remove("is-loading");
      box.classList.add("is-ready");
      box.removeAttribute("aria-busy");
    };
    on(frame, "load", ready, {once:true});
    window.setTimeout(jeOwned(ready), 8000);
    play.parentNode.replaceChild(frame, play);
  }, {once:true});
}
function initEnrichUI(){
  initVideo();
  initPostcode();
}

/* ================= CONVERSION FURNITURE (je-pdp-convert-20260902) =================
   The elements the best product pages keep beside the buy button. Every figure
   is read: the Google rating/count/quote from window.JE_TOUR_TRUST (shop
   metafields written daily by google_reviews_sync.py), the fitting rung from the
   product's own live variants, the guarantee from the product record. */
var TRUST = (window.JE_TOUR_TRUST && typeof window.JE_TOUR_TRUST === "object") ? window.JE_TOUR_TRUST : {};
var GOOGLE_REVIEWS_URL = "https://search.google.com/local/reviews?placeid=ChIJmbbwXhrleEgRipVhqUlUPPc";
/* je-pdp-no-returns-claim-20260902: returns remain in the policy, not in PDP sales furniture. */
var FINALE_COPY = {
  stock: "Local delivery by our own team, typically within 1\u20133 business days. Free on orders of \u00a3100 or more.",
  ato:   "Ordered in for you and delivered by our own team. Free delivery on orders of \u00a3100 or more.",
  oos:   "Call us on 01724 844040 and we\u2019ll find you the nearest match."
};
function trustRating(){
  var r = parseFloat(TRUST.rating), n = parseInt(TRUST.count, 10);
  if(!(r > 0 && r <= 5) || !(n > 0)) return null;
  return {rating: r, count: n};
}
/* je-choose-local-strap-20261013: the strapline, first thing in the hero, above the rating line. The words and the markup are the
   section's (sections/je-tour-pdp.liquid builds the string once and prints the same one in its
   placeholder hero), so this hero lands on the placeholder's pixels. Nothing on the hub. */
function strapHTML(){
  return (MODE === "pdp" && typeof window.JE_TOUR_STRAP_HTML === "string") ? window.JE_TOUR_STRAP_HTML : "";
}
function eyebrowHTML(){
  var t = trustRating();
  if(!t || MODE !== "pdp") return '<div class="eyebrow rv">' + strapHTML() + 'Johns Electrical presents</div>';
  return '<div class="eyebrow eyebrow-trust rv">' + strapHTML() +
    '<a class="je-trust-rating" href="' + GOOGLE_REVIEWS_URL + '" target="_blank" rel="noopener" ' +
    'aria-label="Rated ' + attr(String(t.rating)) + ' out of 5 stars on Google (opens in a new tab)">' +
    '<span class="je-trust-star" aria-hidden="true">\u2605</span> ' + esc(String(t.rating)) + ' Stars on Google</a>' +
    '<span class="je-trust-sep" aria-hidden="true">\u00b7</span><span>Family-run since 1971</span></div>';
}
function fittingRung(p){
  /* the cheapest PAID rung — its own live title and its own delta over the anchor */
  var anchor = p.variants && p.variants.length ? p.variants[0].price : null;
  var paid = (p.variants || []).filter(function(v){ return anchor != null && v.price > anchor; })
    .sort(function(a, b){ return a.price - b.price; });
  if(!paid.length) return null;
  return {title: paid[0].title, delta: paid[0].price - anchor};
}
function trustStripHTML(p){
  if(MODE !== "pdp") return "";
  var rung = fittingRung(p);
  var fit = rung ? (/dispos/i.test(rung.title) && !/install/i.test(rung.title)
      ? "Old one taken away, +" + money(rung.delta)
      : "Fitted by our own team, +" + money(rung.delta)) : "Delivered by our own team";
  return '<ul class="je-trust-strip rv d3" aria-label="Why buy from Johns Electrical">' +
    '<li><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7z"/><circle cx="7" cy="17" r="2"/><circle cx="17" cy="17" r="2"/></svg>Free delivery&nbsp;<small class="je-fd-min" style="font-size:.9em;font-weight:500;opacity:.72;white-space:nowrap;letter-spacing:0">(min. order \u00a3100)</small></li>' +
    '<li><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M14.7 6.3a4 4 0 0 0-5.6 5.6l-6 6 2 2 6-6a4 4 0 0 0 5.6-5.6l-2.3 2.3-2-2z"/></svg>' + esc(fit) + '</li>' + jeRatingLi() + '</ul>';
}
/* je-rating-display-20261012: the product's own customer rating, from the first rating. The
   section prints the line (custom.rating_text, composed by read_ratings.py) into
   window.JE_TOUR_RATING and into its placeholder strip; this prints the same words, so the
   hand-over moves nothing. No rating, no line. */
function jeRatingLi(){
  var r = window.JE_TOUR_RATING;
  if(!r || typeof r.text !== "string" || !r.text) return "";
  return '<li class="je-trust-prating">' + JE_RATING_STAR + esc(r.text) + '</li>';
}
var JE_RATING_STAR = '<svg viewBox="0 0 24 24" aria-hidden="true" style="fill:#f6c71b;stroke:#f6c71b"><path d="M12 3l2.7 5.6 6.1.8-4.5 4.3 1.1 6.1L12 16.9 6.6 19.8l1.1-6.1L3.2 9.4l6.1-.8z"/></svg>';
function customerCardHTML(){
  var t = trustRating();
  var quote = String(TRUST.quote || "").trim();
  if(!t || !quote) return "";
  return '<a class="svc svc-customer rv d3" href="' + GOOGLE_REVIEWS_URL + '" target="_blank" rel="noopener">' +
    '<span class="tag free">' + esc(String(t.rating)) + ' \u2605</span><div class="ic ic-contact">' + serviceIcon("contact") + '</div>' +
    '<h3>What customers say</h3><blockquote>\u201c' + esc(quote) + '\u201d</blockquote>' +
    '<p class="svc-cite">' + (TRUST.author ? '\u2014 ' + esc(String(TRUST.author)) + ', ' : '') + t.count + ' Google reviews \u2192</p></a>';
}
function goodToKnowHTML(p){
  if(MODE !== "pdp") return "";
  var rung = fittingRung(p);
  var rows = [];
  var deliv = LANE === "stock" ?
    "Free on orders of \u00a3100 or more (\u00a315 below that) to our local delivery area, typically within 1\u20133 business days, by our own team \u2014 not a courier. Or collect free from 142 High Street, Scunthorpe." :
    LANE === "ato" ?
    "Free on orders of \u00a3100 or more (\u00a315 below that) to our local delivery area once it has come in to us, by our own team \u2014 not a courier. Or collect free from 142 High Street, Scunthorpe." :
    "Free on orders of \u00a3100 or more (\u00a315 below that) to our local delivery area by our own team once it is back in stock. Or collect free from 142 High Street, Scunthorpe.";
  rows.push(["Delivery", deliv + " Check your postcode above."]);
  if(rung){
    var fitRow = /dispos/i.test(rung.title) && !/install/i.test(rung.title)
      ? "Choose <b>" + esc(rung.title) + "</b> (+" + money(rung.delta) + ") when you add to bag and we take the old one away."
      : "Choose <b>" + esc(rung.title) + "</b> (+" + money(rung.delta) + ") when you add to bag: our own team unboxes it, connects it, checks it works and takes the old one away.";
    rows.push(["Fitting & the old one", fitRow]);
  }
  if(p.warranty && p.warranty.years){
    rows.push(["Guarantee", esc(warrantyLine(p.warranty)) + (p.warranty.note ? " " + esc(p.warranty.note) : "")]);
  }
  rows.push(["Paying", "Card, Shop Pay, Klarna and PayPal at checkout. Shop Pay Installments and Klarna instalment plans are subject to approval."]); /* je-spi-promo-20260904 */
  return '<section id="gtk"><div class="wrap">' +
    '<span class="kicker rv">Before you buy</span>' +
    '<h2 class="giant rv d1">Good to know.</h2>' +
    '<div class="gtk-list rv d2">' + rows.map(function(r, i){
      return '<details class="gtk je-glass je-glass--sm"' + (i === 0 ? " open" : "") + '><summary>' + esc(r[0]) +
        '<span class="chev"><svg width="12" height="7" viewBox="0 0 12 7" fill="none"><path d="M1 1l5 5 5-5" stroke="#d7d7dc" stroke-width="2" stroke-linecap="round"/></svg></span></summary>' +
        '<p>' + r[1] + '</p></details>';
    }).join("") + '</div></div></section>';
}

/* je-product-measurements-20260905: exact-product data, visible text first, lazy 3D. */
function jeMeasurementsData(p){
  if(MODE !== "pdp") return null;
  var node = document.getElementById("je-product-measurements-data"), m;
  if(!node) return null;
  try { m = JSON.parse(node.textContent); } catch(_e) { return null; }
  if(m.version !== 1 || m.handle !== p.handle || String(m.productId) !== node.getAttribute("data-product-id")) return null;
  if(p.id && String(p.id) !== String(m.productId)) return null;
  var ds = m.dimensions;
  if(!ds || !["widthMm","heightMm","depthMm"].every(function(k){ return typeof ds[k] === "number" && isFinite(ds[k]) && ds[k] > 0; })) return null;
  return m;
}
function jeMeasureNumber(n){ return Number(n.toFixed(1)).toLocaleString("en-GB"); }
function jeMeasurementsHTML(m, view){
  if(!m || !m.modelUrl) return "";
  return '<div class="media je-measurements" data-je-measurements data-je-view="' + view + '">' +
    '<div class="je-measure-stage"><p class="je-measurements__initial"><span>Explore the product in 3D</span><br>' +
    'Width ' + jeMeasureNumber(m.dimensions.widthMm) + ' mm · Height ' + jeMeasureNumber(m.dimensions.heightMm) +
    ' mm · Depth ' + jeMeasureNumber(m.dimensions.depthMm) + ' mm</p></div></div>';
}
var jeMeasurementsScriptPromise;
function jeInitMeasurements(p){
  var m = jeMeasurementsData(p), closer = el("#closer", app);
  if(!m || !m.modelUrl || !closer) return;
  var stopped = false, observer, mutationObserver, viewers = [];
  function start(section){
    if(section.__jeMeasurements || section.getAttribute("data-je-loading") === "true") return;
    section.setAttribute("data-je-loading","true");
    if(!jeMeasurementsScriptPromise){
      jeMeasurementsScriptPromise = new Promise(function(resolve,reject){
        if(window.JEProductMeasurements){ resolve(); return; }
        var script = document.createElement("script");
        script.src = m.viewerUrl; script.async = true;
        script.onload = function(){ window.JEProductMeasurements ? resolve() : reject(new Error("Viewer unavailable")); };
        script.onerror = reject; document.head.appendChild(script);
      }).catch(function(e){ jeMeasurementsScriptPromise = null; throw e; });
    }
    jeMeasurementsScriptPromise.then(function(){
      if(!stopped && section.isConnected) viewers.push(window.JEProductMeasurements.mount(section,Object.assign({},m,{annotations:section.getAttribute("data-je-view") === "fit"})));
    }).catch(function(){
      section.removeAttribute("data-je-loading");
      if(!stopped){ var hint=section.querySelector(".je-measurements__initial span"); if(hint) hint.textContent="The 3D view is unavailable. Product measurements:"; }
    });
  }
  function check(){
    if(stopped || !nearViewport(closer,400)) return;
    els(".pane.on [data-je-measurements]",closer).forEach(start);
  }
  if("IntersectionObserver" in window){
    observer = new IntersectionObserver(function(entries){ if(entries.some(function(e){return e.isIntersecting;})) check(); }, {rootMargin:"400px"});
    observer.observe(closer);
  } else check();
  mutationObserver = new MutationObserver(check);
  els(".pane",closer).forEach(function(pane){mutationObserver.observe(pane,{attributes:true,attributeFilter:["class"]});});
  cleanup.push(function(){ stopped=true; if(observer)observer.disconnect();mutationObserver.disconnect();viewers.forEach(function(v){if(v)v.destroy();}); });
}

/* je-closer-tabs-20260906: expose the selected panel and keep keyboard navigation local. */
function jeInitCloserTabs(root){
  var closer = el("#closer", root);
  if(!closer) return;
  var tabs = els(".tabs .tab[data-pane]", closer);
  var panes = els(".panelbox > .pane", closer);
  function select(tab){
    var pane = el("#" + tab.getAttribute("data-pane"), closer);
    if(!pane || panes.indexOf(pane) < 0) return;
    tabs.forEach(function(item){
      var active = item === tab;
      item.classList.toggle("on", active);
      item.setAttribute("aria-selected", String(active));
      item.tabIndex = active ? 0 : -1;
    });
    panes.forEach(function(item){
      var active = item === pane;
      item.classList.toggle("on", active);
      item.setAttribute("aria-hidden", String(!active));
      item.inert = !active;
    });
  }
  tabs.forEach(function(tab, index){
    tab.addEventListener("click", function(){ select(tab); });
    tab.addEventListener("keydown", function(event){
      var next;
      if(event.key === "ArrowRight") next = (index + 1) % tabs.length;
      else if(event.key === "ArrowLeft") next = (index + tabs.length - 1) % tabs.length;
      else if(event.key === "Home") next = 0;
      else if(event.key === "End") next = tabs.length - 1;
      else return;
      event.preventDefault();
      select(tabs[next]);
      tabs[next].focus({preventScroll:true});
    });
  });
}

function renderTour(p){
  var jeMeasure = jeMeasurementsData(p);
  var d = p.dna || {};
  LANE = MANUAL_OOS ? "oos" : (pageLane() || "stock");
  var shortName = shortProductName(p);
  var code = productCode(p);
  var photoSet = productPhotoSet(p);
  var gallerySet = productGallerySet(p, photoSet);
  var pal = d.palette || {};
  var root = document.documentElement;
  var primary = pal.a || "#2997ff";
  var secondary = pal.b || "#bf5af2";
  var tertiary = pal.c || "#ffd60a";
  root.style.setProperty("--pa", primary);
  root.style.setProperty("--pa-ink", paletteButtonInk(primary));
  root.style.setProperty("--pa-text", paletteTextOnBlack(primary));
  root.style.setProperty("--pb", secondary);
  root.style.setProperty("--pb-text", paletteTextOnBlack(secondary));
  root.style.setProperty("--pc", tertiary);
  root.style.setProperty("--pc-text", paletteTextOnBlack(tertiary));
  /* je-name-shimmer-depink-pass2-20260826: name-gradient stops, pink filtered out */
  var nameStops = [primary, secondary, tertiary].filter(function(c){ return !paletteIsPink(c); });
  var nameA = nameStops.length ? nameStops[0] : "#2997ff";
  var nameC = nameStops.length ? nameStops[nameStops.length - 1] : "#ffd60a";
  root.style.setProperty("--je-name-a", paletteTextOnBlack(nameA));
  root.style.setProperty("--je-name-c", paletteTextOnBlack(nameC));
  if(MODE === "showcase") document.title = (p.display || p.title) + " — Johns Electrical";

  var save = p.was ? (p.was - p.price) : 0;
  /* je-glass-1i-vitrine-20260830: 1i Smoked Vitrine (Will: "this is how I want all the
     price tags to look throughout the website").  Layer order and nesting
     are the reference's <!-- 1i BEGIN/END --> block: spotlight, five embers,
     body, code line, price row, stock line.  The COPY stays ours.

     THE LIVE-PRICE HOOKS DO NOT MOVE.  .price-now / .price-was / .price-save
     are the nodes hydrate() rewrites when the real Shopify variants land,
     and .stockline is the one it repoints to "Call us for availability"
     when nothing is purchasable.  Restyling a price must not cost the page
     its live price. */
  /* je-vitrine-stack-20260901: Will - "the cut through isnt above the proce ... a much
     better layout on all product pages".  The Was is read BEFORE the price it
     qualifies - a MARKUP move, never CSS `order:`, so reading order and visual
     order agree.  The hydration hooks are class lookups and do not care about order.
     je-vitrine-fit-20260901: Will - "The cut through price should be directly above
     the main price with the savings tab just to the right of the main price."  Putting
     the Was on its own full-width flex row centred it on the BOX, not on the price -
     measured live at 1440, Was centre 720.00 against the price's 669.45.  The two now
     share ONE inline-block so their centres coincide by construction, and the Save
     stays a sibling of that block, i.e. a wrapping flex item that can still drop
     beneath the price on a narrow phone instead of being clipped.
     .je-price-main carries NO hydration hook and never will: hydrate() rewrites
     .price-now / .price-was / .price-save by class and REMOVES the Was and the Save
     when the live payload has no deal, so the wrapper must be able to end up holding
     the price alone. */
  var priceCells =
    '<div class="je-price-main">' +
    (p.was ? '<div class="je-was price-was"><s>Was ' + money(p.was) + '</s></div>' : "") +
    '<div class="je-price price-now">' + money(p.price) + '</div>' +
    '</div>' +
    (save > 0 ? '<div class="je-save price-save">Save ' + money(save) + '</div>' : "");
  function vitrine(reveal, withStore){ /* je-store-stock-20260925: withStore = the hero's one shop list */
    return '<div class="je-vitrine ' + reveal + '">' +
      '<div class="je-spot"></div>' + JE_VITRINE_EMBERS +
      '<div class="je-vitrine-body">' +
      '<div class="je-price-row">' + priceCells + '</div>' +
      stockLineHTML(LANE) + (withStore ? storeDetailHTML(LANE) : "") +
      '</div></div>';
  }
  /* je-tour-two-glass-actions-20260826: both controls reuse the one live-rung
     sheet and the one guarded cart submission. Only Buy it now carries checkout
     intent. Both remain disabled until Shopify's current variants hydrate. */
  /* je-tour-express-20261008: same server evidence as the first paint (window.JE_TOUR_PURCHASABLE).
     When it says purchasable the pair ships READY: a click before hydration just opens the
     sheet in its existing "Checking live options…" state and the live payload settles the
     rungs. Not purchasable: the old disabled+busy start, hydrate settles it. */
  var pdpDisabled = window.JE_TOUR_PURCHASABLE === true ? "" : "disabled aria-busy=\"true\" ";
  var pdpActions = MODE === "pdp" && !MANUAL_OOS ?
    '<div class="je-tour-actions rv d3" role="group" aria-label="Purchase options">' +
    '<button class="btn je-tour-action je-tour-action--cart sheet-open" id="jeTourAddCart" type="button" ' +
    'aria-haspopup="dialog" aria-controls="sheetWrap" ' + pdpDisabled +
    'aria-label="Add to bag — choose an option"><span>Add to bag</span></button>' +
    '<button class="btn je-tour-action je-tour-action--buy sheet-open" id="jeTourBuyNow" type="button" ' +
    'data-checkout-intent="true" aria-haspopup="dialog" aria-controls="sheetWrap" ' + pdpDisabled +
    'aria-label="Buy it now — choose an option, then go straight to checkout"><span>Buy it now</span></button>' +
    '</div>' : "";
  /* je-pdp-video-top-20260902: build the optional video once. Video-bearing
     products pair it with the exact-product hero photo; no-video products keep
     the existing hero markup and geometry. */
  var heroVideo = videoHTML(p, true);

  var h = "";
  /* je-pdpbar-was-hydrate-20260901: both sticky bars used to write their Was as a
     bare <s> from the bind-time data asset, so hydrate() - which rewrites
     els(".price-was") from /products/<handle>.js - updated the Now beside it while
     a dead Was could sit crossed out until the next 08:35 rebind.  The <s> now
     carries price-was-bar and is updated-or-removed by the same live payload.
     price-was-bar, NOT price-was: the generic hook's innerHTML is "<s>Was £x</s>"
     and these compact bars show just the struck figure.  Like every price hook,
     hydration may update or remove it but never CREATES one. */
  if(MODE === "showcase"){
    h += '<nav id="localnav" aria-label="Product">' +
      '<div class="name">' + esc(shortName) + '</div>' +
      '<div class="buy"><a class="back" href="#" id="backlink">← Showcase</a>' +
      '<div class="price">' + (p.was ? '<s class="price-was-bar">' + money(p.was) + "</s>" : "") + '<span class="price-now">' + money(p.price) + '</span></div>' +
      '<button class="btn sheet-open" type="button">Add to Bag</button></div></nav>';
  } else {
    h += '<div id="pdpbar" data-anchor-price="' + attr(String(Math.round(Number(p.price) * 100))) + '"><div class="pinfo">' +
      '<div class="pname">' + esc(shortName) + '</div>' +
      '<div class="pprice">' + (p.was ? '<s class="price-was-bar">' + money(p.was) + "</s>" : "") +
      '<span class="price-now">' + money(p.price) + '</span><span class="pselection" aria-live="polite"></span>' + stockLineHTML(LANE) + /* je-phone-buybar-20261010 */ '</div></div>' +
      '<button class="btn sheet-open" type="button">Add to Bag</button></div>';
  }

  // hero
  h += '<header id="hero"><div class="aurora" aria-hidden="true"><i></i><i></i><i></i></div>' +
    eyebrowHTML() +
    '<h1 class="rv d1">' + productTitleHTML(p) + '</h1>' +
    '<p class="sub rv d4">' + esc(d.tagline || d.sub || "") + (code ? '<span class="je-product-code-above-ratings">Product code · ' + esc(code) + '</span>' : "") + reviewLinkHTML() + '</p>' +
    vitrine('rv d2', true) +
    pdpActions + locationHTML(pdpActions) + expressHTML() + trustStripHTML(p) + purchaseFitHTML(p) + spiHTML() + klarnaHTML() + /* je-spi-promo-20260904 */
    (heroVideo ? '<div class="je-hero-media">' + rigHTML(photoSet.hero, p, true) + heroVideo + '</div>' : rigHTML(photoSet.hero, p, false)) +
    '<div class="scrollcue" aria-hidden="true">Scroll<svg width="16" height="9" viewBox="0 0 16 9" fill="none"><path d="M1 1l7 6 7-6" stroke="#b8b8be" stroke-width="2" stroke-linecap="round"/></svg></div>' +
    '</header>';

  // The showroom moves the optional video after the hero; reviews follow it.
  if(MODE === "pdp") h += reviewsHTML(p);

  // je-visual-brief-cards-20260905: every chapter plus practical sections.
  var rail = window.JE_BRIEF_CARDS.build(p);
  h += window.JE_BRIEF_CARDS.render(p);

  // chapters
  var pinIdx = 0;
  // je-know-your-controls-20260905: only released exact-identity guides get a chapter.
  var controlsIdentity = {id: MODE === "pdp" ? String(window.JE_TOUR_PRODUCT_ID || "") : String(p.id || ""), model: p.model};
  var controlsMeta = window.JEControlsLoader && window.JEControlsLoader.lookup(controlsIdentity);
  var chapters = (d.chapters || []).slice();
  var controlsChapter = -1;
  var extraControlsChapters = [];
  if(controlsMeta){
    chapters.forEach(function(chapter, index){
      if(/\bcontrols?\b/i.test((chapter.kicker || "") + " " + (chapter.headline || ""))){
        if(controlsChapter < 0) controlsChapter = index;
        else extraControlsChapters.push(index);
      }
    });
    if(controlsChapter < 0){ controlsChapter = chapters.length; chapters.push({kicker:"Controls",headline:"Know your controls"}); }
  }
  var support = photoSet.story;
  var beatsAfter = {};
  if(chapters.length){
    support.forEach(function(media, i){
      var slot = Math.min(chapters.length - 1,
        Math.floor((i + 1) * chapters.length / (support.length + 1)));
      (beatsAfter[slot] || (beatsAfter[slot] = [])).push([media, i]);
    });
  }
  chapters.forEach(function(c, i){
    var headline = esc(c.headline || "").replace(/\s*\|\s*/g, "<br>");
    if(controlsMeta && i === controlsChapter){
      h += '<section class="block je-controls-chapter" id="ch' + i + '"><div class="wrap" data-je-controls-host>' +
        '<span class="kicker">CONTROLS</span><h2 class="giant">Know your controls</h2>' +
        '<p class="lede">Choose a control to see what it does.</p></div></section>';
    } else if(controlsMeta && extraControlsChapters.indexOf(i) !== -1){
      // Keep old chapter anchors usable while the single detailed guide owns controls.
      h += '<span id="ch' + i + '" aria-hidden="true"></span>';
    } else if(c.chips && c.chips.length){
      h += '<section class="block chapflow" id="ch' + i + '"><div class="wrap">' +
        '<span class="kicker rv">' + esc(c.kicker || "") + '</span>' +
        '<h2 class="giant rv d1">' + headline + '</h2>' +
        (c.lede ? '<p class="lede rv d2">' + esc(c.lede) + '</p>' : "") +
        '<div class="chips rv d3">' + c.chips.map(function(x){ return '<span class="chip">' + esc(x) + '</span>'; }).join("") + '</div>' +
        statsHTML(c.stats) + '</div></section>';
    } else {
      h += '<div class="pin-outer" id="ch' + i + '" data-module="' + esc(d.module || "glow") + '" data-pin="' + (pinIdx++) + '">' +
        /* je-tour-pagefx-20260827 (Will: "the background effect should fade in and out of
           the WHOLE page not just some of it"): on a PDP the effect is now ONE fixed
           viewport canvas behind the entire page (mountPageFX), so a per-chapter canvas
           would draw the same module a second time at double density inside the pins.
           The showcase hub keeps its per-chapter canvases — it has no page canvas. */
        '<div class="pin">' + (MODE === "pdp" ? "" : '<canvas aria-hidden="true"></canvas>') +
        '<div class="vig" aria-hidden="true"></div>' +
        '<div class="inner"><span class="kicker">' + esc(c.kicker || "") + '</span>' +
        '<h2 class="giant">' + headline + '</h2>' +
        (c.lede ? '<p class="lede" style="margin-left:auto;margin-right:auto;text-align:center">' + esc(c.lede) + '</p>' : "") +
        (c.counter ? '<div class="counter" data-target="' + Number(c.counter.target) + '" data-suffix="' + esc(c.counter.suffix||"") + '">0</div>' +
          '<div class="counter-label">' + esc(c.counter.label || "") + '</div>' : "") +
        statsHTML(c.stats) +
        '</div></div></div>';
    }
    (beatsAfter[i] || []).forEach(function(pair){
      h += photoBeatHTML(pair[0], pair[1], p);
    });
  });
  if(!chapters.length){
    support.forEach(function(media, i){ h += photoBeatHTML(media, i, p); });
  }

  // official video lives beside the hero product photo (je-pdp-video-top-20260902)

  // closer look
  var cl = d.closer || {};
  if(jeMeasure){ var jeOldFit=cl.fit || {}; cl = Object.assign({}, cl, {fit:Object.assign({}, jeOldFit, {w:Number((jeMeasure.dimensions.widthMm/10).toFixed(3)), h:Number((jeMeasure.dimensions.heightMm/10).toFixed(3)), d:Number((jeMeasure.dimensions.depthMm/10).toFixed(3)), note:(jeOldFit.note ? jeOldFit.note + ". " : "") + jeMeasure.scopeNote})}); if(jeMeasure.modelUrl && !cl.design) cl.design={h:"Explore the design",p:"Rotate and move the model to take a closer look."}; }
  var tabs = [], panes = [];
  // je-fit-design-20261010: one default pane, with measurements attached to the model.
  var closerPhoto = photoSet.story[0] || photoSet.hero;
  var hasFit = cl.fit && [cl.fit.w,cl.fit.h,cl.fit.d].every(function(n){return Number(n) > 0 && isFinite(Number(n));});
  var hasModel = jeMeasure && jeMeasure.modelUrl;
  var hasDesign = cl.design && (cl.design.h || cl.design.p || (cl.design.bullets || []).length);
  if(hasModel || hasFit || hasDesign){
    var fitPane = '<div class="pane" id="p-fit">';
    // A valid model does not depend on a separate product photo being available.
    if(hasModel){
      fitPane += jeMeasurementsHTML(jeMeasure,"fit");
      // Keep installation/scope qualifications without repeating the dimension diagram.
      if(cl.fit && (cl.fit.note || cl.fit.kg)) fitPane += '<p class="je-fit-note">' +
        (cl.fit.kg ? esc(cl.fit.kg) + ' kg. ' : '') + esc(cl.fit.note || '') + '</p>';
    } else if(isRealProductPhoto(closerPhoto)){
      closerPhoto = accessiblePhoto(closerPhoto, p, photoSet.story.length ? 1 : 0);
      fitPane += '<div class="media ' + (closerPhoto.cutout ? 'cutout' : 'framed') + '">' +
        productPhotoHTML(closerPhoto, "closer-product-photo", false,
          "(max-width: 820px) 90vw, 520px", [480, 760, 1100, 1400, 1800, 2200]) + '</div>';
    }
    if(hasFit && !hasModel){
      fitPane += '<div class="je-fit-dimensions"><div class="dims">' + fitSVG(cl.fit, p) + '</div>' +
        '<div class="txt"><h3>Measure twice, relax once.</h3>' +
        '<p>It needs ' + cl.fit.w + ' cm of width and stands ' + cl.fit.h + ' cm tall by ' +
        cl.fit.d + ' cm deep' + (cl.fit.kg ? ' — ' + cl.fit.kg + ' kg' : "") + '.</p>' +
        '<ul><li><b>' + cl.fit.w + ' × ' + cl.fit.h + ' × ' + cl.fit.d + '</b> cm (W×H×D)</li>' +
        (cl.fit.kg ? '<li><b>' + cl.fit.kg + ' kg</b></li>' : "") +
        (cl.fit.note ? '<li>' + esc(cl.fit.note) + '</li>' : "") +
        '<li>Our team carries it in — you don’t.</li></ul></div></div>';
    }
    if(hasDesign){
      fitPane += '<div class="txt je-fit-design-details"><h3>' + esc(cl.design.h || "") + '</h3>' +
        '<p>' + esc(cl.design.p || "") + '</p>' +
        (cl.design.bullets ? '<ul>' + cl.design.bullets.map(function(b){ return '<li>' + esc(b) + '</li>'; }).join("") + '</ul>' : "") +
        '</div>';
    }
    tabs.push(["p-fit", "Will it fit?"]);
    panes.push(fitPane + '</div>');
  }
  if(cl.energy && p.energy){
    tabs.push(["p-energy", "Energy"]);
    panes.push('<div class="pane" id="p-energy"><div class="dims"><div style="text-align:center">' +
      '<div class="energy-badge">' + esc(p.energy) + '</div>' +
      '<div style="margin-top:14px;color:var(--ink2);font-size:14px">Energy efficiency class</div></div></div>' +
      '<div class="txt"><h3>The honest number.</h3><p>Rated class ' + esc(p.energy) +
      ' for energy efficiency. The official label has the detail.</p>' +
      (p.energyLabel ? '<ul><li><a href="' + esc(p.energyLabel) + '" target="_blank" rel="noopener">View the official energy label →</a></li></ul>' : "") +
      '</div></div>');
  }
  if(tabs.length){
    h += '<section id="closer"><div class="wrap"><h2 class="giant rv">Take a closer look.</h2>' +
      '<div class="tabs rv d1" role="tablist" aria-label="Product details">' + tabs.map(function(t, i){
        return '<button type="button" role="tab" id="tab-' + t[0] + '" class="tab' + (i===0?" on":"") +
          '" data-pane="' + t[0] + '" aria-controls="' + t[0] + '" aria-selected="' + (i===0) +
          '" tabindex="' + (i===0?"0":"-1") + '">' + t[1] + '</button>';
      }).join("") + '</div><div class="panelbox rv d2">' +
      panes.map(function(pane, i){
        return pane.replace('class="pane"', 'class="pane' + (i===0?" on":"") +
          '" role="tabpanel" aria-labelledby="tab-' + tabs[i][0] + '" tabindex="0" aria-hidden="' +
          (i!==0) + '"' + (i===0?"":" inert"));
      }).join("") + '</div></div></section>';
  }

  // straight from the maker (je-pdp-enrich-20260902)
  h += makerHTML(p);

  // full specification
  if(p.spec && p.spec.length){
    h += '<section id="specs"><div class="wrap">' +
      '<span class="kicker rv">Every detail</span>' +
      '<h2 class="giant rv d1">Full specification.</h2>' +
      '<div class="specgroups rv d2">' +
      p.spec.map(function(g, gi){
        return '<details class="sg"' + (gi === 0 ? " open" : "") + '><summary>' + esc(g.t) +
          '<span class="chev"><svg width="12" height="7" viewBox="0 0 12 7" fill="none">' +
          '<path d="M1 1l5 5 5-5" stroke="#d7d7dc" stroke-width="2" stroke-linecap="round"/></svg></span></summary>' +
          '<table class="sg-table"><tbody>' +
          g.r.map(function(row){ return '<tr><td>' + esc(row[0]) + '</td><td>' + esc(row[1]) + '</td></tr>'; }).join("") +
          '</tbody></table></details>';
      }).join("") + '</div>' + downloadsHTML(p) + '</div></section>';
  }

  // our take + independent reviews (je-pdp-enrich-20260902)
  h += ourTakeHTML(p);
  if(MODE !== "pdp") h += reviewsHTML(p);

  // service
  var paidRungs = p.variants.filter(function(v){ return v.price > p.price; });
  h += '<section id="service"><div class="wrap">' +
    '<span class="kicker rv" style="color:var(--green)">Johns Electrical</span>' +
    '<h2 class="giant rv d1">From a real shop<br><span class="dim">in Scunthorpe.</span></h2>' +
    '<p class="lede rv d2">Not a warehouse, not a courier network — a family electrical shop on the high street since 1971. <b>We deliver it ourselves.</b></p>' +
    '<div class="svc-grid">' +
    '<div class="svc rv"><span class="tag free">FREE</span><div class="ic ic-delivery">' + serviceIcon("delivery") + '</div>' +
    '<h3>Free local delivery <small class="je-fd-min" style="font-size:.58em;font-weight:500;opacity:.72;white-space:nowrap;letter-spacing:0">(min. order \u00a3100)</small></h3><p id="svc-delivery-copy">' + esc(LANE_COPY[LANE].svc) + '</p></div>' +
    (paidRungs.length ?
      '<div class="svc rv d1" id="svc-options"><span class="tag paid">OPTIONAL</span><div class="ic ic-install">' + serviceIcon("installation") + '</div>' +
      '<div class="svc-opt-body">' + serviceOptionsBlock(p.variants, p.price, "major") + '</div></div>' : "") +
    '<div class="svc rv d2"><span class="tag free">HUMAN</span><div class="ic ic-contact">' + serviceIcon("contact") + '</div>' +
    /* je-dead-taps-20261019: the numbers are links, so a phone can call, text or WhatsApp. */
    '<h3>Talk to a person</h3><p>Call <a href="tel:01724844040" style="color:inherit;text-decoration:underline;text-underline-offset:3px">01724 844040</a> or <a href="tel:01724843800" style="color:inherit;text-decoration:underline;text-underline-offset:3px">01724 843800</a>, text <a href="sms:+447401332844" style="color:inherit;text-decoration:underline;text-underline-offset:3px">07401 332844</a>, or WhatsApp <a href="https://wa.me/447448567594" target="_blank" rel="noopener" style="color:inherit;text-decoration:underline;text-underline-offset:3px">07448 567594</a>.</p></div>' +
    customerCardHTML() +
    '</div><div data-je-postcode-home>' + postcodeHTML() + '</div></div></section>';

  // warranty — only when the base period is known; extension text verbatim
  if(p.warranty && p.warranty.years){
    h += '<section id="warranty"><div class="halo" aria-hidden="true"></div>' +
      '<span class="kicker rv" style="color:var(--green)">Peace of mind</span>' +
      '<div class="years rv d1"><div class="yrow"><span class="one">' + p.warranty.years + '</span>' +
      '<span class="yunit">year' + (p.warranty.years > 1 ? "s" : "") + '<br>guarantee</span></div>' +
      (p.warranty.ext ? '<span class="yext">+ ' + esc(p.warranty.ext) + '</span>' : '') +
      '</div>' +
      '<p class="lede rv d2" style="margin:16px auto 0;text-align:center">' +
      esc(warrantyLine(p.warranty)) +
      (p.warranty.note ? ' ' + esc(p.warranty.note) : "") + '</p></section>';
  }

  // Every explicit product-gallery image, duplicate-free and in source order.
  if(gallerySet.length){
    h += '<section id="photos"><div class="wrap photos-head">' +
      '<span class="kicker rv">The real product</span>' +
      '<h2 class="giant rv d1">' + (gallerySet.length > 1 ? 'Every angle.' : 'The product.') + '</h2>' +
      (gallerySet.length > 1 ? '<div class="photo-gallery-tools rv d3">' +
        '<span class="photo-gallery-position" aria-live="polite">1 / ' + gallerySet.length + '</span>' +
        '<div class="photo-gallery-buttons">' +
        '<button type="button" class="photo-gallery-arrow" data-gallery-dir="-1" aria-label="Previous product photo" disabled>' +
        '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m15 18-6-6 6-6"/></svg></button>' +
        '<button type="button" class="photo-gallery-arrow" data-gallery-dir="1" aria-label="Next product photo">' +
        '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m9 18 6-6-6-6"/></svg></button>' +
        '</div></div>' : '') + '</div>' +
      '<div class="photo-gallery" id="product-photo-gallery" role="group" aria-label="Product photos" tabindex="0">' +
      gallerySet.map(function(photo, i){
        photo = accessiblePhoto(photo, p, i);
        return '<figure class="photo-gallery-card ' + (photo.cutout ? 'cutout' : 'original') +
          ' rv d' + Math.min(5, i + 1) + '">' +
          '<div class="photo-gallery-stage"><span aria-hidden="true"></span>' +
          productPhotoHTML(photo, "gallery-product-photo", false,
            "(max-width: 700px) 86vw, 780px", [480, 760, 1100, 1400, 1800, 2200]) + '</div>' +
          '<figcaption><b>' + String(i + 1).padStart(2, "0") + '</b>' +
          esc(photoLabel(photo, i)) + '</figcaption></figure>';
      }).join("") + '</div></section>';
  }

  // good to know (je-pdp-convert-20260902)
  h += goodToKnowHTML(p);

  // cta
  h += '<section id="cta"><div class="wrap">' +
    '<h2 class="giant rv">' + esc(shortName) + '.<br><span class="dim">Ready when you are.</span></h2>' +
    '<p class="lede rv d1 cta-lede">' + esc(FINALE_COPY[LANE] || FINALE_COPY.stock) + '</p>' +
    vitrine('rv d1') +
    '<div class="rv d3" style="display:flex;gap:14px;justify-content:center;flex-wrap:wrap">' +
    '<button class="btn big sheet-open" type="button">Add to Bag</button>' +
    /* je-pdp-truth-20260901: on the product page itself "View the product" linked
       to the page it was on, and the fine print still called it a preview page. */
    (MODE === "pdp" ?
      '<a class="btn big ghost" href="https://wa.me/447448567594" target="_blank" rel="noopener">WhatsApp us</a>' :
      '<a class="btn big ghost" href="/products/' + esc(p.handle) + '">View the product</a>') +
    '<a class="btn big ghost" href="/pages/delivery-installation-removal">Delivery area</a></div>' +
    spiCtaSlotHTML() + /* je-spi-promo-20260904 */
    '<p class="fine rv d4">' +
    (p.agency ? "Sold as an Agent of Euronics Ltd. " : "") +
    (p.model ? "Model " + esc(p.model) + ". " : "") +
    'Specification as supplied by the manufacturer, gathered on ' + esc(DATA.built) + '; prices and availability refresh live when this page opens' +
    (MODE === "pdp" ? '. ' : ' — the <a href="/products/' + esc(p.handle) + '">product page</a> is always canonical. ') +
    (p.was ? '“Was” price is the previous Euronics selling price. ' : "") +
    'Delivery within our local area is free on orders of \u00a3100 or more and \u00a315 below that; any fitting option shown is paid.' +
    (MODE === "pdp" ? '' : ' This is a preview page and isn’t linked from the store.') + '</p>' +
    '</div></section>';

  // side category rail + mobile jump menu — one item per section on the page
  var railItems = [["hero", "Overview"]];
  if(heroVideo) railItems.push(["video", "Video"]);
  if(MODE === "pdp" && reviewsHTML(p)) railItems.push(["reviews", "Reviews"]);
  if(rail.length >= 3) railItems.push(["highlights", "At a glance"]);
  chapters.forEach(function(c, i){
    if(controlsMeta && extraControlsChapters.indexOf(i) !== -1) return;
    railItems.push(["ch" + i, controlsMeta && i === controlsChapter ? "Controls" : (c.kicker || ("Part " + (i + 1)))]);
  });
  if(tabs.length) railItems.push(["closer", "Closer look"]);
  if(makerHTML(p)) railItems.push(["maker", "From the maker"]);
  if(p.spec && p.spec.length) railItems.push(["specs", "Specs"]);
  if(ourTakeHTML(p)) railItems.push(["ourtake", "Our take"]);
  if(MODE !== "pdp" && reviewsHTML(p)) railItems.push(["reviews", "Reviews"]);
  railItems.push(["service", "Delivery"]);
  if(p.warranty && p.warranty.years) railItems.push(["warranty", "Guarantee"]);
  if(gallerySet.length) railItems.push(["photos", "Photos"]);
  if(MODE === "pdp") railItems.push(["gtk", "Good to know"]);
  railItems.push(["cta", "Buy"]);
  h += '<nav id="siderail" aria-label="Page sections">' +
    '<span class="je-tour-select-cue" aria-hidden="true"><span>Select</span>' +
    '<svg viewBox="0 0 12 14" fill="none"><path d="M6 1.5v10M2 7.5l4 4 4-4" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg></span>' +
    railItems.map(function(it){
      return '<a href="#' + it[0] + '"><span>' + esc(it[1]) + '</span><i></i></a>';
    }).join("") + '</nav>';
  h += '<button id="jumpfab" type="button" aria-label="Jump to a section">' +
    '<svg width="14" height="12" viewBox="0 0 14 12" fill="none"><path d="M1 1h12M1 6h12M1 11h12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>' +
    'Sections</button>' +
    '<div id="jumpwrap"><div class="scrim"></div><div id="jumpsheet"><h3>Jump to</h3>' +
    railItems.map(function(it){
      return '<a href="#' + it[0] + '" class="jumplink"><i></i>' + esc(it[1]) + '</a>';
    }).join("") + '<div class="je-jump-more" aria-hidden="true"><span>' +
    '<svg viewBox="0 0 20 20" fill="none" focusable="false"><path d="m5 7.5 5 5 5-5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
    '</span></div></div></div>';

  // buy sheet
  h += sheetHTML(p);
  var jePre = jeReadPlaceholder(); /* je-tour-first-paint-20260901 */
  jeCarrySpi(); /* je-spi-promo-20260904: detach the server-rendered panel before the swap destroys it */
  jeCarryExpress(); /* je-tour-express-20261008: same pattern for the express checkout form */
  var jePendingGallery = el('#hero .je-extra-pending-rows', app);
  var jeEarlyDoor = el('#hero .je-door-media', app);
  app.innerHTML = h;
  var jePendingRig = el('#hero .rig-real', app);
  if(jePendingGallery && jePendingRig) jePendingRig.appendChild(jePendingGallery);
  if(jeEarlyDoor && jePendingRig) jePendingRig.replaceWith(jeEarlyDoor);
  // je-know-your-controls-20260905: one small per-product asset, separate from tour rebuilds.
  if(controlsMeta){
    var controlsHost = app.querySelector('[data-je-controls-host]');
    window.JEControlsLoader.mount(controlsHost, controlsIdentity).then(function(ok){
      if(!ok && controlsHost && controlsHost.isConnected){
        var note = document.createElement('p'), manual = document.createElement('a');
        manual.href = controlsMeta.manual_url; manual.target = '_blank'; manual.rel = 'noopener';
        manual.textContent = 'Open the manufacturer’s guide'; note.appendChild(manual); controlsHost.appendChild(note);
      }
    });
  }
  jeAdoptPlaceholder(jePre, p);
  jeAdoptSpi(); /* je-spi-promo-20260904 */
  jeAdoptExpress(); /* je-tour-express-20261008 */

  initTour(p);
}

function warrantyLine(w){
  // "register to activate" means the base period itself is conditional —
  // "as standard" would contradict it (house rule 6h0l: activate ≠ extend)
  var activate = /activate/i.test((w.ext || "") + " " + (w.note || ""));
  return w.years + "-year guarantee" + (activate ? "" : " as standard") +
    (w.ext ? " — " + w.ext + "." : ".");
}

function statsHTML(stats){
  if(!stats || !stats.length) return "";
  return '<div class="statrow">' + stats.map(function(s){
    return '<div class="stat"><div class="n">' + esc(s[0]) + '</div><div class="l">' + esc(s[1]) + '</div></div>';
  }).join("") + '</div>';
}

function fitSVG(f, p){
  var ratio = Math.max(0.45, Math.min(2.4, f.w / f.h));
  var W = 300, H = W / ratio;
  if(H > 210){ H = 210; W = H * ratio; }
  var x = (460 - W) / 2, y = 230 - H;
  var name = esc((p.dna && p.dna.device && p.dna.device.label) || p.vendor);
  return '<svg viewBox="0 0 460 300" fill="none" aria-label="Dimensions diagram">' +
    '<rect x="' + x + '" y="' + y + '" width="' + W + '" height="' + H + '" rx="6" stroke="#3a3a42" stroke-width="2"/>' +
    '<rect x="' + (x+8) + '" y="' + (y+8) + '" width="' + (W-16) + '" height="' + (H-16) + '" rx="3" fill="#0e1730"/>' +
    '<path d="M' + x + ' 262 h' + W + '" stroke="var(--pa)" stroke-width="1.5"/>' +
    '<path d="M' + x + ' 256 v12 M' + (x+W) + ' 256 v12" stroke="var(--pa)" stroke-width="1.5"/>' +
    '<text x="230" y="290" fill="#d7d7dc" font-size="15" text-anchor="middle">' + f.w + ' cm</text>' +
    '<path d="M' + (x+W+22) + ' ' + y + ' v' + H + '" stroke="var(--pb)" stroke-width="1.5"/>' +
    '<path d="M' + (x+W+16) + ' ' + y + ' h12 M' + (x+W+16) + ' ' + (y+H) + ' h12" stroke="var(--pb)" stroke-width="1.5"/>' +
    '<text x="' + (x+W+40) + '" y="' + (y+H/2) + '" fill="#d7d7dc" font-size="14" text-anchor="middle" transform="rotate(90 ' + (x+W+40) + ' ' + (y+H/2) + ')">' + f.h + ' cm</text>' +
    '<text x="230" y="' + (y+H/2+5) + '" fill="var(--pa)" font-size="16" text-anchor="middle" font-weight="700">' + name + '</text></svg>';
}

var RUNG_DESC = {
  "Free Delivery or In-Store Collection": "£15 delivery below £100; free on orders of £100 or more. Free in-store collection.",
  "Disposal": "We take your old appliance away to be recycled.",
  "Installation & Disposal": "Unboxed, connected and working — your old one taken away.",
  "Electrical Installation & Disposal": "Connected by the right trade — your old appliance taken away.",
  "Gas Installation & Disposal": "Fitted by a Gas Safe registered engineer — your old appliance taken away.",
  "Integrated Installation & Disposal": "Built into your cabinetry — your old appliance taken away."
};

/* je-svc-options-20260827 — Will: "specify the options on the page."
   The service block used to compress every paid rung into one run-on line
   ("<b>Installation & Disposal</b> +£35 · <b>Integrated…</b> +£105 — pick it
   when you add to bag"), so the shopper saw a price with no idea what it buys.
   Now each rung is its own row: its title, what it actually includes (the SAME
   RUNG_DESC the buy sheet uses — one copy, so the card and the sheet can never
   describe a rung differently), and what it adds.

   No install label or price is typed here. The title prints from v.title and
   the figure is computed from the two variant prices, because "Installation" is
   one label at two prices (£35 / £55) and the £10 rung is "Disposal", not an
   installation at all — house rule, and the reason the heading is DERIVED from
   the rung titles rather than written. Getting that wrong advertises fitting on
   a product where we only take the old machine away.

   Rendered from the frozen asset first and re-rendered from the live
   /products/<handle>.js payload on open (see the hydration block), against the
   same anchor the price row and the buy sheet use — so all three agree. */
function serviceOptionsBlock(variants, anchorPrice, priceUnit){
  var paid = (variants || []).filter(function(v){
    return Number(v.price) > Number(anchorPrice);
  });
  if(!paid.length) return "";
  var titles = paid.map(function(v){ return String(v.title || ""); });
  var heading = titles.some(function(t){ return /install/i.test(t); }) ? "Installation options"
    : titles.some(function(t){ return /disposal/i.test(t); })
      ? (paid.length > 1 ? "Disposal options" : "Disposal option")
      : "Optional extras";
  return '<h3>' + heading + '</h3><ul class="svc-opts">' + paid.map(function(v){
    var title = String(v.title || "");
    var desc = RUNG_DESC[title];
    return '<li class="svc-opt"><span class="svc-opt-txt">' +
      '<span class="t">' + esc(title) + '</span>' +
      (desc ? '<span class="d">' + esc(desc) + '</span>' : "") + '</span>' +
      '<span class="p">+' + money((Number(v.price) - Number(anchorPrice)) / (priceUnit === "minor" ? 100 : 1)) + '</span></li>';
  }).join("") + '</ul>' +
    '<p class="svc-note">Choose yours when you add to bag — or leave it as delivery only.</p>';
}

function liveRungsHTML(variants, anchorPrice){
  return variants.map(function(v){
    var title = String(v.title || "Product option");
    // Presentation only: preserve the canonical variant/pricing identity.
    var displayTitle = title === "Free Delivery or In-Store Collection" ? "Delivery or Free In-Store Collection" : title;
    var available = !!v.available;
    var delta = (Number(v.price) - Number(anchorPrice)) / 100;
    var description = available ? (RUNG_DESC[title] || "Select this option.") : "Currently unavailable";
    return '<button class="rung" type="button" data-variant="' + attr(v.id) + '" ' +
      'data-live-available="' + (available ? "true" : "false") + '"' + (available ? "" : " disabled") + '>' +
      '<span><span class="t">' + esc(displayTitle) + '</span>' +
      '<span class="d">' + esc(description) + '</span></span>' +
      '<span class="p"><span class="rung-price">' + money(Number(v.price) / 100) + '</span>' +
      (delta > 0 ? '<em>+' + money(delta) + '</em>' : "") +
      (available ? '<span class="rung-action">Add to bag</span>' : "") + '</span></button>';
  }).join("");
}

function sheetHTML(p){
  return '<div id="sheetWrap" role="dialog" aria-modal="true" aria-label="Add to bag"><div class="scrim"></div>' +
    '<div id="sheet"><button class="close" type="button" aria-label="Close">&times;</button>' +
    '<h3>' + esc(shortProductName(p)) + '</h3>' +
    '<p class="sheet-step">Choose an option below to add to your bag.</p>' +
    '<p class="sub">Free in-store collection on every option. Delivery is free on orders of \u00a3100 or more.</p>' +
    '<div class="rungs" aria-live="polite"><p class="sheet-loading">Checking live options…</p></div>' +
    '<p class="sheet-pending" role="status" aria-live="polite"></p>' +
    '<div class="sheet-error" role="alert" hidden><p></p><a href="/cart">Check your bag</a></div>' +
    '<div class="state" role="status"><div class="tick" aria-hidden="true">✓</div><p>Added to your bag.</p>' +
    '<a class="btn big" href="/cart">View Bag &amp; Checkout</a>' +
    '<button class="btn big ghost sheet-close-btn" type="button">Keep browsing</button></div>' +
    '<p class="note">' + (p.was ? "Genuine Euronics price — was " + money(p.was) + ". " : "") +
    (p.agency ? "Sold as an Agent of Euronics Ltd." : "") + '</p></div></div>';
}

/* ================= TOUR INIT ================= */
function initTour(p){
  jeInitMeasurements(p);
  initEnrichUI();
  mountPurchasePostcode();
  var bar = el("#progress"), lnav = el("#localnav"), pdpbar = el("#pdpbar");
  var railLinks = els("#siderail a", app);
  var railTargets = railLinks.map(function(a){ return el(a.getAttribute("href")); });
  var photoBeats = els(".photo-beat", app);
  var railActive = -1;
  fitAllProductPhotos(app);
  on(window, "resize", function(){ fitAllProductPhotos(app); }, {passive:true});
  function syncPdpClearance(){
    if(MODE === "pdp" && pdpbar){
      app.style.setProperty("--pdpbar-clearance", Math.ceil(pdpbar.getBoundingClientRect().height + 12) + "px");
    }
  }
  syncPdpClearance();
  on(window, "resize", syncPdpClearance, {passive:true});
  setTimeout(jeOwned(syncPdpClearance), 400);
  /* je-tour-railclear-20260826: the section rail is a fixed overlay in the
     right gutter and its width depends on the longest label on THIS product,
     so measure it and let the stylesheet reserve exactly that much. Measured
     in viewport units (innerWidth) because the CSS side works in 100vw.
     Anything unreadable publishes 0px, i.e. shift nothing — a wrong gutter is
     worse than the overlap it would be correcting. */
  var siderail = el("#siderail", app);
  function syncRailGutter(){
    var w = 0;
    if(siderail && getComputedStyle(siderail).display !== "none"){
      w = Math.ceil(window.innerWidth - siderail.getBoundingClientRect().left);
      if(!(w > 0) || w > window.innerWidth * 0.5) w = 0;
    }
    document.documentElement.style.setProperty("--je-railw", w + "px");
  }
  syncRailGutter();
  on(window, "resize", syncRailGutter, {passive:true});
  setTimeout(jeOwned(syncRailGutter), 400);
  if(document.fonts && document.fonts.ready) document.fonts.ready.then(jeOwned(syncRailGutter));
  /* je-perf-motion-20260829: ONE rAF-coalesced controller, and inside it EVERY
     geometry read happens before ANY style write.

     Before this, trackRail / trackPhotos / checkReveals each alternated a
     getBoundingClientRect with a class or custom-property write, and all three
     ran straight off the scroll event.  So the browser had to flush layout
     between them, over and over, inside a single scroll: measured live at 4x
     CPU throttle, 6,388 forced synchronous layouts and 90 rect reads per
     scroll event, frame p50 83.3ms.

     Nothing about the result moved.  The same rail link gets `on` at the same
     scroll position, --photo-shift takes the same value from the same formula,
     the reveal thresholds are the same 0.75 / 1.35 / -120 / -180, and the
     progress fraction is identical and is still written as a width -- see the
     "MEASURED AND DECLINED" note at the bottom of this file for why. */
  var jeRvPrevY = -1, jeRvPrevT = 0;
  /* je-reveal-settle-20260831: is the page ARRIVING here rather than being scrolled
     here?  Two cases, and both mean the entrance would not be seen anyway:
  
       a JUMP  - more than 1.1 viewports in one frame (an anchor, a scrollbar drag,
                 a restored position, a fling that outruns the frame).
       SPEED   - over 4 px per millisecond, i.e. ~4000px/s.  A brisk reading scroll
                 is around 1000px/s and a hard fling is 5000-6000, so this catches
                 the fling and leaves ordinary scrolling alone.
  
     ⛔ The speed test is px/ms, NOT px/frame.  A per-frame delta means different
        speeds on different displays - the same fling is ~50px/frame at 120Hz and
        ~100px/frame at 60Hz - so a per-frame threshold would snap on one of Will's
        monitors and not the other.  Dividing by the real elapsed time is what makes
        the rule the same physical speed everywhere.
  
     MEASURED, and this is why the speed arm exists at all: with only the jump test,
     a fast scroll left every entrance it passed still running (25 concurrent 1.6s
     transitions, 141 animations against 101), and the first scroll after a load went
     from 24% of frames missing the 120Hz budget to 79%.  One-shot fixed the replays
     and moved the cost into the first pass; this is the other half of that fix. */
  function jeRvJumped(y, vh){
    var now = (window.performance && performance.now) ? performance.now() : Date.now();
    var was = jeRvPrevY, wasT = jeRvPrevT;
    jeRvPrevY = y; jeRvPrevT = now;
    if(was < 0) return false;
    var dy = Math.abs(y - was), dt = Math.max(1, now - wasT);
    return dy > vh * 1.1; /* je-smooth-reveal-20261021: a fast scroll no longer snaps what is on screen */
  }
  var jeScrollFrame = 0;
  function jeReadScroll(){
    /* ---- READ PASS: no style write may happen above this line ---- */
    var hh = document.documentElement;
    var top = hh.scrollTop, vh = window.innerHeight, i;
    var st = {
      progress: top / Math.max(1, hh.scrollHeight - hh.clientHeight),
      lnav: top > vh * 0.55,
      pdpbar: top > 260 || window.innerWidth <= 760, /* je-phone-buybar-20261010: on from load on a phone */
      rail: 0,
      photos: null,
      reveals: null,
      snap: false
    };
    for(i = 0; i < railTargets.length; i++){
      if(railTargets[i] && railTargets[i].getBoundingClientRect().top < vh * 0.45) st.rail = i;
    }
    if(!reduced && photoBeats.length){
      st.photos = [];
      for(i = 0; i < photoBeats.length; i++){
        var r = photoBeats[i].getBoundingClientRect();
        if(r.bottom < -100 || r.top > vh + 100){ st.photos.push(null); continue; }
        var progress = ((r.top + r.height / 2) - vh / 2) / Math.max(vh, 1);
        st.photos.push((Math.max(-1, Math.min(1, progress)) * -18).toFixed(1) + "px");
      }
    }
    st.reveals = jeReadReveals(vh);
    st.snap = jeRvJumped(top, vh);
    return st;
  }
  function jeWriteScroll(st){
    /* ---- WRITE PASS ---- */
    if(bar) bar.style.width = (st.progress * 100).toFixed(2) + "%";
    if(lnav) lnav.classList.toggle("on", st.lnav);
    if(pdpbar) pdpbar.classList.toggle("on", st.pdpbar);
    if(st.rail !== railActive){
      railActive = st.rail;
      railLinks.forEach(function(a, j){ a.classList.toggle("on", j === st.rail); if(j === st.rail) a.setAttribute("aria-current", "location"); else a.removeAttribute("aria-current"); });
    }
    if(st.photos){
      for(var i = 0; i < st.photos.length; i++){
        var v = st.photos[i];
        /* null = off screen, which is exactly what the old early `return` did:
           the beat keeps whatever shift it had when it left. */
        if(v === null) continue;
        var beat = photoBeats[i];
        if(beat.__jeShift === v) continue;          // unchanged: do not re-write it
        beat.__jeShift = v;
        beat.style.setProperty("--photo-shift", v);
      }
    }
    jeWriteReveals(st.reveals, st.snap);
  }
  /* ⛔ ONE rAF, not two.  Coalescing the scroll work into its OWN rAF still
     leaves two independent callbacks per frame, and measured on the live page
     the chapter loop's writes landed BEFORE this one's reads: 36 forced
     layouts in a 120-step scroll, blamed on `jeReadScroll after Object.tick`.
     So when the chapter loop is alive it services the scroll itself, in the
     right order, and this private rAF is only the fallback for a page with no
     pins, no pageFX and no highlights rail - nothing to keep a loop running. */
  var jeScrollDirty = false;
  function jeServiceScroll(){
    if(!jeScrollDirty) return null;
    jeScrollDirty = false;
    return jeReadScroll();
  }
  function onScroll(){
    jeScrollDirty = true;
    if(rafAlive || jeScrollFrame) return;
    jeScrollFrame = requestAnimationFrame(function(){
      jeScrollFrame = 0;
      var st = jeServiceScroll();
      if(st) jeWriteScroll(st);
    });
  }
  on(window, "scroll", onScroll, {passive:true});
  on(window, "resize", onScroll, {passive:true});
  cleanup.push(function(){ if(jeScrollFrame){ cancelAnimationFrame(jeScrollFrame); jeScrollFrame = 0; } });
  on(window, "pagehide", function(){
    if(jeScrollFrame) cancelAnimationFrame(jeScrollFrame);
    jeScrollFrame = 0;
  }, false);
  /* bfcache restore hands the page back mid-state: re-assert from the real
     scroll position rather than from whatever was frozen into it */
  on(window, "pageshow", function(e){ if(e.persisted) onScroll(); }, false);
  jeWriteScroll(jeReadScroll());

  var backlink = el("#backlink");
  if(backlink) backlink.addEventListener("click", function(e){ e.preventDefault(); nav(null); });

  /* PDP mode: the theme header was designed for a light page — lighten only the
     links that sit directly on the (now dark) bar; links inside light dropdown
     panels keep their own colour */
  if(MODE === "pdp"){
    els("header.topbar a").forEach(function(a){
      var n = a, onLight = false;
      while(n && n !== document.body){
        var m = getComputedStyle(n).backgroundColor
          .match(/rgba?\((\d+), (\d+), (\d+)(?:, ([\d.]+))?\)/);
        if(m && (m[4] === undefined || +m[4] > 0.5)){
          onLight = (+m[1] > 180 && +m[2] > 180 && +m[3] > 180);
          break;
        }
        n = n.parentElement;
      }
      if(!onLight) a.style.color = "#f5f5f7";
    });
  }

  /* Every photography surface fails closed. Raw originals are accepted only
     in the explicit final gallery; they can never become hero/story fallback. */
  els(".rig-real img,.photo-beat img,.pane .media img,.photo-gallery-card img,.pcard .thumb img", app).forEach(function(img){
    function markPhotoFailure(){
      if(img.classList.contains("product-photo-overlay")){
        img.classList.add("overlay-failed"); return;
      }
      var media = img.closest(".rig-real,.photo-beat,.pane .media,.photo-gallery-card,.pcard .thumb");
      if(media) media.classList.add("media-failed");
    }
    if(img.complete && !img.naturalWidth) markPhotoFailure();
    else img.addEventListener("error", markPhotoFailure);
  });

  /* The final gallery supports native touch swiping plus clear desktop controls.
     Controls always advance one complete product image and mirror manual swipes. */
  var productGallery = el("#product-photo-gallery", app);
  if(productGallery){
    var galleryCards = els(".photo-gallery-card", productGallery);
    var galleryPosition = el(".photo-gallery-position", app);
    var galleryArrows = els(".photo-gallery-arrow", app);
    var galleryIndex = 0, galleryTicking = false;
    function galleryTargetLeft(card){
      return Math.max(0, card.offsetLeft - (productGallery.clientWidth - card.offsetWidth) / 2);
    }
    function setGalleryIndex(next, move){
      galleryIndex = Math.max(0, Math.min(galleryCards.length - 1, next));
      if(move && galleryCards[galleryIndex]){
        productGallery.scrollTo({left:galleryTargetLeft(galleryCards[galleryIndex]),behavior:reduced?"auto":"smooth"});
      }
      if(galleryPosition) galleryPosition.textContent = (galleryIndex + 1) + " / " + galleryCards.length;
      galleryArrows.forEach(function(button){
        var dir = Number(button.getAttribute("data-gallery-dir"));
        button.disabled = dir < 0 ? galleryIndex === 0 : galleryIndex === galleryCards.length - 1;
      });
    }
    function syncGalleryIndex(){
      galleryTicking = false;
      var centre = productGallery.scrollLeft + productGallery.clientWidth / 2;
      var best = 0, distance = Infinity;
      galleryCards.forEach(function(card, i){
        var d = Math.abs(card.offsetLeft + card.offsetWidth / 2 - centre);
        if(d < distance){ distance = d; best = i; }
      });
      setGalleryIndex(best, false);
    }
    galleryArrows.forEach(function(button){
      on(button, "click", function(){ setGalleryIndex(galleryIndex + Number(button.getAttribute("data-gallery-dir")), true); });
    });
    on(productGallery, "scroll", function(){
      if(!galleryTicking){ galleryTicking = true; requestAnimationFrame(syncGalleryIndex); }
    }, {passive:true});
    on(productGallery, "keydown", function(e){
      if(e.key !== "ArrowLeft" && e.key !== "ArrowRight") return;
      e.preventDefault();
      setGalleryIndex(galleryIndex + (e.key === "ArrowLeft" ? -1 : 1), true);
    });
    on(window, "resize", syncGalleryIndex, {passive:true});
    setGalleryIndex(0, false);
  }

  /* ---- product highlights perspective carousel — je-pdp-perspective-20261006 ---- */
  var hlDeck = el("#highlights .hl-deck", app);
  if(hlDeck) (function(){
    if(hlDeck.getAttribute("data-hl-deck-ready") === "true") return;
    hlDeck.setAttribute("data-hl-deck-ready", "true");
    // je-pdp-perspective-20261006: same perspective geometry as the homepage gallery.
    hlDeck.setAttribute("data-hl-perspective", "true");
    cleanup.push(window.JE_BRIEF_CARDS.bind(hlDeck));
    var hlCards = els(".hcard", hlDeck);
    if(!hlCards.length) return;
    var hlControls = el(".highlight-controls", app);
    var hlArrows = els(".highlight-arrow", app);
    var hlCount = el("[data-hl-count]", app);
    var hlDotsBox = el("[data-hl-dots]", app);
    /* cards deeper than this are display:none, not merely transparent */
    var HL_DEPTH = 2;
    var hlSuppressUntil = 0;
    /* commit at just over a fifth of a card — the drag maps 1:1 with the finger
       (translateX is min(--d,0) * 100% of the card), so this IS the distance the
       card has physically travelled */
    var HL_COMMIT = 0.22, HL_FLICK = 0.55;
    var hlIndex = 0, hlDrag = 0, hlDots = [];
    var hlDown = false, hlAxis = "", hlPointer = null, hlCaptured = false;
    var hlSX = 0, hlSY = 0, hlST = 0, hlLX = 0, hlLT = 0;
    function hlWidth(){
      var c = hlCards[hlIndex];
      return (c && c.offsetWidth) || hlDeck.offsetWidth || 320;
    }
    function hlDistance(index, base){
      var n = hlCards.length;
      return ((index - base + n / 2) % n + n) % n - n / 2;
    }
    /* je-glance-flat-20261017 (Will 17 Oct 2026, iPad Safari): the 6 Oct wheel drew up
       to seven see-through cards in 3D, each neighbour BEHIND the front one, so its words
       read through the glass and WebKit re-rendered every blurred tint on each drag frame.
       Now a flat row: a neighbour sits beside the front card with a gap, never behind it,
       smaller and dimmer; only the two neighbours are drawn. Transform and opacity only. */
    var hlMobileMQ = window.matchMedia("(max-width:820px)");
    function hlGeom(){
      var mobile = hlMobileMQ.matches;
      return { s: mobile ? .88 : .86, gap: mobile ? 14 : 24 };
    }
    /* centre-to-centre distance between the front card and a neighbour */
    function hlStep(){
      var g = hlGeom();
      return hlWidth() * (1 + g.s) / 2 + g.gap;
    }
    function hlPaint(){
      var base = hlIndex + hlDrag, g = hlGeom(), w = hlWidth();
      var near = w * (1 + g.s) / 2 + g.gap, far = w * g.s + g.gap;
      for(var i = 0; i < hlCards.length; i++){
        var c = hlCards[i], d = hlDistance(i, base), a = Math.abs(d), k = Math.min(a, 1);
        var x = (k * near + Math.max(a - 1, 0) * far) * (d < 0 ? -1 : 1);
        c.style.transform = "translate3d(" + x.toFixed(1) + "px,0,0) scale(" + (1 - k * (1 - g.s)).toFixed(4) + ")";
        c.style.opacity = a >= 1.9 ? "0" : String(a <= 1 ? 1 - a * .45 : .55 * (1.9 - a) / .9);
        c.style.zIndex = String(20 - Math.round(a * 2));
        c.style.pointerEvents = a <= 1.25 ? "auto" : "none";
      }
    }
    /* everything that must NOT churn during a drag: which cards exist, which one
       a screen reader meets, the arrows, the dots */
    function hlSync(){
      for(var i = 0; i < hlCards.length; i++){
        var c = hlCards[i], d = hlDistance(i, hlIndex);
        c.style.setProperty("--d", String(d));
        if(d !== 0 && c.contains(document.activeElement)) hlDeck.focus({preventScroll:true});
        c.inert = Math.abs(d) > HL_DEPTH;
        els("a,button", c).forEach(function(node){ node.tabIndex = d === 0 ? 0 : -1; });
        var show = Math.abs(d) <= HL_DEPTH;
        if(c.hidden === show) c.hidden = !show;
        if(d === 0){
          c.classList.add("hl-live");
          c.removeAttribute("aria-hidden");
        } else {
          c.classList.remove("hl-live");
          c.setAttribute("aria-hidden", "true");
        }
      }
      hlArrows.forEach(function(button){
        var dir = Number(button.getAttribute("data-highlight-dir"));
        button.disabled = hlCards.length <= 1;
      });
      if(hlCount) hlCount.textContent = "Highlight " + (hlIndex + 1) + " of " + hlCards.length;
      for(var k = 0; k < hlDots.length; k++){
        if(k === hlIndex) hlDots[k].setAttribute("aria-current", "true");
        else hlDots[k].removeAttribute("aria-current");
      }
      hlPaint();
    }
    function hlGo(to){
      var want = (to % hlCards.length + hlCards.length) % hlCards.length;
      if(want === hlIndex && !hlDrag) return;
      hlIndex = want; hlDrag = 0;
      hlSync();
    }
    on(hlDeck, "click", function(e){
      if(performance.now() < hlSuppressUntil){ e.preventDefault(); e.stopPropagation(); return; }
      var card = e.target.closest('.hcard'), index = hlCards.indexOf(card);
      if(index >= 0 && index !== hlIndex){
        e.preventDefault(); e.stopPropagation(); hlGo(index);
      }
    }, {capture:true});
    on(window, "resize", function(){ if(!hlDown) hlPaint(); }, {passive:true});
    if(hlControls) hlControls.hidden = hlCards.length <= 1;
    if(hlDotsBox && hlCards.length > 1){
      for(var hn = 0; hn < hlCards.length; hn++){
        var hlDot = document.createElement("button");
        hlDot.type = "button";
        hlDot.setAttribute("aria-label", "Highlight " + (hn + 1) + " of " + hlCards.length);
        hlDot.addEventListener("click", (function(to){
          return function(){ hlGo(to); };
        })(hn));
        hlDotsBox.appendChild(hlDot);
        hlDots.push(hlDot);
      }
    }
    hlArrows.forEach(function(button){
      on(button, "click", function(){
        hlGo(hlIndex + Number(button.getAttribute("data-highlight-dir")));
      });
    });
    function hlRelease(commit, event){
      if(event && hlPointer !== event.pointerId) return;
      if(!hlDown) return;
      if(event && isFinite(event.clientX)){ hlLX = event.clientX; hlLT = event.timeStamp; }
      hlDown = false;
      if(hlAxis === "x") hlSuppressUntil = performance.now() + 500;
      hlDeck.classList.remove("is-dragging");
      var v = 0, dt = hlLT - hlST;
      if(dt > 0) v = (hlLX - hlSX) / dt;          /* px per ms, signed */
      var flick = Math.abs(v) > HL_FLICK && (v < 0) === (hlDrag > 0);
      var step = 0;
      var moved = hlLX - hlSX;
      var threshold = Math.min(hlWidth() * HL_COMMIT, window.matchMedia('(max-width:900px)').matches ? 40 : Infinity);
      if(commit && hlAxis === 'x' && (Math.abs(moved) >= threshold || (flick && Math.abs(moved) > 14))){
        step = moved < 0 ? 1 : -1;
      }
      hlDrag = 0;
      if(step) hlGo(hlIndex + step); else hlPaint();
      hlAxis = "";
      if(hlCaptured && hlPointer != null && hlDeck.hasPointerCapture && hlDeck.hasPointerCapture(hlPointer)){
        try{ hlDeck.releasePointerCapture(hlPointer); }catch(_e){}
      }
      hlCaptured = false;
      hlPointer = null;
    }
    on(hlDeck, "pointerdown", function(e){
      if(e.target.closest("a,button,input,select,textarea")) return;
      if(hlDown || e.isPrimary === false || (e.pointerType === "mouse" && e.button !== 0)) return;
      hlDown = true; hlAxis = ""; hlDrag = 0;
      hlPointer = e.pointerId; hlCaptured = false;
      hlSX = hlLX = e.clientX; hlSY = e.clientY;
      hlST = hlLT = e.timeStamp;
    }, {passive:true});
    on(hlDeck, "pointermove", function(e){
      if(!hlDown || e.pointerId !== hlPointer) return;
      var mx = e.clientX - hlSX, my = e.clientY - hlSY;
      /* decide the axis ONCE, or a mostly-vertical page scroll drags the deck a
         few pixels sideways every time it goes past */
      if(!hlAxis){
        if(Math.abs(mx) < 8 && Math.abs(my) < 8) return;
        hlAxis = Math.abs(mx) > Math.abs(my) ? "x" : "y";
        if(hlAxis === "y"){ hlRelease(false, e); return; }
        /* Capture only after horizontal intent wins.  Vertical scrolling and
           pinch zoom therefore remain native until the deck owns the gesture. */
        if(hlDeck.setPointerCapture){ try{ hlDeck.setPointerCapture(e.pointerId); hlCaptured = true; }catch(_e){} }
        hlDeck.classList.add("is-dragging");
      }
      hlLX = e.clientX; hlLT = e.timeStamp;
      var p = -mx / hlStep();
      hlDrag = Math.max(-1, Math.min(1, p));
      hlPaint();
    }, {passive:false});
    /* Window cleanup covers a release after the finger leaves the viewport.
       pointerleave must not commit: it fires while an otherwise valid drag is
       still in flight. */
    on(window, "pointerup", function(e){ hlRelease(true, e); }, {passive:true});
    on(window, "pointercancel", function(e){ hlRelease(false, e); }, {passive:true});
    on(hlDeck, "lostpointercapture", function(e){ if(e.target === hlDeck) hlRelease(false, e); }, {passive:true});
    /* the tiles carry no links, but a text node can still start a native drag in
       Firefox/Safari; the CSS user-select:none plus this covers both engines */
    on(hlDeck, "dragstart", function(e){ e.preventDefault(); });
    on(hlDeck, "keydown", function(e){
      if(e.key === "ArrowRight"){ e.preventDefault(); hlGo(hlIndex + 1); }
      else if(e.key === "ArrowLeft"){ e.preventDefault(); hlGo(hlIndex - 1); }
      else if(e.key === "Home"){ e.preventDefault(); hlGo(0); }
      else if(e.key === "End"){ e.preventDefault(); hlGo(hlCards.length - 1); }
    });
    /* je-glance-flat-20261017: the row runs to the screen edges, so the "On this page"
       rail steps aside while the cards are on screen instead of sitting on top of them. */
    var hlRail = el("#siderail", app);
    if(hlRail && "IntersectionObserver" in window){
      var hlRailIO = new IntersectionObserver(function(entries){
        hlRail.classList.toggle("je-rail-yield", entries[entries.length - 1].isIntersecting);
      }, {rootMargin: "0px 0px -12% 0px"});
      hlRailIO.observe(hlDeck);
      cleanup.push(function(){ hlRailIO.disconnect(); hlRail.classList.remove("je-rail-yield"); });
    }
    hlSync();
  })();

  /* je-scrollcue-tap-20261013 (Will 2026-10-13): the hero's "Scroll" cue read as a
     button and did nothing; a shopper tapped it ten times in a row. A tap now moves
     the page to the section under the hero. Bound once at the document: the
     placeholder hero and the engine's own hero both carry the cue. */
  if(!window.__jeScrollCueTap){
    window.__jeScrollCueTap = 1;
    document.addEventListener("click", function(e){
      try{
        var cue = e.target && e.target.closest ? e.target.closest(".scrollcue") : null;
        if(!cue) return;
        var hero = cue.closest("header") || cue.parentNode;
        var next = hero ? hero.nextElementSibling : null;
        while(next && !(next.offsetHeight > 0)) next = next.nextElementSibling;
        var calm = !!(window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches);
        /* scrollIntoView, not a computed offset: it honours the section's own
           scroll-margin, so the heading clears the floating top bar. */
        if(next && next.scrollIntoView){
          try{ next.scrollIntoView({ behavior: calm ? "auto" : "smooth", block: "start" }); }
          catch(err){ next.scrollIntoView(true); }
        } else {
          window.scrollBy(0, Math.round(window.innerHeight * 0.85));
        }
      }catch(err){}
    });
  }

  /* mobile jump menu; je-jump-scroll-cue-20260919 */
  var jumpwrap = el("#jumpwrap"), jumpfab = el("#jumpfab"), jumpsheet = el("#jumpsheet");
  if(jumpfab && jumpwrap && jumpsheet){
    function syncJumpMore(){
      if(!jumpwrap.classList.contains("open")) return;
      var more = jumpsheet.scrollHeight - jumpsheet.clientHeight - jumpsheet.scrollTop > 2;
      jumpsheet.classList.toggle("has-more", more);
    }
    on(jumpfab, "click", function(){ jumpwrap.classList.add("open"); syncJumpMore(); });
    on(el(".scrim", jumpwrap), "click", function(){ jumpwrap.classList.remove("open"); });
    els(".jumplink", jumpwrap).forEach(function(a){
      on(a, "click", function(){ jumpwrap.classList.remove("open"); });
    });
    on(jumpsheet, "scroll", syncJumpMore, {passive:true});
    on(window, "resize", syncJumpMore, {passive:true});
    if(typeof ResizeObserver === "function"){
      var jumpSizeObserver = new ResizeObserver(syncJumpMore);
      jumpSizeObserver.observe(jumpsheet);
      cleanup.push(function(){ jumpSizeObserver.disconnect(); });
    }
    if(document.fonts && document.fonts.ready){
      document.fonts.ready.then(jeOwned(function(){ if(jumpsheet.isConnected) syncJumpMore(); }));
    }
  }

  /* reveal engine (scroll-position based). Entrances REPLAY when an element
     leaves the viewport and comes back (Will 2026-08-25); any element marked
     .rvdone stays one-shot. */
  var rvEls = els(".rv", app);
  /* je-smooth-reveal-20261021: register what this engine will reveal; only these fade (CSS .rv.rvw). */
  if(!reduced) rvEls.forEach(function(e){ if(!e.classList.contains("rvdone") && !e.classList.contains("in")) e.classList.add("rvw"); });
  /* je-perf-motion-20260829: split into a read pass and a write pass so the caller can
     do all of its geometry first.  The thresholds, the hysteresis and the
     resulting class are unchanged; the difference is that a class is only
     TOGGLED when it actually differs, so a settled page writes nothing at all.
     State is read back off the element with classList.contains rather than
     cached on it - a cached flag would silently desync if anything else ever
     touched `in`, and contains() is not a layout read. */
  function jeReadReveals(vh){
    /* ⛔ `var rvEls` is declared ~250 lines BELOW this function and the scroll
       controller runs one pass at init, so on that first call the var is
       hoisted-but-undefined and `rvEls.length` throws.  Measured: 186 page
       errors on the candidate and the tour engine never finished booting, on
       every one of the 255 PDPs.  The old code was safe only because it called
       trackRail()/trackPhotos() at init and checkReveals() separately, after
       the declaration.  A null here is the same thing: no reveal work yet. */
    if(!rvEls) return null;
    var out = null;
    for(var i = 0; i < rvEls.length; i++){
      var elm = rvEls[i];
      if(elm.classList.contains("rvdone")) continue;
      var has = elm.classList.contains("in"), want = has;
      // A one-shot entrance cannot change an element that already arrived.
      // Read the live class each time so an external reset still works.
      if(has) continue;
      var r = elm.getBoundingClientRect();
      /* je-reveal-onscreen-20260826 (Will): arm only once the element's top is inside the top 75% of the
         viewport -- a quarter-screen above the bottom edge, so the entrance plays on screen.
         It used to arm at 1.2 * vh, a fifth of a screen BELOW the bottom edge, so the
         entrance was over before it was seen. */
      /* (.rv keeps opacity:1 in je-tour-engine.css, so text is never invisible
         while it waits -- it only holds its 24px offset.) */
      /* je-reveal-settle-20260831: ONE-SHOT.  The `else if` that used to sit here
         set want = false once the element passed vh*1.35 or -180, so scrolling
         back up and down again REPLAYED the 1.6s entrance - measured live at 26
         replays on the homepage and 46 on a PDP in a single down/up/down cycle.
         An entrance is an arrival; it happens once.  `want` can now only rise,
         so nothing that has already arrived can be sent back to its 24px offset. */
      /* je-smooth-reveal-20261021: arm as soon as it enters; already scrolled past = 2 (placed, never seen moving). */
      if(r.top < vh){ want = r.bottom < 0 ? 2 : true; }
      if(want !== has){ (out || (out = [])).push(elm, want); }
    }
    return out;
  }
  function jeWriteReveals(list, snap){
    if(!list) return;
    var jePlaced = false, jeArrived = [];
    /* je-reveal-settle-20260831: `snap` means the page ARRIVED here rather than
       scrolled here (a jump of more than 1.1 viewports in one frame - a fling, a
       scrollbar drag, an anchor, a restored position).  Content you land on
       should already be there; running its entrance means watching the thing you
       jumped to slide into place for up to 1.6s.  .rvsnap zeroes the duration for
       exactly the frame the class is added in, and is removed on the next one so
       every other transition the element owns (the .rev hover lift rides
       `translate`) is untouched. */
    for(var i = 0; i < list.length; i += 2){
      if(list[i + 1] === 2 || (snap && list[i + 1])){ list[i].classList.add("rvsnap"); jePlaced = true; }
      list[i].classList.toggle("in", !!list[i + 1]);
      if(list[i + 1] && list[i].classList.contains("rvw")) jeArrived.push(list[i]);
    }
    if(jeArrived.length) setTimeout(jeOwned(function(){
      for(var k = 0; k < jeArrived.length; k++) jeArrived[k].classList.remove("rvw");
    }), 1600);
    if(snap || jePlaced) requestAnimationFrame(jeOwned(function(){
      for(var j = 0; j < list.length; j += 2) list[j].classList.remove("rvsnap");
    }));
  }
  function checkReveals(){ jeWriteReveals(jeReadReveals(window.innerHeight)); }
  checkReveals();
  setTimeout(jeOwned(checkReveals), 250); setTimeout(jeOwned(checkReveals), 900);

  /* The hero rig deliberately has no scroll transform.  It stays in normal
     flow so its clipped product stage can never move across the Scroll cue. */

  /* whole-page ambient effect (PDP only) — see mountPageFX.
     The module comes off `p` because `d` is renderTour's local, not initTour's;
     reaching for it here throws a ReferenceError that the PDP boot's own
     .catch() swallows in silence, taking every later wiring step with it. */
  var pageFX = mountPageFX((p.dna && p.dna.module) || "glow");

  /* pinned chapters: counters + morph + canvases */
  var pins = els(".pin-outer", app).map(function(o){
    var canvas = el("canvas", o);
    return {
      outer: o, inner: el(".pin .inner", o),
      counterEl: el(".counter", o),
      counterTarget: el(".counter", o) ? Number(el(".counter", o).getAttribute("data-target")) : 0,
      counterSuffix: el(".counter", o) ? el(".counter", o).getAttribute("data-suffix") : "",
      lastVal: -1, fit: 1,
      fx: canvas ? makeFX(canvas, o.getAttribute("data-module")) : null
    };
  });
  /* clip guard (Will 2026-08-25 "look for cut off text"): if a pinned chapter's
     content is taller than the pin at THIS window size, scale it to fit —
     transform doesn't change scrollHeight, so the measurement stays honest */
  function fitPins(){
    pins.forEach(function(pn){
      var pin = pn.outer.querySelector(".pin");
      pn.flow = getComputedStyle(pin).position !== "sticky";
      /* je-section-jump-20261019: measure the room inside the bar padding */
      var pinCs = getComputedStyle(pin);
      var pinH = pin.clientHeight - (parseFloat(pinCs.paddingTop) || 0) - (parseFloat(pinCs.paddingBottom) || 0);
      pn.fit = pinH > 0 ? Math.min(1, (pinH - 24) / Math.max(1, pn.inner.scrollHeight)) : 1;
      if(reduced) pn.inner.style.transform = pn.fit < 1 ? "scale(" + pn.fit.toFixed(3) + ")" : "";
    });
  }
  fitPins();
  on(window, "resize", fitPins, {passive:true});
  setTimeout(jeOwned(fitPins), 600);
  function chapterProgress(outer){
    var r = outer.getBoundingClientRect();
    var total = r.height - window.innerHeight;
    if(total <= 0) return 1;
    return Math.min(1, Math.max(0, -r.top / total));
  }
  function frame(t){
    if(!rafAlive) return;
    /* je-perf-motion-20260829: ONE rect per pin per frame, read pass then write pass.

       Before this each iteration called nearViewport(pn.outer) and then
       chapterProgress(pn.outer) -- two getBoundingClientRect on the SAME
       element -- and then wrote inner.style.opacity and inner.style.transform,
       so the NEXT iteration's read had to flush this iteration's write: a
       forced synchronous layout per pin per frame, forever, on 255 pages.
       The opacity write was unconditional and always the literal "1", i.e. it
       invalidated style every frame to set a value that never changed.

       The transform string is byte-for-byte the one the old line built. */
    var jeVh = window.innerHeight, i, pn;
    var jeSt = jeServiceScroll();                           /* ---- READ ---- */
    for(i = 0; i < pins.length; i++){
      pn = pins[i];
      var r = pn.outer.getBoundingClientRect();
      pn.jeLive = !(r.bottom <= -200 || r.top >= jeVh + 200);
      if(!pn.jeLive) continue;
      var total = r.height - jeVh;
      pn.jePr = pn.flow || total <= 0 ? 1 : Math.min(1, Math.max(0, -r.top / total));
    }
    if(jeSt) jeWriteScroll(jeSt);                           /* ---- WRITE ---- */
    for(i = 0; i < pins.length; i++){
      pn = pins[i];
      if(!pn.jeLive) continue;
      var pr = pn.jePr;
      var enter = Math.min(1, pr/0.12), exit = Math.min(1, (1-pr)/0.12);
      var vis = Math.min(enter, exit);
      /* Keep chapter copy fully opaque throughout the scroll scrub.  Fading
         the wrapper made otherwise accessible text unreadable at entry/exit.
         Written ONCE per pin now instead of once per frame - same value. */
      if(!pn.jeOpaque){ pn.jeOpaque = 1; pn.inner.style.opacity = "1"; }
      var tf = "translateY(" + ((1-enter)*46 - (1-exit)*46).toFixed(1) +
        "px) scale(" + ((0.94 + vis*0.06) * pn.fit).toFixed(4) + ")";
      if(tf !== pn.jeTf){ pn.jeTf = tf; pn.inner.style.transform = tf; }
      if(pn.counterEl){
        /* je-audit-regressions-20260906: TIME-based, not scroll-scrubbed - the figure used to reach its true value
           only ~62% through the pin, so a reader who stopped early saw "8kg" on a 10 kg drum. The count
           starts the first live frame 2% into the pin and eases to the target over 900 ms, then holds. */
        var tn = (typeof t === "number") ? t : performance.now();
        if(!pn.counterT0 && pr > 0.02) pn.counterT0 = tn;
        var e = pn.counterT0 ? 1 - Math.pow(1 - Math.min(1, (tn - pn.counterT0) / 900), 3) : 0;
        var v = Math.round(pn.counterTarget * e);
        if(v !== pn.lastVal){
          pn.lastVal = v;
          pn.counterEl.innerHTML = v.toLocaleString("en-GB") +
            (pn.counterSuffix ? "<small>" + esc(pn.counterSuffix) + "</small>" : "");
        }
      }
      if(pn.fx) pn.fx.draw(t);
    }
    /* the page canvas is NOT gated on nearViewport — it IS the viewport */
    if(pageFX && !document.hidden){ pageFX.tick(t); }
    requestAnimationFrame(frame);
  }
  if(!reduced && (pins.length || pageFX)){
    rafAlive = true;
    cleanup.push(function(){ rafAlive = false; });
    requestAnimationFrame(frame);
  } else {
    pins.forEach(function(pn){
      if(pn.counterEl) pn.counterEl.innerHTML = pn.counterTarget.toLocaleString("en-GB") +
        (pn.counterSuffix ? "<small>" + esc(pn.counterSuffix) + "</small>" : "");
      pn.inner.style.opacity = 1;
      if(pn.fx) pn.fx.draw(0);
    });
    if(pageFX) pageFX.tick(0);   // reduced motion: one still frame, then stop
  }

  /* closer-look tabs */
  jeInitCloserTabs(app);

  /* card tilt — service cards only.  je-highlights-deck-20260901: the hcards
     left this handler with the rail; it writes an INLINE transform, which
     beats any stylesheet rule and would overwrite the deck's --d geometry
     mid-drag. */
  if(!reduced && window.matchMedia("(pointer:fine)").matches){
    els(".svc", app).forEach(function(card){
      card.addEventListener("pointermove", function(ev){
        var r = card.getBoundingClientRect();
        var rx = ((ev.clientY - r.top)/r.height - .5) * -5;
        var ry = ((ev.clientX - r.left)/r.width - .5) * 5;
        card.style.transform = "perspective(700px) rotateX(" + rx + "deg) rotateY(" + ry + "deg) translateY(-4px)";
      });
      card.addEventListener("pointerleave", function(){ card.style.transform = ""; });
    });
  }

  /* buy sheet — never enable a choice until Shopify's live variants hydrate */
  var sheetWrap = el("#sheetWrap"), sheet = el("#sheet");
  var sheetOpeners = els(".sheet-open", app);
  var sheetPending = false;
  var sheetTrigger = null, sheetCloseTimer = null, sheetActive = false, bagUpdateRevision = 0;
  var chosenRung = null, liveRungsById = {};
  /* je-tour-express-20261008: the server already rendered the price and the stock line from the same
     variant data (window.JE_TOUR_PURCHASABLE), so the buy controls start READY when it said
     purchasable — the sheet opens with its existing "Checking live options…" state and the
     live payload still corrects everything (setOpenersReady / applyLane / the rung re-render).
     Not purchasable: the old disabled+busy start, hydrate settles it. */
  sheetOpeners.forEach(function(b){
    if(window.JE_TOUR_PURCHASABLE === true) return;
    b.disabled = true; b.setAttribute("aria-busy", "true");
  });

  function fallbackToStandardPdp(){
    var fallback = "/products/" + encodeURIComponent(p.handle) + "?view=default";
    window.location.replace(fallback);
  }
  function setOpenersReady(ready){
    sheetOpeners.forEach(function(b){
      b.disabled = !ready;
      if(ready) b.removeAttribute("aria-busy");
      else b.setAttribute("aria-busy", "true");
    });
  }
  function setSubmissionPending(pending){
    sheetPending = pending;
    sheet.classList.toggle("pending", pending);
    sheet.setAttribute("aria-busy", pending ? "true" : "false");
    var pendingNote = el(".sheet-pending", sheet);
    if(pendingNote) pendingNote.textContent = pending ? "Adding your selected option…" : "";
    els(".rung", sheet).forEach(function(r){
      r.disabled = pending || r.getAttribute("data-live-available") !== "true";
      if(pending) r.setAttribute("aria-busy", "true"); else r.removeAttribute("aria-busy");
    });
    setOpenersReady(!pending);
  }
  function setStickySelection(variant){
    chosenRung = variant || null;
    if(!pdpbar) return;
    var selection = el(".pselection", pdpbar);
    var price = el(".price-now", pdpbar);
    if(!selection || !price) return;
    if(!chosenRung){ selection.textContent = ""; return; }
    selection.textContent = String(chosenRung.title || "Selected option");
    price.textContent = money(Number(chosenRung.price) / 100);
    var was = el('.price-was-bar', pdpbar);
    if(was) was.hidden = String(chosenRung.price) !== pdpbar.getAttribute('data-anchor-price');
    pdpbar.setAttribute("data-selected-variant", String(chosenRung.id));
  }
  /* je-simgym-bag-20260906: additions are confirmed by Shopify; the header
     consumes an absolute cart count via Horizon's existing cart:update event.
     A failed count refresh must never turn a successful add into a second POST. */
  function refreshBagCount(id, revision){
    return fetch("/cart.js", {headers: {"Accept": "application/json"}, cache: "no-store"})
      .then(function(resp){ if(!resp.ok) throw new Error("cart read"); return resp.json(); })
      .then(function(cart){
        if(revision !== bagUpdateRevision) return;
        if(typeof cart.item_count !== "number" || !isFinite(cart.item_count) || cart.item_count < 0){
          throw new Error("invalid cart count");
        }
        document.dispatchEvent(new CustomEvent("cart:update", {bubbles: true, detail: {
          resource: cart, sourceId: "je-tour", data: {
            source: "je-tour", itemCount: cart.item_count, variantId: String(id)
          }
        }}));
        els("[data-cart-count]", document).forEach(function(count){
          var link = count.closest("a");
          if(link && link.hasAttribute("aria-label")){
            link.setAttribute("aria-label", "Cart, " + cart.item_count + (cart.item_count === 1 ? " item" : " items"));
          }
        });
      }).catch(function(){ /* The confirmed addition and View Bag link remain usable. */ });
  }
  function showBagError(rejected){
    setSubmissionPending(false);
    var box = el(".sheet-error", sheet);
    el("p", box).textContent = rejected
      ? "This option could not be added. Please check your bag before trying again."
      : "We could not confirm the addition. Please check your bag before trying again.";
    box.hidden = false;
    if(sheetActive) el("a", box).focus({preventScroll:true});
  }
  function openSheet(event){
    if(sheetPending || !event || !event.currentTarget || event.currentTarget.disabled) return;
    sheetTrigger = event.currentTarget;
    sheetActive = true;
    clearTimeout(sheetCloseTimer);
    var checkout = event.currentTarget.hasAttribute("data-checkout-intent");
    sheet.setAttribute("data-checkout-intent", checkout ? "checkout" : "bag");
    sheet.classList.remove("done");
    sheet.classList.toggle("checkout-intent", checkout);
    sheetWrap.setAttribute("aria-label", checkout ? "Choose an option, then go to checkout" : "Choose an option to add to bag");
    el(".sheet-step", sheet).textContent = checkout ? "Choose an option below to continue to checkout." : "Choose an option below to add to your bag.";
    els(".rung-action", sheet).forEach(function(label){ label.textContent = checkout ? "Add & checkout" : "Add to bag"; });
    /* Keep any previous error visible until a new choice is submitted. */
    sheetWrap.classList.add("open");
    requestAnimationFrame(function(){ requestAnimationFrame(function(){
      if(!sheetActive) return;
      sheetWrap.classList.add("in");
      var choice = el(".rung:not(:disabled)", sheet);
      if(choice) choice.focus({preventScroll:true});
    }); });
  }
  function closeSheet(){
    if(!sheetActive) return;
    sheetActive = false;
    sheetWrap.classList.remove("in");
    sheetCloseTimer = setTimeout(function(){ sheetWrap.classList.remove("open"); }, 350);
    var returnFocus = sheetTrigger;
    if(!returnFocus || returnFocus.disabled || !document.contains(returnFocus)){
      returnFocus = els('a[href="/cart"]', document).filter(function(link){ return link.getClientRects().length; })[0];
    }
    if(returnFocus) returnFocus.focus({preventScroll:true});
  }
  sheetOpeners.forEach(function(b){ b.addEventListener("click", openSheet); });
  el(".close", sheet).addEventListener("click", closeSheet);
  el(".scrim", sheetWrap).addEventListener("click", closeSheet);
  el(".sheet-close-btn", sheet).addEventListener("click", closeSheet);
  on(document, "keydown", function(e){
    if(e.key === "Escape"){ closeSheet(); if(jumpwrap) jumpwrap.classList.remove("open"); }
    if(e.key === "Tab" && sheetWrap.classList.contains("in")){
      var stops = els('button:not(:disabled),a[href]', sheet).filter(function(node){ return node.getClientRects().length; });
      if(!stops.length) return;
      var first = stops[0], last = stops[stops.length - 1];
      if(e.shiftKey && (document.activeElement === first || !sheet.contains(document.activeElement))){ e.preventDefault(); last.focus(); }
      else if(!e.shiftKey && (document.activeElement === last || !sheet.contains(document.activeElement))){ e.preventDefault(); first.focus(); }
    }
  });

  function bindLiveRungs(){
    els(".rung", sheet).forEach(function(r){
      r.addEventListener("click", function(){
        if(sheetPending || r.disabled || r.getAttribute("data-live-available") !== "true") return;
        var id = parseInt(r.getAttribute("data-variant"), 10);
        if(!isFinite(id)){ fallbackToStandardPdp(); return; }
        var selected = liveRungsById[String(id)];
        if(!selected){ fallbackToStandardPdp(); return; }
        var submissionIntent = sheet.getAttribute("data-checkout-intent") === "checkout";
        /* Keep the live selection visible while the guarded request is in
           flight.  The state survives a close/reopen until navigation. */
        setStickySelection(selected);
        var requestRevision = ++bagUpdateRevision;
        el(".sheet-error", sheet).hidden = true;
        setSubmissionPending(true);
        fetch("/cart/add.js", {
          method: "POST",
          headers: {"Content-Type": "application/json", "Accept": "application/json"},
          body: JSON.stringify({items: [{id: id, quantity: 1}]})
        }).then(function(resp){
          if(!resp.ok){ var error = new Error("cart " + resp.status); error.cartRejected = resp.status >= 400 && resp.status < 500; throw error; }
          return resp.json();
        }).then(function(){
          if(submissionIntent && sheetActive){ window.location.assign("/checkout"); return; }
          sheet.classList.add("done");
          setSubmissionPending(false);
          if(sheetActive) el(".state a", sheet).focus({preventScroll:true});
          refreshBagCount(id, requestRevision);
        }).catch(function(error){ showBagError(!!error.cartRejected); refreshBagCount(id, requestRevision); });
      });
    });
  }

  /* LIVE price/availability hydration — this is the sole source of actionable rungs */
  fetch("/products/" + encodeURIComponent(p.handle) + ".js").then(function(r){
    if(!r.ok) throw new Error("pjs " + r.status);
    return r.json();
  }).then(function(live){
    var variants = Array.isArray(live.variants) ? live.variants : [];
    if(!variants.length) throw new Error("no live variants");
    var actionVariants = MANUAL_OOS ? variants.map(function(v){
      return {id: v.id, title: v.title, price: v.price, available: false};
    }) : variants;
    var available = actionVariants.filter(function(v){ return !!v.available; });
    var priceSource = available.length ? available : variants;
    var anchor = priceSource.reduce(function(a, b){ return a.price <= b.price ? a : b; });
    var now = anchor.price / 100, was = anchor.compare_at_price ? anchor.compare_at_price / 100 : null;
    if(pdpbar) pdpbar.setAttribute('data-anchor-price', String(anchor.price));
    els(".price-now", app).forEach(function(n){ n.textContent = money(now); });
    els(".price-was", app).forEach(function(n){
      if(was && was > now){ n.innerHTML = "<s>Was " + money(was) + "</s>"; }
      else n.remove();
    });
    /* je-pdpbar-was-hydrate-20260901: the sticky bars' compact strikethrough -
       same anchor, same rule (update or remove, never create), figure only. */
    els(".price-was-bar", app).forEach(function(n){
      if(was && was > now){ n.textContent = money(was); } else n.remove();
    });
    els(".price-save", app).forEach(function(n){
      if(was && was > now){ n.textContent = "Save " + money(was - now); } else n.remove();
    });
    var rungs = el(".rungs", sheet);
    liveRungsById = {};
    actionVariants.forEach(function(v){ liveRungsById[String(v.id)] = v; });
    rungs.innerHTML = liveRungsHTML(actionVariants, anchor.price);
    bindLiveRungs();
    /* je-svc-options-20260827: the service card quotes real prices, so it has to
       come from this payload too. It was rendered from the frozen asset and
       nothing here ever touched it — a day-old bind could therefore advertise a
       rung at yesterday's figure while the price row beside it showed today's.
       Re-rendered against the SAME anchor as the price row and the buy sheet.
       If the live product no longer sells a paid rung the card is removed
       outright rather than left showing an option that cannot be bought. */
    var svcBody = el("#svc-options .svc-opt-body", app);
    if(svcBody){
      var svcHTML = serviceOptionsBlock(actionVariants, anchor.price, "minor");
      if(svcHTML){ svcBody.innerHTML = svcHTML; }
      else {
        var svcCard = el("#svc-options", app);
        if(svcCard && svcCard.parentNode) svcCard.parentNode.removeChild(svcCard);
      }
    }
    /* je-pdp-truth-20260901: the live payload's tags are the evidence the theme's
       availability lane reads, so the rendered lane is re-checked against them
       here. An unpurchasable product is out of stock whatever the tags say. */
    applyLane(liveLane(live, available.length > 0) || (available.length ? LANE : "oos"));
    applyKlarna(available.length ? anchor.price : 0);
    applySpi(available.length ? anchor : null); /* je-spi-promo-20260904: same evidence, same moment */
    applyExpress(available.length ? anchor : null, false); /* je-tour-express-20261008: same evidence, same moment */
    if(available.length){
      setOpenersReady(true);
    } else {
      setOpenersReady(false);
      sheetOpeners.forEach(function(b){
        b.removeAttribute("aria-busy");
        b.textContent = "Unavailable";
      });
    }
  }).catch(fallbackToStandardPdp);

}

/* ================= WHOLE-PAGE FX (PDP) =================
   je-tour-pagefx-20260827 — Will 2026-08-27: "on the product pages the background
   effect should fade in and out of the WHOLE page not just some of it."

   It used to be three canvases, one per pinned chapter, each inside its own
   .pin — so on this Beko PDP the effect covered 4,104px of an 11,967px page
   (34%) and stopped dead at every chapter edge: nothing on the hero, the
   highlights, the photo beat, the specs, the service block, the warranty, the
   gallery or the CTA.  Now ONE position:fixed canvas sits behind the ENTIRE
   page and the chapters emit no canvas of their own (see renderTour), so there
   is exactly one effect layer at exactly one density.

   It is the SAME makeFX the chapters used, with the product's own dna.module
   and palette — not a second implementation.  A chapter canvas was already
   viewport-sized (100vh sticky), so the particle density is unchanged; the
   effect simply no longer ends where a chapter ends.

   BEHIND the page at z -1, like je-bg-fx.js and for the same reason: every
   white card, dark panel and product photo covers it, so nothing is ever drawn
   over a photo or a line of copy.  That needs the shells that paint their own
   black to go see-through — the tour root and the three solid-black sections
   lose their background-COLOUR, and the three gradient sections keep the SHAPE
   of their gradient at a low alpha so they still read as bands.  <body> stays
   black underneath, so with JS blocked the page looks exactly as it does today.

   The fade is a scroll envelope, not a section edge: it comes up out of the
   hero (which owns its own aurora composition) over the first three-quarters
   of a screen, holds through the page, and eases back down over the last
   screen into the CTA.

   je-bg-fx.js has no product.* key so the two can never both mount, and each
   now checks for the other's canvas id anyway. */
function mountPageFX(module){
  if(MODE !== "pdp") return null;                       // showcase hub keeps per-chapter canvases
  if(document.getElementById("je-tour-bg")) return null; // already mounted
  if(document.getElementById("je-bgfx")) return null;    // the site-wide layer claimed this template
  var main = document.querySelector("main[data-template]");
  var tpl = main ? (main.getAttribute("data-template") || "") : "";
  if(tpl.indexOf("product.") !== 0) return null;

  var S = 'html body main#MainContent[data-template="' + tpl + '"]';
  var style = document.createElement("style");
  style.id = "je-tour-bg-css";
  style.textContent =
    "#je-tour-bg{position:fixed;inset:0;width:100%;height:100%;z-index:-1;pointer-events:none;opacity:.25}" +
    /* je-bgfx-viewport-stable-20260903: same reason as #je-bgfx - a height:100% fixed layer can
       fall short of the visible viewport while the phone's URL bar is moving,
       and the strip it misses reads as a black bar. */
    "@supports (height:100lvh){#je-tour-bg{height:100lvh;bottom:auto}}" +
    "@media print{#je-tour-bg{display:none}}" +
    S + "," + S + " .je-tour-root," +
    S + " #closer," + S + " #warranty," + S + " #photos{background-color:transparent !important}" +
    /* keep the shape of these three bands, at an alpha the lights read through */
    /* je-transparent-bars-20260903: Will - "they are like transparent black bars".  These three
       bands were kept by je-tour-pagefx-20260827 "at an alpha the lights read through"
       (0.55 / 0.55 / 0.75 over 993 / 1193 / 867 px).  With an ambient field behind the
       whole page they read as exactly what he called them, so the ink comes off.  The
       declarations stay so the revert is these strings going back and nothing moves. */
    S + " #specs{background-image:none !important}" +
    S + " #service{background-image:none !important}" +
    S + " #cta{background-image:none !important}";
  var cv = document.createElement("canvas");
  cv.id = "je-tour-bg";
  cv.setAttribute("aria-hidden", "true");
  cv.setAttribute("data-module", module);
  /* je-tour-fallback-transaction-20261015: the teardown is registered BEFORE the layer is in
     the page and before makeFX can throw, so a failed init never leaves the canvas or its
     stylesheet behind the restored fallback. */
  cleanup.push(function(){
    if(cv.parentNode) cv.parentNode.removeChild(cv);
    if(style.parentNode) style.parentNode.removeChild(style);
  });
  document.head.appendChild(style);
  document.body.appendChild(cv);

  var fx = makeFX(cv, module);
  var last = -1;
  /* je-perf-motion-20260829: documentElement.scrollHeight is a LAYOUT read, and this ran
     on every scroll event AND again from the rAF on every frame -- so on a page
     whose style was already dirty it forced a synchronous layout ~60 times a
     second for a number that only changes when the document does.  It is now
     read at most every 500ms, and immediately on resize / load / a font swap.
     The curve, the 0.02 write threshold and the 0.25..1.0 range are unchanged. */
  var jeDocH = 0, jeDocHAt = -1e9;
  function jeDocHeight(now, force){
    if(force || now - jeDocHAt > 500){
      jeDocHAt = now;
      jeDocH = document.documentElement.scrollHeight;
    }
    return jeDocH;
  }
  function applyOpacity(force){
    /* je-bgfx-viewport-stable-20260903: the canvas box (100lvh), not the chrome-dependent
       innerHeight.  This ramp is the whole layer's brightness, and on a phone it
       re-ran on every URL-bar slide - measured 0.73 -> 0.78 on one toggle at
       y=400, i.e. the background visibly pulsed on a change of scroll direction. */
    var vh = cv.clientHeight || window.innerHeight || 1;
    var y = window.scrollY || window.pageYOffset || 0;
    var docH = Math.max(jeDocHeight(Date.now(), force === true || jeDocHAt < 0), vh);
    var up = Math.min(1, y / (vh * 0.75));                    // out of the hero
    var down = Math.min(1, Math.max(0, docH - (y + vh)) / vh); // back down into the CTA
    var o = 0.25 + 0.75 * Math.max(0, Math.min(up, down));
    if(Math.abs(o - last) > 0.02){ cv.style.opacity = o.toFixed(2); last = o; }
  }
  on(window, "resize", function(){ applyOpacity(true); }, {passive:true});
  on(window, "load", function(){ applyOpacity(true); });
  if(document.fonts && document.fonts.ready) document.fonts.ready.then(jeOwned(function(){ applyOpacity(true); }));
  applyOpacity();
  on(window, "scroll", applyOpacity, {passive:true});
  on(window, "resize", applyOpacity, {passive:true});
  return { tick: function(t){ applyOpacity(); fx.draw(t); } };
}

/* ================= CANVAS FX ================= */
function makeFX(cv, module){
  var ctx = cv.getContext("2d");
  var W = 0, H = 0, lastDpr = 0, parts = [];
  var waveT = 0;
  function size(){
    var dpr = Math.min(2, window.devicePixelRatio || 1);
    var w = cv.clientWidth, h = cv.clientHeight;
    if(w === W && h === H && dpr === lastDpr) return;
    W = w; H = h; lastDpr = dpr;
    cv.width = W * dpr; cv.height = H * dpr;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    spawn();
  }
  function pal(){
    var cs = getComputedStyle(document.documentElement);
    return [cs.getPropertyValue("--pa").trim() || "#2997ff",
            cs.getPropertyValue("--pb").trim() || "#bf5af2",
            cs.getPropertyValue("--pc").trim() || "#ffd60a"];
  }
  function rnd(a, b){ return a + Math.random() * (b - a); }
  function spawn(){
    parts = [];
    var n = Math.floor(W * H / (module === "pixels" ? 2600 : 5200));
    n = Math.max(30, Math.min(700, n));
    var colors = pal();
    for(var i = 0; i < n; i++){
      parts.push({
        x: rnd(0, W), y: rnd(0, H), r: rnd(0.5, 2.2),
        ph: rnd(0, 6.283), sp: rnd(0.4, 1.8),
        c: colors[i % 3], drift: rnd(-0.4, 0.4)
      });
    }
  }
  size();
  window.addEventListener("resize", size);
  cleanup.push(function(){ window.removeEventListener("resize", size); });

  function draw(t){
    if(W === 0) size();
    ctx.clearRect(0, 0, W, H);
    waveT += 0.004;
    var i, s, a, y, x;
    switch(module){
      case "pixels": {
        var waveX = (Math.sin(waveT) * 0.5 + 0.5) * W;
        for(i = 0; i < parts.length; i++){
          s = parts[i];
          var off = Math.max(0, 1 - Math.abs(s.x - waveX) / (W * 0.16));
          a = (0.35 + 0.65 * Math.abs(Math.sin(t * 0.001 * s.sp + s.ph))) * (1 - off);
          if(a < 0.02) continue;
          dot(s.x, s.y, s.r, s.c, a);
        }
        break;
      }
      case "drum": case "steam": {  // bubbles / droplets rising
        for(i = 0; i < parts.length; i++){
          s = parts[i];
          y = (s.y - t * 0.02 * s.sp) % H; if(y < 0) y += H;
          x = s.x + Math.sin(t * 0.001 * s.sp + s.ph) * 14;
          a = 0.15 + 0.4 * Math.abs(Math.sin(t * 0.0008 * s.sp + s.ph));
          ring(x, y, s.r * 2.4, s.c, a);
        }
        break;
      }
      case "frost": {  // flakes falling, slow drift
        for(i = 0; i < parts.length; i++){
          s = parts[i];
          y = (s.y + t * 0.012 * s.sp) % H;
          x = s.x + Math.sin(t * 0.0006 * s.sp + s.ph) * 18;
          a = 0.25 + 0.5 * Math.abs(Math.sin(t * 0.0007 + s.ph));
          dot(x, y, s.r, s.c, a);
        }
        break;
      }
      case "flame": case "ember": {  // sparks rising, flicker
        var speed = module === "flame" ? 0.05 : 0.02;
        for(i = 0; i < parts.length; i++){
          s = parts[i];
          y = (s.y - t * speed * s.sp) % H; if(y < 0) y += H;
          x = s.x + Math.sin(t * 0.002 * s.sp + s.ph) * 8;
          a = (0.2 + 0.6 * Math.abs(Math.sin(t * 0.003 * s.sp + s.ph))) * (y / H);
          dot(x, y, s.r, s.c, a);
        }
        break;
      }
      case "vortex": {  // spiral pulled toward a slow-moving focus
        var fx = W * (0.5 + 0.22 * Math.sin(waveT * 0.7));
        var fy = H * (0.55 + 0.14 * Math.cos(waveT * 0.9));
        for(i = 0; i < parts.length; i++){
          s = parts[i];
          var ang = t * 0.0012 * s.sp + s.ph;
          var rad = 30 + ((s.ph * 57 + t * 0.03 * s.sp) % (Math.max(W, H) * 0.5));
          rad = Math.max(W, H) * 0.5 - rad % (Math.max(W, H) * 0.5);
          x = fx + Math.cos(ang) * rad; y = fy + Math.sin(ang) * rad * 0.6;
          a = 0.1 + 0.5 * (1 - rad / (Math.max(W, H) * 0.5));
          dot(x, y, s.r, s.c, a);
        }
        break;
      }
      case "micro": {  // expanding rings from centre
        var cx = W / 2, cy = H / 2;
        for(i = 0; i < 6; i++){
          var age = ((t * 0.00022 + i / 6) % 1);
          ring(cx, cy, age * Math.max(W, H) * 0.55, pal()[i % 3], (1 - age) * 0.35);
        }
        break;
      }
      case "wave": {  // sine ribbons
        var colors2 = pal();
        for(var k = 0; k < 3; k++){
          ctx.beginPath();
          for(x = 0; x <= W; x += 8){
            y = H / 2 + Math.sin(x * 0.008 + t * 0.0012 + k * 2.1) * (26 + k * 18)
              + Math.sin(x * 0.02 - t * 0.0007 + k) * 8;
            if(x === 0) ctx.moveTo(x, y); else ctx.lineTo(x, y);
          }
          ctx.strokeStyle = colors2[k]; ctx.globalAlpha = 0.35 - k * 0.08;
          ctx.lineWidth = 2; ctx.stroke(); ctx.globalAlpha = 1;
        }
        break;
      }
      case "brew": {  // wisps rising with sway
        for(i = 0; i < parts.length; i++){
          s = parts[i];
          y = (s.y - t * 0.015 * s.sp) % H; if(y < 0) y += H;
          x = s.x + Math.sin(y * 0.02 + s.ph) * 22;
          a = 0.12 + 0.3 * Math.abs(Math.sin(t * 0.0009 + s.ph)) * (1 - y / H);
          dot(x, y, s.r * 1.6, s.c, a);
        }
        break;
      }
      case "breeze": {  // horizontal streaks
        for(i = 0; i < parts.length; i++){
          s = parts[i];
          x = (s.x + t * 0.08 * s.sp) % (W + 120) - 60;
          y = s.y + Math.sin(t * 0.0008 + s.ph) * 6;
          ctx.strokeStyle = s.c; ctx.globalAlpha = 0.18 + 0.2 * Math.abs(Math.sin(s.ph + t * 0.001));
          ctx.lineWidth = 1.4; ctx.beginPath();
          ctx.moveTo(x, y); ctx.lineTo(x + 40 + s.sp * 30, y); ctx.stroke(); ctx.globalAlpha = 1;
        }
        break;
      }
      default: {  // glow dust
        for(i = 0; i < parts.length; i++){
          s = parts[i];
          x = s.x + Math.sin(t * 0.0004 * s.sp + s.ph) * 24;
          y = s.y + Math.cos(t * 0.0005 * s.sp + s.ph) * 18;
          a = 0.1 + 0.3 * Math.abs(Math.sin(t * 0.0008 + s.ph));
          dot(x, y, s.r, s.c, a);
        }
      }
    }
  }
  function dot(x, y, r, c, a){
    ctx.beginPath(); ctx.globalAlpha = Math.max(0, Math.min(1, a));
    ctx.fillStyle = c; ctx.arc(x, y, r, 0, 6.2832); ctx.fill(); ctx.globalAlpha = 1;
  }
  function ring(x, y, r, c, a){
    if(r <= 0) return;
    ctx.beginPath(); ctx.globalAlpha = Math.max(0, Math.min(1, a));
    ctx.strokeStyle = c; ctx.lineWidth = 1.4; ctx.arc(x, y, r, 0, 6.2832); ctx.stroke(); ctx.globalAlpha = 1;
  }
  return {draw: draw};
}
})();
